import * as React from "react";
import type { SVGProps } from "react";
const SvgMexico = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1280 720"
    {...props}
  >
    <defs>
      <radialGradient
        id="Mexico_svg__radial-gradient"
        cx={863.66}
        cy={2550.99}
        r={23.26}
        gradientTransform="matrix(.29 .12 .12 -.3 23.4 1033.53)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={1} stopColor="#f15770" />
      </radialGradient>
      <radialGradient
        xlinkHref="#Mexico_svg__radial-gradient"
        id="Mexico_svg__radial-gradient-2"
        cx={1434.73}
        cy={-511.7}
        r={23.27}
        gradientTransform="matrix(-.03 -.32 -.29 .03 428.18 829.13)"
      />
      <radialGradient
        xlinkHref="#Mexico_svg__radial-gradient"
        id="Mexico_svg__radial-gradient-3"
        cx={-691.17}
        cy={1863.39}
        r={23.27}
        gradientTransform="matrix(.11 .13 .25 -.21 340.51 884.73)"
      />
      <style>
        {
          ".Mexico_svg__cls-1{fill:#fff}.Mexico_svg__cls-4{fill:#a8ac71}.Mexico_svg__cls-6{fill:#78732e}.Mexico_svg__cls-9{fill:#f8c83c}.Mexico_svg__cls-10{fill:#977c2e}.Mexico_svg__cls-11{fill:#af7029}.Mexico_svg__cls-12{fill:#816c2a}.Mexico_svg__cls-13{fill:#fcca3d}.Mexico_svg__cls-16{fill:#fcca3e}.Mexico_svg__cls-17{fill:#aa8c30}.Mexico_svg__cls-18{fill:#9ca168}.Mexico_svg__cls-19{fill:#717732}.Mexico_svg__cls-20{fill:#016848}.Mexico_svg__cls-21{fill:#cd202a}.Mexico_svg__cls-23{fill:#0872a7}.Mexico_svg__cls-24{fill:#f9aa51}.Mexico_svg__cls-25{fill:#953220}.Mexico_svg__cls-26{fill:#231f20}.Mexico_svg__cls-27{fill:#8cbebf}.Mexico_svg__cls-28{fill:#04534e}.Mexico_svg__cls-29{fill:#0c8489}.Mexico_svg__cls-33{fill:#e92736}.Mexico_svg__cls-34{fill:#f7e204}.Mexico_svg__cls-35{fill:#904720}.Mexico_svg__cls-36{fill:#ab6d29}.Mexico_svg__cls-37{fill:#4d2a15}.Mexico_svg__cls-38{fill:#d2a567}.Mexico_svg__cls-39{fill:#8f4620}.Mexico_svg__cls-40{fill:#202020}.Mexico_svg__cls-41{fill:#202220}.Mexico_svg__cls-42{fill:#4b4139}.Mexico_svg__cls-43{fill:#803f1d}.Mexico_svg__cls-45{fill:#5c3a1d}.Mexico_svg__cls-46{fill:#8b441f}.Mexico_svg__cls-48{fill:#1e2121}.Mexico_svg__cls-49{fill:#5c3818}.Mexico_svg__cls-52{fill:#dbad6c}.Mexico_svg__cls-54{fill:#b27129}.Mexico_svg__cls-58{fill:#6c4119}.Mexico_svg__cls-60{fill:#f9c83a}"
        }
      </style>
    </defs>
    <g id="Mexico_svg__Mexico">
      <path
        id="Mexico_svg__rect3678"
        d="M.28.16h1279.41v719.68H.28z"
        className="Mexico_svg__cls-1"
      />
      <path
        id="Mexico_svg__rect4649"
        d="M.28.16h426.47v719.68H.28z"
        style={{
          fill: "#006847",
        }}
      />
      <path
        id="Mexico_svg__rect4651"
        d="M853.25.16h426.47v719.68H853.25z"
        style={{
          fill: "#ce1126",
        }}
      />
      <path
        id="Mexico_svg__path21"
        d="M571.71 277.87s-7.53.64-12.77-.26-4.09-14.26-4.22-14.65-3.19-3.63-2.68-6.6 10.19-10.85 11.5-11.28c.89-.29 2.81.52 2.81.52s2.44-2.38 3.17-2.38 1.78 1.38 1.49 2-3.61 2.53-3.86 4 0 3-.93 4.43-2.81 3.44-3 4.67-.77 2.3.16 2.75 4.09.07 6.8-1.16 3.83-2.89 4.21-2.72-1.56 3.4-4.56 4.66-5 2.72-6.49 2.5c0 0-1.66 4 3.49 4.21a18.1 18.1 0 0 0 8-1.14l-3.07 10.47Z"
        className="Mexico_svg__cls-4"
      />
      <path
        id="Mexico_svg__path23"
        d="M542.27 309.29a6.56 6.56 0 0 1 4 6c0 4.4-4.34 8.09-4.21 15.87s1.33 7.85 11.62 16.2a11.2 11.2 0 0 1 3.07 5c.57 2.52 2.42 17.43 12.33 17.36s11.24-6.34 11.24-6.34l-4.22-6.23s-3.45 1-5.3.59a6.79 6.79 0 0 1-4.6-4.08c-1.08-2.4-1.38-8.11-3.07-10.63-4.15-6.22-11.56-7.26-11.62-13.8s4.53-7.26 3.26-15-10.54-11.53-10.54-11.53l-3.77-1.52-1.31 7.81 3.16.38Z"
        className="Mexico_svg__cls-4"
      />
      <path
        id="Mexico_svg__path25"
        d="M569.54 254.88c3.32-.77 1.41-9.43 1.41-9.43l-2.3 1.91a7.3 7.3 0 0 1 1.42 3.84 13.8 13.8 0 0 1-.53 3.68"
        style={{
          fill: "#f1a720",
        }}
      />
      <path
        id="Mexico_svg__path27"
        d="M575.6 341.2s-1.54-1.26-1.69-1.37c-1.19-.79-6.39-5-5.55-17.47.94-14.13 21.48-21.56 22.81-27.17 1.49-6.22 6.14-8.94-10.21-21.73l-3.84 4.54 6.71 5s1.48-.84 1.57 1.07-1.79 3.53-2.25 5-10.62 8.45-11.39 9.14-5.86 4.65-5.86 4.65a28.6 28.6 0 0 0-5.12 8.1c-2.47 5.49-1.2 12.52-1.2 12.52s.08 15 16 17.72Z"
        className="Mexico_svg__cls-4"
      />
      <path
        id="Mexico_svg__path29"
        d="m565.59 349.11 1.15 5.31-3.26 1.2-1.41-.06-1 .45-2.52 2.43-.64-.2s-.38.14-.51-1.42-.35-2.92-.35-2.92l3.06 1.26 1.09.07.8-.23 1.34-2.91 2.3-2.95Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path31"
        d="M556.07 350.08s-1-1.23-1.53-2a7.2 7.2 0 0 0-1.79-1.69l2.23-1.25h2.4l-.35 2.88-1 2Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path33"
        d="M561.5 341.55a4.7 4.7 0 0 1 2 1.88 49 49 0 0 0 1.18 2.53l-3.8-.29-2.91-.91 1.89-2.63 1.66-.58Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path35"
        d="M560 365a3.46 3.46 0 0 1-1.22-1.71 24 24 0 0 1-.8-3.21l2.53-.48 3 1.19.84.07s-.71 1.49-.8 1.56-2.88 2.49-2.88 2.49z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path37"
        d="M570.09 356.91s-2.23-.7-2.59-1.75-.67-.9-.67-.9l-.7 3-.89 2.82s.19.48.29.48 2.13-.52 2.26-.58a24 24 0 0 0 1.73-1.78c0-.1.57-1.3.57-1.3Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path39"
        d="M560.7 366.37s1.12.62 2.68 1.53a5.7 5.7 0 0 0 2.49.9l1.18-1.26 1.22-2.4.16-.29-6 .55-1.69 1Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path41"
        d="m569.42 364 5.14-3.08.35-2.78-1-.78s.19.09-1.21.09h-1.76l-.94 3.45-.57 3.14Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path43"
        d="M565.75 368.9s3.6 1.55 9.83-.72c2.82-1 3.35-2.39 3.35-2.39l-2.49-1-2.36 2.1-8.33 2Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path45"
        d="M560.83 329s-.37-1.16-.72-2.68a9.3 9.3 0 0 1-.32-2.17l1.83.95 2.65 2-1.88 1.5-1.56.43Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path47"
        d="M565.16 336.31a15 15 0 0 1-1.66-2.07 23 23 0 0 1-1.3-2.25l1.95.4 2.27 1.1-1 2.93z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path49"
        d="M553.58 253.81c-.35 1.25-.81 3.54.93 4 1 .24 4.69-.07 8.94-4.92a7.9 7.9 0 0 0 2.09-4.63l.81-2.63s-1.66-1.21-4.34.48c-2.42 1.51-8.43 7.73-8.43 7.73Z"
        style={{
          fill: "#c6c7a6",
        }}
      />
      <ellipse
        id="Mexico_svg__ellipse51"
        cx={565.19}
        cy={247}
        rx={0.75}
        ry={0.8}
        style={{
          fill: "#1c242f",
        }}
      />
      <path
        id="Mexico_svg__path53"
        d="M559.78 247.8a35 35 0 0 0-3.51 3.24 14.4 14.4 0 0 0 5.15-2.89 6.82 6.82 0 0 1 5.16-1.32c.69.16.45-.74.13-1-.75-.59-2.83-.89-3.28-.54a39 39 0 0 0-3.65 2.51"
        className="Mexico_svg__cls-4"
      />
      <path
        id="Mexico_svg__path55"
        d="M568.42 327.46a17 17 0 0 1-.2-2.09 8.7 8.7 0 0 1 .08-2.23l-1.7 1.47-1.6 2.27 2.53.91.92-.33Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path57"
        d="M559.6 322.42a33 33 0 0 1-.1-4.51 51 51 0 0 1 1-6.21l1.07 2.74 3.1 4.83 1 .71-2.62 1.91-2.68.88-.78-.35Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path59"
        d="M568.48 321.2a19 19 0 0 1 .43-2.12 18 18 0 0 1 1-2.59s0 .16-.09.19-2.71 2.18-2.77 2.27-1.22 1.1-1.22 1.1l1.63 1.23 1-.06"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path61"
        d="M561.32 309.74a10.2 10.2 0 0 1 1.77-3.19c1.37-1.75 2.73-3.55 2.73-3.55l1.17 4.7.7 4 .12.84a4.3 4.3 0 0 1-1.34.39c-.38 0-3.25-.2-3.61-.68s-1.54-2.53-1.54-2.53Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path63"
        d="M570.63 315.21s.87-.93 1.64-1.64 2-2.09 2-2.09l-6.27 1.15.89 2.14 1.79.44Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path65"
        d="M566.82 302.16a8.6 8.6 0 0 0 2.28-1.92c1.69-1.72 2.55-1.51 2.55-1.51l.71 6.77-3.33-1-2.21-2.37Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__polygon67"
        d="m574.68 311.06 3.8-3.86-6.32-1.81 1.15 4.44z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path69"
        d="m577.34 300.87.38-6.55a15.6 15.6 0 0 0-2.92 2 20 20 0 0 1-2.38 1.8l.77 1.17 2.23 1.45 1.92.17Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path71"
        d="M583 294.52v-5.15l-.22.1a11.5 11.5 0 0 1-2 2.26 11.5 11.5 0 0 0-1.53 1.49l1.69 1.11 2 .19Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path73"
        d="M585.32 301.42s1.78-1.48 3.08-2.51a12.7 12.7 0 0 0 2.92-3.22l-8.17-.62.32 3.27z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__polygon75"
        d="m567.16 272.32-.85 2.03-.26 3.59 6.82-.04-1.67-2.29-2.08-1.3z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path77"
        d="M579.46 306.3a34 34 0 0 0 3-2.45 17 17 0 0 1 2.38-1.88l-6.48-.71.12 4.28 1 .76Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path79"
        d="M591.81 294.62a21 21 0 0 0 .63-5.11 13 13 0 0 0-.47-3.61l-4.86 3.31.7 2.46 1.86 2 2.14.94Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path81"
        d="M583.51 288.62a7.8 7.8 0 0 0 1.53-2.74c.1-1 .09-.69.09-.69l3.83.07 2.3.19.28.23-1.72 2-2.36 1.36-3 .36-.91-.82Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path83"
        d="M591.26 284.8s-1.5-2.57-2.35-4a8.5 8.5 0 0 0-1.67-2.1l-1.87 5.56-.19.54Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path85"
        d="m543.84 322.93-.74 1.55a11.4 11.4 0 0 1 4.54-1.26c2 .06 4.18 2.53 4.18 2.53l.48-1.79s-2.62-2.56-4.34-2.68-4.12 1.65-4.12 1.65m1.27-11.44s.55.65.67.84a5 5 0 0 1 2.78-3c2.59-1.1 4-.22 4-.22s-.51-1.5-1.65-1.82a4.06 4.06 0 0 0-3.68.91 7.4 7.4 0 0 0-2.11 3.31Zm8.78 8.61s-1.21-2.58-3.31-3.1-4.8 1.1-4.8 1.1l-.44 1.36s2.87-1.62 5-.78a5.85 5.85 0 0 1 2.94 3.24l.63-1.82Zm-9.86-10a3.6 3.6 0 0 0 .64 1s-.29-2.78 1-4.21a9.7 9.7 0 0 1 2.23-1.94l-1.18-.62a7.6 7.6 0 0 0-2.27 2.37 6.3 6.3 0 0 0-.41 3.37Zm-1.14-4.56a4.36 4.36 0 0 1 2.35-2 1.65 1.65 0 0 0-.57-.52.94.94 0 0 0-.82 0 4.54 4.54 0 0 0-1.81 2.14 10.4 10.4 0 0 0-.6 3.8l1 .59a11.4 11.4 0 0 1 .4-4Zm15.5-37.58a5 5 0 0 1 2.81-.69 5.81 5.81 0 0 0-1.24 5.65 20.1 20.1 0 0 0-1.78 4.62h1.27s.43-2.05.94-3.66a12.1 12.1 0 0 0 3.7 4.19l2-.09a13.7 13.7 0 0 1 1-4.88l.19.21a9.9 9.9 0 0 0 3.91 2.77v-.67a13.9 13.9 0 0 1-3.51-3l-.13-.19v-.07a8.25 8.25 0 0 1 3.58-3.2l1.36 1.13.34-.44-1-1.29h-1.18a39 39 0 0 0-3.48 3.31 18.3 18.3 0 0 1-1.55-3.08l-.88-.33s-2.12.25-4 3.31c-.23-2.25 2.36-4.7 2.36-4.7l-.12-.94s-2.63.49-4.67 1.1a6.76 6.76 0 0 0-3.29 2.53l-.08 1.38a15.9 15.9 0 0 1 3.46-3Zm2.81 4.15a10.3 10.3 0 0 1 3.83-2.85 6.4 6.4 0 0 0 1.52 3.25 16.3 16.3 0 0 0-1.44 4.43 15 15 0 0 1-3.83-3.88 3 3 0 0 1-.31-.59c.07-.12.15-.25.23-.36m-14.9 41.59.09 1.51a6 6 0 0 1 3.93-1.77 7.14 7.14 0 0 1 4.38 1.77s0-2-.29-2.22a8.9 8.9 0 0 0-4-1.31c-1.79 0-4.08 2-4.08 2Zm42.15-22.1a21 21 0 0 1-.92-2 4.1 4.1 0 0 0 1.05-.56 24 24 0 0 0 3.42-3.14l-.7-1.1h-3.19c-.63 0-2-.16-2.71-.26.14-.49.53-1.86 1-3.29a18 18 0 0 1 1.1-2.74l-1.09-1.1s.26 1-1.66 1.27-5.45-1.55-5.45-1.55v.78a42 42 0 0 0 4.9 1.25 3.42 3.42 0 0 0 2.38-.53 18 18 0 0 0-1 2.67 10 10 0 0 0-.54 1.77c0 .24.36.45.36.45l-.17 1.67s1.91.25 2.81.25 3.32.2 3.32.2a13 13 0 0 1-3.39 2.79 5 5 0 0 1-.69.25c-.08-.23-2-3.12-2-3.12l-.19 1.06a22 22 0 0 1 1.49 2.26 10.4 10.4 0 0 1-3-.26l-.77.84v4.88c-1.65-.45-3.51-1.12-3.51-1.12l-.68.52v-.12l-.88.7a22.1 22.1 0 0 0-.57 6.22v.17a9.63 9.63 0 0 1-4.74-2.63l-.77.65a18.5 18.5 0 0 0 .2 6.3 11.56 11.56 0 0 1-5-2.87l-1 .84s.6 5.58 1.23 8.62c.06.26.13.49.2.72a11 11 0 0 1-1.47.06 6.35 6.35 0 0 1-4.45-2.66l-.81 2s1 5.36 4 7.75l.68.54a11.8 11.8 0 0 1-5.64 2.42l.19 1.7s1.83 1.43 3.62 2.67c.18.11.37.23.56.33a9.4 9.4 0 0 1-3.17 1.79l.47 1.12s2.37-1.66 3.47-2.55a17 17 0 0 0 3.68.89v-.91a15 15 0 0 1-3-.59l.21-.19a32 32 0 0 0 2.64-3.54l.16-1.95a5.24 5.24 0 0 1-2.29-1.1c3.63-2.48 3.77-3.61 3.77-3.61l.68-1.28a4.92 4.92 0 0 1-2.13-2.3 44 44 0 0 0 5.75-1.42c.07-.2.43-.41.43-.41a18.2 18.2 0 0 1-2-5.07c2.86.74 5.78 1.22 5.78 1.22l.92-.79a26.5 26.5 0 0 1-.93-4.83c3.39.21 6.27.47 6.27.47l.58-.65s-1.92-3.66-1.85-5.74v-.19a8.5 8.5 0 0 0 1.91.19c2.81-.06 5.94 0 5.94 0l.48-1.07s-2.71-1.84-3.35-3Zm-20.67 30.48a21.4 21.4 0 0 1-2.77 4l-.44.47c-.32-.14-.64-.29-1-.47a6.07 6.07 0 0 1-2.72-2.64 53 53 0 0 0 4.85-3c1.93 1.54 2 1.69 2 1.69Zm1.7-6.18a43 43 0 0 1-3.8 3.73 8 8 0 0 1-.82-.9c-1.7-2.21-3.83-4.11-3.62-7.43a4.42 4.42 0 0 0 4.26 2.07c.6-.06 1.29-.16 2-.29a6.64 6.64 0 0 0 2 2.82Zm4-5a41 41 0 0 1-5.25 1.3c-.11-.26-.21-.53-.31-.85a33 33 0 0 1-1-7.84 18.7 18.7 0 0 0 5.1 2.29c.87 3.53 1.42 5.1 1.42 5.1Zm-.9-5.75a19 19 0 0 1 .13-5.78 8.87 8.87 0 0 0 4.54 2.07 30 30 0 0 0 .51 4 29 29 0 0 1-5.18-.31Zm11.42-4.41a12.2 12.2 0 0 1-5.56.22c0-.35 0-.7-.06-1.07a45 45 0 0 1 .16-6 30 30 0 0 0 4.28 1.46v.21a19.5 19.5 0 0 0 1.15 5.19Zm-.26-6.16h-.2c.13-2.12.12-5.21.12-5.21a9.6 9.6 0 0 0 3.15.29 7.5 7.5 0 0 0 1 2.5 12.6 12.6 0 0 0 2.23 2.46 32.7 32.7 0 0 1-6.32 0Zm-14.81 36.65-.26-1.06a7.7 7.7 0 0 0-2.29 2.69 3 3 0 0 1-.56-.14c-1.2-.43-4-1.53-4-1.53l.4.8a38 38 0 0 0 3.68 1.51h.25c-.39 1.17-1 2.76-1 2.76l.47.65a11.2 11.2 0 0 1 1-3.34c1 .1 2.38.15 2.38.15s-.17.77-.43 1.64-.76 2.89-.76 2.89l.87.54 4.07.09-.68-.81s-.13-.2-1.45-.24a7.8 7.8 0 0 0-2.13.17s.17-.83.68-2.47a7.2 7.2 0 0 1 .53-1.55l-.51-1.42a9.2 9.2 0 0 1-2.16.33 6 6 0 0 1 1.85-1.7Zm-22.23-2.57a8.36 8.36 0 0 1 4.6 1.68l-.1-1.19s-1.95-2.63-4.18-2.63-4.89 2.3-4.89 2.3v2.46s2.08-2.62 4.57-2.62m26.25 38.23a15.7 15.7 0 0 1-5.43 1.1 16 16 0 0 0 1.54-3c5-1.4 6-4.73 6-4.73l-.31-1.24a9.64 9.64 0 0 1-5.24 4.73c.75-2.36 1.5-6.34 1.5-6.34l-1.37-.36s-2 2.46-3.83 3.09a15 15 0 0 0 1.43-5.26l-.6-1.07a7.8 7.8 0 0 1-3.45 1.59 3.5 3.5 0 0 1-1 0 65 65 0 0 0 3.36-6.29l-.39-.88a30.3 30.3 0 0 1-3.41 6.19c-.22.27-.44.52-.66.76a24 24 0 0 1-4.29-2l.28.78a12.7 12.7 0 0 0 3.53 1.76c-1.28 1.34-2.66 2.58-2.66 2.58l.12 1.88s3.24.61 5.9.88a14.5 14.5 0 0 1-3.88 4l.86 1.3a35.6 35.6 0 0 0 7.35-1.18 18.2 18.2 0 0 1-2.37 3.64s4.31.3 7.25-1.2a9.3 9.3 0 0 0 3.83-3l-.83-.91a5.7 5.7 0 0 1-3.19 3.24Zm-13.61-8.11s1.27-1.39 2.36-2.82h.14c3 .65 3.83-.25 3.83-.25s.57 1.62-1.26 4.54a16.3 16.3 0 0 1-5.07-1.5Zm2.69 6 2.68-3.11a7 7 0 0 0 .51-.66 6.27 6.27 0 0 0 4.6-2.52 11.06 11.06 0 0 1-1 5.44 14.8 14.8 0 0 1-6.82.88Zm-3.64-19.31a28.8 28.8 0 0 1 6.45 1.52l-.45-1.49s-3.46-.84-5.61-1.12a7.15 7.15 0 0 1 3.09-3.19l-1-.51s-1.18.19-2.78 2.91c-.13.22-.25.45-.36.68h-.6a8.77 8.77 0 0 0-4.69 1.42l.38.78a13.6 13.6 0 0 1 4.42-1c-.79 2.21-1.39 4.73-1.39 4.73l.58 1.33s1.11-3.56 1.89-6Zm-5.91-12.05-.61-1.56s-3-1.06-5.3 0a12 12 0 0 0-4 3.76l1 1.82s1.59-2.95 3.7-3.66a15.1 15.1 0 0 1 5.27-.39Zm5.82 4.58-2-1s-3.25.94-4.4 2.11-2.08 4.14-1.76 5a3.3 3.3 0 0 0 1.34 1.4s.54-3.15 2.14-4.63a20.5 20.5 0 0 1 4.68-2.88m-7.59-.93a8.8 8.8 0 0 1 3.76-1.79l-1.21-1.1a9.8 9.8 0 0 0-4.47 1.72 30.5 30.5 0 0 0-3.52 4.18l1.73 1.68a44 44 0 0 1 3.71-4.69m10.11-88 .1-.13c1.55-2 3.05-2 3.64-1.83a2.1 2.1 0 0 0 .87 0h.26a.18.18 0 0 1 .18.1 18 18 0 0 0-1.55 4.69c-.45 2.2-1.41 2.46-2.11 3.82s-2.21 3.54-2.21 5.48.44 3 .95 3.25 1.45-.85 1.41-1.3c-.07-.65-.58 0-1 0s-.32-.65-.51-1.81 1.4-4.41 2-5.45 1.79-2.26 2-4a45 45 0 0 1 1.37-5 6.3 6.3 0 0 0-2.56-.46 5 5 0 0 0-3.77 2.25c-.79 1.23-3.31 2.22-3.31 2.22a5.77 5.77 0 0 0 4.21-1.86Z"
        className="Mexico_svg__cls-1"
      />
      <path
        id="Mexico_svg__polygon87"
        d="m570.53 268.39-4.9.13 1.4 3.67z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path89"
        d="M564.75 268.21a6 6 0 0 1-1-.84 2.9 2.9 0 0 0-.61-.55l-1.76 1.11-1 3.63.51.52 3.94-3.87Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path91"
        d="m564.1 278-3.58-5.27-2 4.4 1 .34s1 .1 2.47.31a17 17 0 0 0 2.18.22Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path93"
        d="m578.64 366.08-.18.12a17.67 17.67 0 0 1-9.2 2.86 13.1 13.1 0 0 1-6.8-1.87 7.74 7.74 0 0 1-3-3.52 32 32 0 0 1-2-7.71c-.48-2.7-1-5.32-2.17-7.25-1.6-2.56-4.63-4.16-7.34-6.44a14.46 14.46 0 0 1-5.61-10.27c-.05-.52-.07-1-.07-1.54a22.2 22.2 0 0 1 2.19-8.92c1.1-2.59 2.23-4.79 2.24-6.78a4.5 4.5 0 0 0-.11-1 7.48 7.48 0 0 0-2.91-3.78 18 18 0 0 0-2.36-1.53l-1.9-.53-.16.6 1.87.52.08-.3-.13.27.18.1a18 18 0 0 1 2.52 1.73 6.34 6.34 0 0 1 2.24 3.06 4 4 0 0 1 .09.84c0 1.75-1.07 3.93-2.19 6.54a23.1 23.1 0 0 0-2.24 9.17 14 14 0 0 0 .08 1.6 15.07 15.07 0 0 0 5.86 10.73c2.78 2.32 5.75 3.93 7.21 6.3s1.87 6.12 2.57 9.74a22.7 22.7 0 0 0 1.53 5.15 8.24 8.24 0 0 0 3.25 3.78 13.73 13.73 0 0 0 7.1 2 18.3 18.3 0 0 0 9.75-3.1l-.36-.5Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path95"
        d="M574.4 356.39a5.1 5.1 0 0 1-2.46.67 4.73 4.73 0 0 1-3.42-1.53 8 8 0 0 1-2.29-4.53 30 30 0 0 0-1.82-6.51c-1.2-2.8-4.17-5-6.93-7.23s-5.32-4.33-5.78-6.66a6.5 6.5 0 0 1-.13-1.31c0-2 .85-4 1.73-6.23a21.2 21.2 0 0 0 1.77-7.82c0-.51 0-1-.08-1.58-.41-3.91-3.39-6.82-6.23-8.76a28.3 28.3 0 0 0-5.58-2.93l-.2.59a5 5 0 0 1 .45.18 26.7 26.7 0 0 1 6 3.43c2.41 1.86 4.6 4.39 4.92 7.55 0 .52.08 1 .08 1.52a20.5 20.5 0 0 1-1.73 7.59c-.87 2.25-1.77 4.3-1.77 6.46a8 8 0 0 0 .14 1.44c.57 2.68 3.24 4.82 6 7s5.66 4.42 6.75 7a28.7 28.7 0 0 1 1.78 6.39 8.66 8.66 0 0 0 2.46 4.85 5.37 5.37 0 0 0 3.85 1.7 5.46 5.46 0 0 0 2.84-.8l-.34-.52Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path97"
        d="M592.49 341.39s3.43.81 3.3 3.6a25.9 25.9 0 0 1-1.66 6.67l-4.72-4.28 2.66-2.35 1-1.4-.56-2.24Z"
        className="Mexico_svg__cls-4"
      />
      <path
        id="Mexico_svg__path99"
        d="M533.46 307.87s-3.38 1.16-4.09-.33a6 6 0 0 1-.44-3c-.07-.32-2-.45-1.85-2.39s2.68-1.82 3.19-1.82.64-3 2.36-2.85 2.56 2.14 2.56 2.14l-1.73 8.23Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path101"
        d="m533.46 307.87-.08-.25-.21.07a8 8 0 0 1-2.11.35 2.5 2.5 0 0 1-.92-.14.94.94 0 0 1-.54-.47 4.56 4.56 0 0 1-.44-2v-.93a.44.44 0 0 0-.21-.27 4 4 0 0 0-.48-.24 2.6 2.6 0 0 1-.79-.53 1.45 1.45 0 0 1-.38-1.05v-.23a1.51 1.51 0 0 1 1.06-1.33 4.7 4.7 0 0 1 1.62-.25h.26a.47.47 0 0 0 .38-.23 3.8 3.8 0 0 0 .32-.72 6 6 0 0 1 .58-1.3 1.14 1.14 0 0 1 1-.6h.09a2.54 2.54 0 0 1 1.75 1 5 5 0 0 1 .45.67l.11.21v.08l.24-.1-.25-.06-1.73 8.23.25.06-.08-.25.08.25.25.05 1.74-8.31v-.07a4.6 4.6 0 0 0-.67-1.09 3.1 3.1 0 0 0-2.1-1.21h-.13a1.52 1.52 0 0 0-1.15.52 4.8 4.8 0 0 0-.84 1.6c-.08.25-.17.47-.23.61l-.09.14v.1-.12.1-.12H530a5 5 0 0 0-1.8.28 2.05 2.05 0 0 0-1.39 1.77v.28a2 2 0 0 0 1 1.82 7 7 0 0 0 .66.33l.19.1.09-.09h-.12v.07l.09-.09h-.12v.83a5.14 5.14 0 0 0 .49 2.22 1.46 1.46 0 0 0 .81.72 3.1 3.1 0 0 0 1.11.18 8.8 8.8 0 0 0 2.48-.45l.14-.05v-.14l-.25-.05Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path103"
        d="M537.23 308.77s-2.88 1.5-3.77.07 0-3.24-.32-3.57-2-.9-1.73-2.59 2.11-1.17 2.75-1.49 1.09-2.85 2.87-2.4a2.77 2.77 0 0 1 2.11 1.88s-1.4 6.74-1.91 8.1"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path105"
        d="m537.23 308.77-.12-.23-.21.1a5.6 5.6 0 0 1-2.12.55 1.2 1.2 0 0 1-1.11-.49 2.7 2.7 0 0 1-.37-1.45c0-.67.16-1.27.17-1.7a.65.65 0 0 0-.15-.46 2.4 2.4 0 0 0-.45-.31 3.7 3.7 0 0 1-.82-.65 1.53 1.53 0 0 1-.38-1.4 1.22 1.22 0 0 1 .39-.75 1.87 1.87 0 0 1 1.06-.36 3.8 3.8 0 0 0 1.16-.2 1.56 1.56 0 0 0 .53-.6 8 8 0 0 1 .75-1.22 1.36 1.36 0 0 1 1.06-.6 1.5 1.5 0 0 1 .35 0 2.8 2.8 0 0 1 1.59 1 2.5 2.5 0 0 1 .27.48v.15l.25-.06-.25-.05s-.35 1.68-.76 3.54-.9 3.88-1.14 4.52l.24.09-.12-.23.12.23.23.1c.28-.73.74-2.73 1.16-4.6s.77-3.54.77-3.54v-.11a2.2 2.2 0 0 0-.43-.87 3.2 3.2 0 0 0-1.86-1.21 2 2 0 0 0-.48-.06 1.7 1.7 0 0 0-1.07.4 4.3 4.3 0 0 0-1 1.28 5 5 0 0 1-.32.55.7.7 0 0 1-.22.25 1.7 1.7 0 0 1-.56.11 3.9 3.9 0 0 0-1.33.25 1.65 1.65 0 0 0-1 1.31 1.9 1.9 0 0 0 0 .46 2.19 2.19 0 0 0 .86 1.7c.22.18.45.32.62.44a2 2 0 0 1 .36.23h-.14v.11c0 .3-.17 1-.17 1.7a3.23 3.23 0 0 0 .45 1.73 1.72 1.72 0 0 0 1.54.74 6.7 6.7 0 0 0 2.56-.71l.09-.05v-.09l-.23-.1Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path107"
        d="M542.08 309.42a2.61 2.61 0 0 1-2.87 1.42c-2.05-.38-1.41-3.36-1.73-3.88s-1.79-.91-1.53-2.79 2.11-1.62 2.81-1.87 1.47-3.18 2.81-2.73 2.62 2.14 2.36 2.92c0 0-2.87.9-3.26 2.85s1.41 4.08 1.41 4.08"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path109"
        d="m542.08 309.42-.23-.11a2.5 2.5 0 0 1-.55.72 2.16 2.16 0 0 1-1.53.6 2.4 2.4 0 0 1-.51-.05 1.3 1.3 0 0 1-.92-.59 3.55 3.55 0 0 1-.45-1.7v-.84a1.6 1.6 0 0 0-.14-.64 7 7 0 0 0-.93-.84 1.8 1.8 0 0 1-.6-1.39 3 3 0 0 1 0-.38 1.57 1.57 0 0 1 .39-.91 2 2 0 0 1 1.09-.54c.42-.09.84-.11 1.17-.22a1.55 1.55 0 0 0 .63-.64c.27-.42.56-1 .87-1.41a2.5 2.5 0 0 1 .48-.52.8.8 0 0 1 .46-.19h.2a3.8 3.8 0 0 1 1.55 1.11 2.4 2.4 0 0 1 .67 1.34v.14l.24.08-.07-.25a7.5 7.5 0 0 0-1.54.72 3.8 3.8 0 0 0-1.89 2.33 3 3 0 0 0-.06.62 6.74 6.74 0 0 0 1.52 3.68l.19-.17-.23-.11.23.11.19-.17v-.07a6.1 6.1 0 0 1-1.34-3.27 2.2 2.2 0 0 1 0-.52 3.3 3.3 0 0 1 1.65-2 7 7 0 0 1 1-.51l.32-.12h.25v-.13a1 1 0 0 0 0-.3 2.87 2.87 0 0 0-.8-1.68 4.34 4.34 0 0 0-1.77-1.26 1.1 1.1 0 0 0-.36-.06 1.4 1.4 0 0 0-1 .47 7 7 0 0 0-1 1.44 5.5 5.5 0 0 1-.39.61.8.8 0 0 1-.26.26 3.6 3.6 0 0 1-.65.13 3.6 3.6 0 0 0-1.39.42 2 2 0 0 0-.94 1.54v.45a2.38 2.38 0 0 0 .75 1.77 10 10 0 0 1 .86.74.8.8 0 0 1 0 .19 16 16 0 0 0 .2 2 2.6 2.6 0 0 0 .51 1.11 1.87 1.87 0 0 0 1.14.66 3.3 3.3 0 0 0 .61.06 2.68 2.68 0 0 0 1.94-.82 3 3 0 0 0 .6-.81l.07-.15-.1-.13-.2.17Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path111"
        d="M587.3 340.71s-2.56-2.8-4.35-5.26a55 55 0 0 0-4.55-5.28L574 328l-2.76-4.62-.35-5.44 1.2-3.16 1.66-2.42s-9.08 3.25-4.48 20.65c2 7.39 7 8.46 7 8.46l8.34-.51 2.69-.22Z"
        className="Mexico_svg__cls-11"
      />
      <path
        id="Mexico_svg__path113"
        d="M583.09 282.62a1.78 1.78 0 0 1 1.55.67 2.26 2.26 0 0 1 .34 1.28 3 3 0 0 1-.05.58v.22l.3.08-.28-.13c-3 6.65-9.38 9.76-15.1 13.9a27.2 27.2 0 0 0-7.5 7.62 23.4 23.4 0 0 0-3.22 12.7v.84c.22 10 4 15.38 8.17 18.2a19.07 19.07 0 0 0 10.36 3.12h.7s1.17-.15 2.84-.3 3.85-.3 5.86-.3a22 22 0 0 1 3.45.22 3.2 3.2 0 0 1 1.86.72 1.57 1.57 0 0 1 .37 1 3.74 3.74 0 0 1-1.22 2.32 7.8 7.8 0 0 1-1.72 1.37l.25.56a8 8 0 0 0 1.91-1.49 4.4 4.4 0 0 0 1.4-2.76 2.2 2.2 0 0 0-.52-1.41 3.62 3.62 0 0 0-2.23-.94 22.4 22.4 0 0 0-3.55-.23 82 82 0 0 0-8.78.6v.32-.32h-.66a18.5 18.5 0 0 1-10-3c-4-2.73-7.67-7.85-7.9-17.71v-.82a23 23 0 0 1 3.12-12.37c2.86-4.65 7.32-7.47 11.68-10.41s8.62-6 11-11.18v-.06a4.7 4.7 0 0 0 .1-.95 2.8 2.8 0 0 0-.45-1.64 2.41 2.41 0 0 0-2-.94v.63Z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path115"
        d="M595.35 343.57s-2.16 3.94-2.7 4a5.4 5.4 0 0 1 2.41 1.55l-.52 1s-2.38-1.7-3.88-1.77l-.13-1.46a7.1 7.1 0 0 0 2.23-1.33 7.8 7.8 0 0 0 1.71-3.37l.88 1.43Z"
        className="Mexico_svg__cls-1"
      />
      <path
        id="Mexico_svg__path117"
        d="m603.73 346.15-5.36 1.47-2.74-1.71s.23-2.23-1-3.19a10.6 10.6 0 0 0-3.08-1.73 23.4 23.4 0 0 0-4.91-.54L577 330l3.62.38 5.73-.71 5.32-.45 2.81.41 3 .93 1.58 1.33 1.64 1.45 1.64 2.7 1 3.05.43 3.28v3.82Z"
        className="Mexico_svg__cls-13"
      />
      <path
        id="Mexico_svg__path119"
        d="M604 345.81a16.2 16.2 0 0 1-4.34.52 19.6 19.6 0 0 1-4-.42s.13.16-.38 1.76a23 23 0 0 1-1 2.59l.09 6.3 5.11 1 2.68-1 1.37-6.87.42-3.84Z"
        className="Mexico_svg__cls-11"
      />
      <path
        id="Mexico_svg__polygon121"
        d="m602.52 343.14.23 2.45 1 .29-.02-2.2z"
        className="Mexico_svg__cls-13"
      />
      <path
        id="Mexico_svg__path123"
        d="m597.71 284.23-.6-4.29-1.68-2.85-2.13-2.92-2.3-2.51-1.27-1.14-.54-.84-5.59.26-2.94 3.5s7.65 5.4 10.52 11.29a14 14 0 0 1 5.51 3.38l.25-.46.75-3.42Z"
        className="Mexico_svg__cls-13"
      />
      <path
        id="Mexico_svg__path125"
        d="M592.28 289c-.08 4.38-.83 6.46-1.41 7.43l3.39-3.89 2.44-4.39a13.85 13.85 0 0 0-5.5-3.39 9.56 9.56 0 0 1 1.08 4.24"
        className="Mexico_svg__cls-11"
      />
      <path
        id="Mexico_svg__path127"
        d="M600.19 353.8s-1.58-2-2.75-3.11a10.7 10.7 0 0 0-2.6-1.82l-.26.57.22.11a10 10 0 0 1 2.21 1.59c.56.55 1.24 1.32 1.78 1.94s.92 1.11.92 1.12z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path129"
        d="M603.48 349.1a8.3 8.3 0 0 1-2.43 3.62 21.2 21.2 0 0 1-4.34 2.9l5.49 2 3.66-3.41-2.38-5.14Z"
        style={{
          fill: "#6f5b24",
        }}
      />
      <path
        id="Mexico_svg__polygon131"
        d="m603.95 354.3-1.03 1-.81.86 1.37-5.7.98 1.68.12.91-.29.6z"
        style={{
          fill: "#404118",
        }}
      />
      <path
        id="Mexico_svg__polygon133"
        d="m709.41 455.24.44 8.82 3.33-2.2-2.55-7.26z"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__polygon135"
        d="m710.76 454.24-1.6.86v.17l.25-.03.12.24.95-.51 2.39 6.78-2.78 1.85-.42-8.37-.26.01.12.24-.12-.24-.25.03.47 9.25 3.86-2.56z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path137"
        d="M711.93 452.85a2.91 2.91 0 1 1-2.91-2.76 2.85 2.85 0 0 1 2.91 2.76"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__path139"
        d="M711.93 452.85h-.23a2.68 2.68 0 1 1-2.68-2.53 2.62 2.62 0 0 1 2.68 2.53h.45a3.13 3.13 0 1 0-3.13 3 3.06 3.06 0 0 0 3.13-3Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path141"
        d="M711 455.91a2.75 2.75 0 0 0-.83.94 13 13 0 0 0-.61 1.75v-2.85l1-.55.45.71Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path143"
        d="M711.44 454.12a2.45 2.45 0 0 1-2.24 1c-1.57-.08-2.34-.81-2.53-1.61a2.86 2.86 0 0 1 .31-2.32c.52-.92-.74.89-.74.89v1.77l1.15 1.36 1 .31 1 .06 1.23-.41.83-.63.05-.45Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__polygon145"
        d="m719.97 468.98-6.45-6.17-2.89 2.32 8.76 5.11z"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__polygon147"
        d="m719.5 470.6.78-1.68-.13-.13-.18.19-.23-.1-.46.99-8.2-4.78 2.43-1.94 6.29 6.03.17-.2-.23-.1.23.1.18-.19-6.61-6.33-3.37 2.71z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path149"
        d="M719.41 472.46a2.88 2.88 0 0 1 .67-4 2.79 2.79 0 0 1 4 .43 2.9 2.9 0 0 1-.67 4 2.79 2.79 0 0 1-4-.44Z"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__path151"
        d="m719.41 472.46.18-.14a2.44 2.44 0 0 1-.48-1.47 2.81 2.81 0 0 1 2.77-2.77 2.43 2.43 0 0 1 2 1 2.48 2.48 0 0 1 .48 1.47 2.81 2.81 0 0 1-2.77 2.77 2.43 2.43 0 0 1-2-1zl-.18.14a2.87 2.87 0 0 0 2.33 1.16 3.26 3.26 0 0 0 3.23-3.24 2.87 2.87 0 0 0-2.91-2.9 3.17 3.17 0 0 0-1.94.67 3.24 3.24 0 0 0-1.29 2.56 2.9 2.9 0 0 0 .58 1.75z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path153"
        d="M719.73 468.61a2.1 2.1 0 0 1-1.4.19 32.5 32.5 0 0 1-6.84-3.5l7.47 4.64z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path155"
        d="M724.38 470.72a2.46 2.46 0 0 1-1.53 1.95c-1.44.65-2.45.36-3-.27a2.82 2.82 0 0 1-.76-2.21c0-1.06-.26 1.13-.26 1.13l.8 1.58 1.63.68 1-.18.88-.38.92-.94.46-.94-.17-.42Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__polygon157"
        d="m769.51 376.82 6.61 6.57.77-3.33-6.04-4.05z"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__polygon159"
        d="m770.86 375.7-1.76 1.07.23.23.18-.18.13.22 1.21-.72 5.75 3.86-.63 2.71-6.28-6.25-.18.18.13.22-.13-.22-.18.18 6.93 6.9.92-3.96z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path161"
        d="M771.36 375.12a2.75 2.75 0 1 1-2.74-2.79 2.76 2.76 0 0 1 2.74 2.79"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__path163"
        d="M771.36 375.12h-.23a2.52 2.52 0 1 1-2.51-2.55 2.53 2.53 0 0 1 2.51 2.55h.47a3 3 0 1 0-3 3 3 3 0 0 0 3-3Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path165"
        d="M772.13 377.09a1.56 1.56 0 0 0-.19.78v1.36l-1.63-1.81.83-1.07 1 .74Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path167"
        d="M771.26 374.73c.1 1.29-1.78 3.14-3.19 2.55s-2.42-2-1.65-3.49-.39.55-.39.55l.19 2.14 1.34 1.22 1.66.1 1.32-.74.79-1.46z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__polygon169"
        d="m786.92 380.71-10.09 2.88.83-3.33 8.68-.85z"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__polygon171"
        d="m786.18 379.69.5 1.12.24-.1-.08-.25.08.25.22-.11-.64-1.46-9.05.87-.98 3.95 10.79-3.09-.12-.27-.22.11-.08-.25-9.66 2.76.68-2.72z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path173"
        d="M791.23 379.33a2.69 2.69 0 1 1-2.68-2.72 2.71 2.71 0 0 1 2.68 2.72"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__path175"
        d="M791.23 379.33H791a2.46 2.46 0 1 1-2.45-2.49 2.48 2.48 0 0 1 2.45 2.49h.46a2.92 2.92 0 1 0-2.91 2.95 2.94 2.94 0 0 0 2.91-2.95Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path177"
        d="M791 378.26s-.32-.89-.15.11-1.14 3.17-2.64 3a2.4 2.4 0 0 1-2.06-2.72c.13-1.22-.25.42-.25.42l.24 1.62.8.76 1.15.68 1.34-.23 1.21-.78.54-1.14v-.81l-.18-.88Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path179"
        d="M784.24 379.75a1.35 1.35 0 0 1-.84 1.17c-.9.49-2.59 1.49-2.59 1.49l5.56-1.62-.46-1.35z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__polygon181"
        d="m753 430.46-6.16-9.59.99-.5 6.97 8.23z"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__polygon183"
        d="m754.45 428.59-1.62 1.68.17.19.23-.15-.23.15.19.18 1.96-2.02-7.25-8.57-1.43.71 6.5 10.11.22-.23-.19-.18.23-.15-6.02-9.34.56-.28z"
        className="Mexico_svg__cls-17"
      />
      <ellipse
        id="Mexico_svg__circle185"
        cx={746.23}
        cy={418.64}
        className="Mexico_svg__cls-16"
        rx={2.84}
        ry={2.88}
      />
      <path
        id="Mexico_svg__path187"
        d="M749.08 418.66h-.23a2.62 2.62 0 1 1-2.61-2.65 2.63 2.63 0 0 1 2.61 2.65h.46a3.08 3.08 0 1 0-3.07 3.12 3.09 3.09 0 0 0 3.07-3.12Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path189"
        d="M750.6 423.83a1.57 1.57 0 0 0-.31 1 8.3 8.3 0 0 0 .14 1.53l-3.12-4.93.93-.58 2.36 3Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path191"
        d="M748.9 419.19c-.56 1.3-2.82 2.12-3.91 1.49s-2-3-.68-4l-.7.61-.35 1.34.5 1.41 1.09 1.22 1 .31 1.6-.32 1.16-.91s.85-2.42.29-1.13Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__polygon193"
        d="m753.39 430.73 7.82 1.42.29-1.07-6.55-2.59z"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__polygon195"
        d="m754.85 428.18-1.91 2.73.4.08.05-.26.2.15 1.45-2.08 6.15 2.44-.17.61-7.59-1.38-.04.26.2.15-.2-.15-.05.26 8.05 1.46.41-1.52z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path197"
        d="M766.42 432.23a2.81 2.81 0 1 1-2.82-2.85 2.84 2.84 0 0 1 2.82 2.85"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__path199"
        d="M766.42 432.23h-.23a2.59 2.59 0 1 1-2.59-2.62 2.6 2.6 0 0 1 2.59 2.62h.45a3 3 0 1 0-3 3.09 3.05 3.05 0 0 0 3-3.09Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path201"
        d="M759.87 430.49s0 .58-1 .58h-3.16l5.18 1 .25-1-1.28-.58Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path203"
        d="M766.22 431.69a2.34 2.34 0 0 1-3.05 2.81 2.64 2.64 0 0 1-1.89-3.61l-.49 1.23.36 1.64 1.21 1.06 1.24.27 1.27-.32 1.29-1.23.31-1.47z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path205"
        d="M796.15 358.27c-.61 7.55-8 11.4-11.94 14.22a21.15 21.15 0 0 0-5.79 6.32l-1.31 4.4-.64 2.82-.13 1a14.4 14.4 0 0 1 .64 4.18c.1 3.43-.22 8.32-.22 8.32l5.24-3.76 3.8-1.42 1.15-.19s-4.22 4.19-5.88 8.73-4.72 14.11-10.47 17.26-9.33 1.82-11.24 3.5-2 2.13-2 2.13l-2.45 3.35-1.91 2.51-1.81 1.25-1.14.93a15 15 0 0 1-.47 3.26c-.63 2.21-1.37 4.68-1.37 4.68a7.1 7.1 0 0 1 2.54-.87 22 22 0 0 1 2.68-.17 9 9 0 0 0-1.47 2.63c-.38 1.29.25 9.07-7.15 13.73S718.52 461 718.52 461l-3.52 1.43-3.41 2.57-3.07 3.36-.23.91a25.2 25.2 0 0 1-4 3.93c-1.65 1.1-5.49 3.62-5.49 3.62a19.5 19.5 0 0 1 4.35.26c1.08.4 6.89 3 6.89 3a22.7 22.7 0 0 0-7.15 1c-2.9 1.13-16.09 8.6-22.48 8.38s-15.5-9.54-15.5-9.54l-4.13-2.9-6.86-1.33-8.47-.48.12-1.11.16-1.37a35.7 35.7 0 0 1 7.5.22c4 .47 5.27 1.79 8.59 2.17a14.15 14.15 0 0 0 7-.64c1.21-.56 11.46-9.24 11.46-9.24l11.53-4 4.4.64 1.95.52 1.79.52a12.6 12.6 0 0 1-1.88 2.14 14.7 14.7 0 0 1-2.88 2l1.41 1.13 7.28-1.17 2.37.62a3.2 3.2 0 0 1 .69.36 6.4 6.4 0 0 1 1.06-2.47 46.5 46.5 0 0 1 6.73-5.66 13.6 13.6 0 0 0 2.72-1.95c.58-.61 2.94-6.71 2.94-6.71l.32-3.1 8-7.75 5.43-5.77 2.36-6.57-.26-1.33s2 2 1.6 6.09-1.25 5.51-1.25 5.51a74 74 0 0 1 8.44-5.09 9.27 9.27 0 0 1 4.7-.9 13.3 13.3 0 0 0 4.17-3.63c1.6-2.33 2-3 2-3.95s.25-5.48.25-5.48l-.51-13.9 4.73-10.46 6.86-6.16 1.31-.77a11.8 11.8 0 0 0-.64 2.46c-.1 1-.1 2.78-.1 2.78s3.48-4.76 5.27-5.63l1.1-.52a14.2 14.2 0 0 0 1.42-3.85 42 42 0 0 0 .64-6.17l.1-5.76-1.11-4.47-3.2-8.59-.13-11.3-2.39-3.23s2.27-.17 5.08 3.88a26.5 26.5 0 0 1 3.64 9.75l6.52-20a23.1 23.1 0 0 1 3 6.31 46 46 0 0 1 1.63 6.64l2.57-5.55a5.2 5.2 0 0 0 .31 2c.44 1.84 4.43 4.15 3.83 11.7Zm-132.44 128s-1.22-3.07-7.5-6.18a38.4 38.4 0 0 0-11-3.71l-.06 2.31L655 483l4.92 4Z"
        className="Mexico_svg__cls-18"
      />
      <path
        id="Mexico_svg__path207"
        d="M708.61 467.42a46.5 46.5 0 0 1 8.62-6.93 19.1 19.1 0 0 1 6.32-1.66c3.74-.68 4.35-.13 13-4.89s10.54-10.24 12.2-11.56a10.8 10.8 0 0 1 4.69-1.65s-3.61 4.24-6.77 7.7-6.55 5.67-11.4 8.95-14.94 3.43-14.94 3.43a15.1 15.1 0 0 0-8 4.08 29 29 0 0 0-4 4.33 2.23 2.23 0 0 1 .33-1.8Zm23.79-25c-8 7.29-10.6 14.06-10.6 14.06s7.09-6.09 10.73-9.58 8.75-5.19 11.05-7.33 2.43-3.95 3.89-5.31a17.3 17.3 0 0 1 2.56-2s-3.51-2.72-17.63 10.17Zm-16.83 16.87a9.92 9.92 0 0 0 4.7-4.56c1-2.27.45-2.85 1.92-5.44 0 0 8.3-8 11.23-11.47 5.24-6.16 2.88-11.21 2.88-11.21a6.77 6.77 0 0 1-1.6 5.31c-2.17 2.72-12.88 10.05-14.18 14.26s-.57 4.37-1.15 6.61c-1.32 5.16-3.8 6.5-3.8 6.5M710.05 480a16.14 16.14 0 0 0-8.86-2.5c-9.53.6-17.6 6.48-23.9 6.65s-8.78-3-13.65-6.31c-5.19-3.54-18-3-18-3l-.08.3-.09.38s8.84.09 12.61 1.13c7.2 2 11.08 9.49 19.26 9 10.61-.63 19.31-7.09 23.65-7.07 7.45.05 9.11 1.43 9.11 1.43Zm-47.31-4.83s7.39 1.34 13.14-2.88 12.58-9.91 16.35-10.17a29 29 0 0 1 7.73.71s-4.79-2.14-8.62-2.07-7.73.58-11.31 2.72-5.3 6-9.19 8.49a25.3 25.3 0 0 1-8.1 3.2m-1.33 9.95c-1 0-2.14.64-2.52.58s-2.65-2.4-5.81-4.08a37 37 0 0 0-7.88-2.7s-.58.15.47.5 5 1.68 7.44 2.85a17.1 17.1 0 0 1 5.24 4.24 3.17 3.17 0 0 0 3 1.56c1.85-.07 2.59-1.13 2.39-1.85s-1.31-1.1-2.3-1.1Zm5.21-7.19a16.1 16.1 0 0 0 7.79 1.55c10.35-.26 16.86-7.34 23.64-9.93s10.24-.35 10.24-.35.17-.36 0-.52a13.84 13.84 0 0 0-7.57-2.37c-11.37.17-22 7.34-26.65 9.28a35.6 35.6 0 0 1-7.41 2.34Zm110-78.37c-3.49 3.6-8.69 15.1-11 18.24s-5.17 4.08-6.41 5.35c-1.1 1.11-5.27 6.73-6.23 8.1s-1.25 1-1.92 1.55-1 .62.1.32 1.47-1 3.19-2.91 1.63-2.82 4.37-5.28 7.72-5.27 10.19-8.3 7.51-14.72 10.14-17.57c2.86-3.09 7.84-4.93 7.84-4.93s-3.89-1.13-10.23 5.45ZM759 421.39s-.13-2.08 2.43-5.13 3.45-2.65 5.49-7.12 2.94-8.81 4.6-13.54a55.5 55.5 0 0 1 4.53-9.4s-2.68.26-5.43 4a67.8 67.8 0 0 0-9.33 17 52.5 52.5 0 0 0-2.29 14.19m-3.26 4.33s1-.51 1.08-6.28-.31-13.86 1.35-17.88 10.47-13.67 10.47-13.67-3.64.9-8.75 5-7.28 9.2-7 13.08 2.43 8.3 2.62 12.12.25 7.64.25 7.64ZM776.46 386s2.18-7.82 3.07-9.72.94-3 5.37-8c2.53-2.85 5-4.67 6.08-8.64s1-15.07 1-15.07a10.3 10.3 0 0 0-2.09 3c-.94 1.95-.25 9.16-1.91 12.48s-5.41 11.16-7.29 12.84a69 69 0 0 1 .3-11.28c.69-5.66 2.6-7.38 3.45-11.1s.34-13.3.34-13.3a25 25 0 0 0-4.51 6.69c-1.49 3.59-2.38 10-2.43 14.86s1.11 8.77 1.28 11.54.38 4.06-.73 7.08-.55.95-1.23 3.89-1.4 5.14-1.4 5.14l.67-.39Zm-6.89-42.42s2.64 3.33 2.21 7.13-1.87 8.81-.38 12.78 3.71 4.37 4.3 6.65a37.7 37.7 0 0 1 .64 6.76s1.23-8.49.38-10.82-1.23-1.25-2.46-3.71 0-9.2-.9-13.13a9.46 9.46 0 0 0-3.79-5.66"
        className="Mexico_svg__cls-19"
      />
      <path
        id="Mexico_svg__path209"
        d="M569.42 452.54a2.26 2.26 0 0 1-2.09 2.33c-1 0-1.83-1.1-1.83-2.46s.82-2.46 1.83-2.46a2.55 2.55 0 0 1 2.09 2.59"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__path211"
        d="M569.42 452.54h-.23a2.23 2.23 0 0 1-.6 1.52 1.82 1.82 0 0 1-1.26.58 1.41 1.41 0 0 1-1.11-.63 2.65 2.65 0 0 1-.49-1.6 2.7 2.7 0 0 1 .49-1.6 1.39 1.39 0 0 1 1.11-.62 1.69 1.69 0 0 1 1.25.7 2.65 2.65 0 0 1 .61 1.65h.46a3.07 3.07 0 0 0-.72-2 2.2 2.2 0 0 0-1.6-.88 1.88 1.88 0 0 0-1.48.82 3.34 3.34 0 0 0 0 3.76 1.88 1.88 0 0 0 1.48.82 2.51 2.51 0 0 0 2.32-2.57Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__polygon213"
        d="m569.37 456.93 1.79 9.84-2.38-.94-.86-8.55z"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__polygon215"
        d="m568.2 457.48 1.23-.29-.06-.26-.25.05.25-.05-.06-.25-1.66.4.89 8.94 2.96 1.17-1.92-10.57-.27.06.06.25-.25.05 1.71 9.4-1.81-.74z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path217"
        d="M571.55 453.59c1.15 1.49-.8 3.77-2.87 4.33s-4.64-.39-4.62-2.28c0-2.15 3-1 3.82-1.28 1.24-.39 2.43-2.37 3.67-.77"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__path219"
        d="m571.55 453.59-.19.15a1.34 1.34 0 0 1 .3.85 2.82 2.82 0 0 1-.92 1.84 4.87 4.87 0 0 1-2.12 1.27 4.5 4.5 0 0 1-1.17.15 4.06 4.06 0 0 1-2.21-.61 1.85 1.85 0 0 1-1-1.57 1 1 0 0 1 .43-.9 2 2 0 0 1 1.08-.22c.6 0 1.25.1 1.73.11a1.2 1.2 0 0 0 .42-.06 5.3 5.3 0 0 0 1.38-.82 2.26 2.26 0 0 1 1.18-.55 1.07 1.07 0 0 1 .85.53l.19-.15.18-.14a1.54 1.54 0 0 0-1.22-.71 2.66 2.66 0 0 0-1.44.63 5 5 0 0 1-1.26.77.9.9 0 0 1-.28 0c-.42 0-1.09-.11-1.73-.12a2.7 2.7 0 0 0-1.32.29 1.44 1.44 0 0 0-.64 1.3 2.36 2.36 0 0 0 1.16 2 4.6 4.6 0 0 0 2.46.67 5 5 0 0 0 1.29-.16 5.26 5.26 0 0 0 2.32-1.39 3.32 3.32 0 0 0 1.06-2.17 1.8 1.8 0 0 0-.39-1.14l-.18.14Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path221"
        d="M571.42 453.65c.53.6-.3 2.85-2.53 3.75s-3.35.05-3.94-.71a2.52 2.52 0 0 1-.56-1.55l-.32.41.3 1.16 1.13 1 2 .43 1.47-.27 1.45-.78.74-.78.64-.95.09-1.17-.36-.58h-.09v.05Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path223"
        d="M569.42 458.55a1.56 1.56 0 0 0-.73.69 5 5 0 0 0-.47 1.55l-.17-2.63 1.15-.61z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path225"
        d="M557.45 468.68c0 1.23-1.37 2.22-3.06 2.22s-3.07-1-3.07-2.22 1.38-2.22 3.07-2.22 3.06.99 3.06 2.22"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__path227"
        d="M557.45 468.68h-.23a1.77 1.77 0 0 1-.79 1.39 3.77 3.77 0 0 1-4.08 0 1.6 1.6 0 0 1 0-2.77 3.72 3.72 0 0 1 4.08 0 1.76 1.76 0 0 1 .79 1.38h.47a2.19 2.19 0 0 0-1-1.76 4.13 4.13 0 0 0-4.6 0 2 2 0 0 0 0 3.52 4.13 4.13 0 0 0 4.6 0 2.19 2.19 0 0 0 1-1.76Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__polygon229"
        d="m559.58 468.16 9.45-.47-1.6-1.88-7.76.84z"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__polygon231"
        d="m559.42 466.42-.11 2.02.28-.02-.01-.26.25.02.08-1.3 7.42-.8 1.17 1.38-8.94.44.02.26.25.02-.25-.02.01.26 9.98-.5-2.03-2.38z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path233"
        d="M560.39 467.06c.78 2.39.85 5.66-1.83 5.31s-2.18-2.75-2.39-3.67c-.38-1.68-1.95-3.2-.34-4.83s3.76.79 4.56 3.19"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__path235"
        d="m560.39 467.06-.22.07a8.9 8.9 0 0 1 .46 2.66 3.2 3.2 0 0 1-.39 1.71 1.42 1.42 0 0 1-1.3.66 2 2 0 0 1-.35 0 2.53 2.53 0 0 1-1.36-.54 2.3 2.3 0 0 1-.69-1.46c-.08-.55 0-1.09-.14-1.49-.29-1.2-1.07-2.26-1-3.21a1.92 1.92 0 0 1 .6-1.46 1.4 1.4 0 0 1 1-.47 2.6 2.6 0 0 1 1.79 1.09 7.8 7.8 0 0 1 1.38 2.48l.22-.07.21-.08a8 8 0 0 0-1.46-2.64 3 3 0 0 0-2.14-1.21 1.8 1.8 0 0 0-1.33.6 2.38 2.38 0 0 0-.78 1.74c0 1.18.83 2.24 1.06 3.31a13.6 13.6 0 0 0 .27 2.07 2.4 2.4 0 0 0 .71 1.14 3 3 0 0 0 1.6.64h.41a1.9 1.9 0 0 0 1.69-.87 3.76 3.76 0 0 0 .46-2 9.1 9.1 0 0 0-.49-2.81l-.21.08Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path237"
        d="M562 466.46a.69.69 0 0 0 .39.86 13 13 0 0 0 2 .65l-3.66.13-.38-1.43z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path239"
        d="M560.73 468.75a1.4 1.4 0 0 1 0 .37 3 3 0 0 1-.29 1.05c-.43.91-.6 1.95-1.92 1.68a2.42 2.42 0 0 1-2-2.11 2.55 2.55 0 0 0-.43-1.21v1.17l.81 1.94 1.32.61h1.15l.89-.35.43-1.17.22-1-.22-1Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path241"
        d="M551.49 468.48a2.39 2.39 0 0 0 2.3 1.73c1.87.05 2.34-.52 2.34-.52l.21.65-.68.34-1.63.19-1.43-.29-.66-.49-.51-.88z"
        className="Mexico_svg__cls-17"
      />
      <ellipse
        id="Mexico_svg__ellipse243"
        cx={529.56}
        cy={415.4}
        className="Mexico_svg__cls-16"
        rx={1.85}
        ry={2.82}
      />
      <path
        id="Mexico_svg__path245"
        d="M531.42 415.42h-.23a3.5 3.5 0 0 1-.5 1.86 1.23 1.23 0 0 1-2.24 0 3.65 3.65 0 0 1 0-3.72 1.22 1.22 0 0 1 2.24 0 3.46 3.46 0 0 1 .5 1.86h.46a3.9 3.9 0 0 0-.58-2.12 1.67 1.67 0 0 0-3 0 4.1 4.1 0 0 0 0 4.24 1.67 1.67 0 0 0 3 0 3.94 3.94 0 0 0 .58-2.12Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__polygon247"
        d="m529.6 421.64.22 9.17-2.39-2.17.17-7.3z"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__polygon249"
        d="m527.85 421.64 1.71.26.04-.26-.25.01.25-.01.04-.26-2.28-.34-.18 7.71 2.9 2.64-.22-9.97-.22-.04-.04.26-.25.01.2 8.56-1.86-1.68z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path251"
        d="M533.14 418.85c.48 2.12-2.62 3.31-4.73 2.92s-3.7-1.49-3.38-3.44 2.94-1.51 3.83-1 3.61-1.47 4.28 1.49Z"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__path253"
        d="M533.14 418.85h-.22a1.8 1.8 0 0 1 0 .39 2 2 0 0 1-1.12 1.76 5.34 5.34 0 0 1-2.55.65 5 5 0 0 1-.79-.07 5.26 5.26 0 0 1-2.34-1 2.23 2.23 0 0 1-.86-2.21 1.31 1.31 0 0 1 .6-1 2.23 2.23 0 0 1 1.15-.27 3.6 3.6 0 0 1 1.73.43 1.2 1.2 0 0 0 .56.12c.61 0 1.36-.28 2-.27a1.44 1.44 0 0 1 .94.28 2 2 0 0 1 .65 1.2h.22l.23-.06a2.47 2.47 0 0 0-.81-1.46 2 2 0 0 0-1.23-.38c-.77 0-1.56.28-2 .27a.6.6 0 0 1-.32-.06 4.2 4.2 0 0 0-2-.49 2.54 2.54 0 0 0-1.38.35 1.78 1.78 0 0 0-.83 1.27 5 5 0 0 0 0 .53 2.68 2.68 0 0 0 1.08 2.14 5.9 5.9 0 0 0 2.53 1 5 5 0 0 0 .88.07 5.75 5.75 0 0 0 2.78-.71 2.47 2.47 0 0 0 1.39-2.07 3 3 0 0 0 0-.5l-.23.06Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path255"
        d="M532.92 418.5a2 2 0 0 1-.07.81 3.55 3.55 0 0 1-3.42 2.1c-2.13 0-3-.68-3.6-1.39a3.6 3.6 0 0 1-.67-1.72l-.07 1.07.83 1.33 2.11 1h2l2-.6.9-1 .21-1.09-.27-.53Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path257"
        d="M529.53 423a2.4 2.4 0 0 0-1.15.41 9 9 0 0 0-.72.76v-2.54l1.9.14V423Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path259"
        d="M516.6 429.71c0 .81-1.43 1.45-3.2 1.45s-3.19-.64-3.19-1.45 1.43-1.46 3.19-1.46 3.2.65 3.2 1.46"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__path261"
        d="M516.6 429.71h-.23a.65.65 0 0 1-.19.41 4.16 4.16 0 0 1-2.78.82 5.3 5.3 0 0 1-2.16-.41 2.1 2.1 0 0 1-.61-.41.6.6 0 0 1-.19-.41.6.6 0 0 1 .19-.41 4.1 4.1 0 0 1 2.77-.82 5.3 5.3 0 0 1 2.17.41 1.9 1.9 0 0 1 .61.41.7.7 0 0 1 .19.41h.46a1.07 1.07 0 0 0-.32-.73 4.5 4.5 0 0 0-3.11-1 5.8 5.8 0 0 0-2.35.45 2.4 2.4 0 0 0-.75.51 1.1 1.1 0 0 0-.32.73 1 1 0 0 0 .32.72 4.43 4.43 0 0 0 3.1 1 5.8 5.8 0 0 0 2.35-.45 2.3 2.3 0 0 0 .76-.52 1.06 1.06 0 0 0 .32-.72Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__polygon263"
        d="m519.16 429.72 7.19-.49 3.06 2.37-10.37-.39z"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__polygon265"
        d="m519.32 430.96.08-1.22-.24-.02.01.26-.01-.26-.26-.03-.13 1.77 11.44.43-3.78-2.93-7.51.52-.02.21.26.03.01.26 7.1-.5 2.35 1.84z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path267"
        d="M516.51 425.86c1.94.06 3.28 2.2 3 4.47s-2 4.1-3.81 3.82a1.84 1.84 0 0 1-1.62-2.25c0-.45 1-1.27 1.16-2s-.52-2.35-.29-3.1.69-1 1.56-.93Z"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__path269"
        d="M516.51 425.86v.23a2.62 2.62 0 0 1 2 1.11 4.24 4.24 0 0 1 .81 2.53 5 5 0 0 1 0 .56c-.25 2-1.74 3.67-3.22 3.65h-.33a1.61 1.61 0 0 1-1.2-.68 1.7 1.7 0 0 1-.24-1v-.35a.8.8 0 0 1 .15-.29c.14-.21.36-.48.56-.77a2.2 2.2 0 0 0 .44-.93v-.23c0-.72-.35-1.8-.35-2.49a1.2 1.2 0 0 1 0-.36 1 1 0 0 1 .39-.6 1.46 1.46 0 0 1 .79-.16h.14v-.47h-.16a1.83 1.83 0 0 0-1 .24 1.44 1.44 0 0 0-.58.85 1.6 1.6 0 0 0-.07.5c0 .81.35 1.9.35 2.49v.16a2.5 2.5 0 0 1-.55 1c-.13.18-.27.34-.37.51a1.15 1.15 0 0 0-.22.51 2 2 0 0 0 0 .39 2.25 2.25 0 0 0 .32 1.22 2.08 2.08 0 0 0 1.52.89 2.6 2.6 0 0 0 .4 0c1.82 0 3.4-1.86 3.67-4.06v-.62a4.64 4.64 0 0 0-.91-2.82 3 3 0 0 0-2.35-1.29v.24Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path271"
        d="M520.32 429.77s-.14.14 1 .64a41.4 41.4 0 0 0 6.16 1l-8.09-.22.29-1.38.68-.08Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path273"
        d="M519.41 429.91A3.6 3.6 0 0 1 519 431c-.41.83-1.43 3-3.13 2.71s-1.49-1.5-1.49-1.69v-.61l-.29 1.24.4.86.7.44 1.39.17.93-.41 1-1 .54-1 .42-1.11Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path275"
        d="M515 430.13s0 .38-1.38.43a13 13 0 0 1-3.26-.54l.64.79 1.11.29h1.38l1.08-.11.43-.88Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path277"
        d="M510.7 370.11c-.8 1.27-2.33 2.24-3.1 1.75s-.5-2.28.3-3.56 2.08-1.91 2.85-1.41.75 1.94-.05 3.22"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__path279"
        d="m510.7 370.11-.19-.13a4.8 4.8 0 0 1-1.19 1.27 2.26 2.26 0 0 1-1.23.51.7.7 0 0 1-.37-.1 1.07 1.07 0 0 1-.35-1 4.63 4.63 0 0 1 .72-2.28 2.79 2.79 0 0 1 2.05-1.48.9.9 0 0 1 .49.14 1.23 1.23 0 0 1 .45 1.08 3.6 3.6 0 0 1-.57 1.81l.19.13.19.12a3.93 3.93 0 0 0 .66-2.07 1.69 1.69 0 0 0-.67-1.47 1.4 1.4 0 0 0-.74-.21 3.24 3.24 0 0 0-2.44 1.69 5.1 5.1 0 0 0-.79 2.54 1.55 1.55 0 0 0 .56 1.35 1.2 1.2 0 0 0 .62.16 2.77 2.77 0 0 0 1.5-.59 5.1 5.1 0 0 0 1.3-1.4l-.19-.12Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__polygon281"
        d="m502.68 384.51 4.02-9.46-.6-.52-4.55 6.64z"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__polygon283"
        d="m501.26 381.13 1.4 4.1.26-.62-.24-.1.24-.09-1.09-3.21 4.32-6.3.24.2-3.94 9.29.23.11.24-.09-.24.09.24.1 4.08-9.65-.95-.82z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path285"
        d="M506 375.06c-2-1.46-2.43-2.95-1.79-4.42s2.13-.51 2.13-.51a8.6 8.6 0 0 0 1.7 1.47c.72.39 1.87-.13 2.72 1.08a1.8 1.8 0 0 1-.34 2.72 4.74 4.74 0 0 1-4.42-.34"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__path287"
        d="m506 375.06.13-.2c-1.4-1-2-2-2-3a2.8 2.8 0 0 1 .26-1.15.93.93 0 0 1 .91-.68 2 2 0 0 1 .62.13l.19.1h.06l.12-.19-.16.16a8.7 8.7 0 0 0 1.76 1.52 4.3 4.3 0 0 0 1.39.25 1.7 1.7 0 0 1 1.26.75A2.05 2.05 0 0 1 511 374a1.3 1.3 0 0 1-.65 1.2 5.1 5.1 0 0 1-1.93.38 3.78 3.78 0 0 1-2.27-.7l-.14.2-.13.18a4.26 4.26 0 0 0 2.55.79 5.3 5.3 0 0 0 2.1-.42 1.73 1.73 0 0 0 .93-1.63 2.47 2.47 0 0 0-.49-1.44 2.16 2.16 0 0 0-1.56-.94 4 4 0 0 1-1.24-.21 5.7 5.7 0 0 1-1.08-.84c-.33-.32-.56-.58-.56-.58a2.3 2.3 0 0 0-1.12-.33 1.4 1.4 0 0 0-1.34.95 3.35 3.35 0 0 0-.3 1.34c0 1.16.7 2.29 2.16 3.35l.14-.18Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path289"
        d="M510.92 373.28a1.29 1.29 0 0 1-.47 1.43 3.68 3.68 0 0 1-3.45.29 20.7 20.7 0 0 1-3-2.54l.9 1.6 1.4 1.16 2 .56 1.88-.29.85-.75.26-.6-.3-.86Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path291"
        d="M505.21 375.87a6.5 6.5 0 0 1 0 1.09 17.5 17.5 0 0 1-.39 2.29l1.71-3.81-.68-.6-.64 1Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path293"
        d="M489.29 373.82c1.42.81 2.18 2.18 1.69 3.08s-2.05 1-3.48.13-2.18-2.18-1.68-3.08 2-.95 3.47-.13"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__path295"
        d="m489.29 373.82-.12.2a3 3 0 0 1 1.73 2.27 1 1 0 0 1-.12.49 1.4 1.4 0 0 1-1.3.59 3.9 3.9 0 0 1-1.86-.54 3.06 3.06 0 0 1-1.72-2.27 1 1 0 0 1 .12-.49 1.38 1.38 0 0 1 1.29-.59 3.9 3.9 0 0 1 1.86.54zl.11-.21a4.3 4.3 0 0 0-2.09-.6 1.83 1.83 0 0 0-1.69.83 1.4 1.4 0 0 0-.18.72 3.44 3.44 0 0 0 2 2.67 4.2 4.2 0 0 0 2.08.61 1.85 1.85 0 0 0 1.7-.83 1.5 1.5 0 0 0 .18-.72 3.47 3.47 0 0 0-2-2.68z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__polygon297"
        d="m493.45 377.98 7.42 4.44-.22 3.5-8.04-6.91z"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__polygon299"
        d="m492.96 378.98.69-.83-.2-.17-.13.22.13-.22-.19-.17-1.01 1.24 8.63 7.41.25-4.17-7.73-4.65-.14.17.19.17-.13.22 7.28 4.37-.17 2.82z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path301"
        d="M493.39 378.81c-1.64 1.83-3.15 2.11-4.52 1.3s-.26-2.21-.26-2.21a8.6 8.6 0 0 0 1.63-1.55c.46-.68.09-1.9 1.37-2.62a1.75 1.75 0 0 1 2.63.66 5 5 0 0 1-.85 4.42"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__path303"
        d="m493.39 378.81-.17-.16a4.06 4.06 0 0 1-2.87 1.66 2.57 2.57 0 0 1-1.36-.41 1 1 0 0 1-.57-.87 1.6 1.6 0 0 1 .18-.68c0-.1.1-.17.13-.22v-.06l-.18-.15.13.19a8.8 8.8 0 0 0 1.69-1.61 4.2 4.2 0 0 0 .41-1.37 1.68 1.68 0 0 1 .88-1.17 2.1 2.1 0 0 1 1-.29 1.35 1.35 0 0 1 1.3.8 5.3 5.3 0 0 1 .18 1.39 4.17 4.17 0 0 1-1 2.81l.17.16.17.15a4.58 4.58 0 0 0 1.1-3.12 5.3 5.3 0 0 0-.21-1.52 1.74 1.74 0 0 0-1.73-1.13 2.55 2.55 0 0 0-1.22.33 2.15 2.15 0 0 0-1.1 1.47 4.5 4.5 0 0 1-.35 1.23 5.8 5.8 0 0 1-.95 1c-.34.3-.63.51-.63.51A2.27 2.27 0 0 0 488 379a1.45 1.45 0 0 0 .79 1.28 3.2 3.2 0 0 0 1.6.46 4.47 4.47 0 0 0 3.21-1.81l-.17-.15Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path305"
        d="M494.65 378.85s-.26-.26.25.87 4.68 5.14 4.68 5.14l-6.64-5.61.77-1.09z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path307"
        d="M492.44 379.5a4.2 4.2 0 0 1-1.62.57c-.77 0-2.05-.05-2.22-1a1.39 1.39 0 0 1 .26-1.29l-.55 1.25.21.69 1 .57 1.36.13 1.24-.61.34-.35Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path309"
        d="M489.75 376.65s.09.26-1.15.09a6.66 6.66 0 0 1-2.72-1.6l1 1.55 2.08.87.81-.91Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path311"
        d="M612.84 485.57s.79-2.23 6.16-4.85 13.44-6.16 14.21-5.71-.42 3.37-.42 3.37l-5.2 1.59-4.15 2.43-4.85 3.14h-5.75Z"
        className="Mexico_svg__cls-18"
      />
      <path
        id="Mexico_svg__path313"
        d="M626.52 471.46a43.1 43.1 0 0 0-11.91 2.21c-.46.09-1.44.79-2.29.37a9.65 9.65 0 0 1-3-3l-1.45-1.21-.34 4.92-10-8.68-1.06 5.74-1.28 2.64-9.92-9.38.47 7.26a27 27 0 0 1-2.73.26l-7.07-4.93-2.08.7 2.3 4.27-8.95.7a11.2 11.2 0 0 0-1.93 1.5 12.3 12.3 0 0 0-1.89 2.17s-.27.46 0 .67a8.6 8.6 0 0 0 3.53-.13c.77-.29 1.26-1.36 1.49-.92s.51 2.4 1.69 2.2 5.34-3.34 8.3-2c3.3 1.54-4.28 3.78-3.5 6.12s6.25 1.35 7.64.6 5.53-5.92 7.23-3.95c2.36 2.74-5 4.86-3.61 7.59s5.4 2 7.38.91 6.58-8.21 7.6-6.69c1.77 2.66-3.88 5.19-2.46 7.24s4.55-.07 6.63-1.54 2.9-4.92 5.77-6.54 2.68-.94 3.47-1 3-2.24 3-2.24l6.75-2.86 3.31.24 1.71.81 3.38.47.4-2.86s-3.92-1.83-6.64-1.73Zm-54.06.06 1.43-2.54-.81-1.23a23.2 23.2 0 0 1-4.55-3.54c-2.18-2.21-3-2.71-4-3.21s-4.35-2.68-4.35-2.68l-1.5-5.56-.9-1.61-2.58 1-3.39-12-.67-2.14-1.4-.09-2.74 7.29-3.11-4.53-.8-9.92-1.94 2.17-2.5 2.54-4.44-9s-.37-.23-.59.52a16 16 0 0 0-.33 5.25 49 49 0 0 1-6-4.5c-4.51-3.88-5.6-5.88-5.6-5.88l-2.11-4.76 2-4.18 1-5-4.34 1.78-.77-11.28-.67-3.56-5.23 7.49a28 28 0 0 1-2.05-3.21c0-.32.1-7.13.1-7.13l-1.41-.42-2.14 4s-2.06-4.15-3-5a25.2 25.2 0 0 0-.58-8.8c-1.22-4-2.65-6.13-2.14-9.39s1.83-3.57 1.68-5-2.3.94-1.58-1 7.56-6.27 6.13-8.55-8 3.58-6.49-.36 7.87-4 8.23-9.49c.22-3.42-6 2.13-6.54.42s3.83-5.23 3.78-7.46.82-2.49-.41-3.68-5 4.66-5 4.66l-4.15-1.56-1.43 5.92-1.27 5-5.11-3 1.37 6.11 1.23 6-5.31-1.35 2.81 5.07 3.66 3.72 2.26 3.07 1.64.88 2.2 2.18.76 3.27s1.28 3.58 1.28 3.73.21 3.52.21 3.52l.05 2.33-.12 1.81-.08.68-.11.78v2.14c-1 .09-2.63-1.53-3.22-.52s3.07 4 2.37 4.66-6.14-1.1-6.45.65.51 4.21 3.64 5 10.41 2.46 9.19 3.89-9.13-4.34-8.81-.13a7.44 7.44 0 0 0 5.11 6.74c2 .78 10-.13 9.58 1.75s-6.52-.59-7.09 2.13 4.22 3.11 5.24 3.11 4.34-.12 5.62.85 5.74 5.7 8.56 8.1c2.38 2 7.53 5.6 9 6.63h-.08c-1.51-.14-4.65-.47-5.14.66-.64 1.46 12 6 8.38 7.37s-7.54-3.87-8.59-.65 2.4 5.92 4.37 7.09 13.18.24 11 2.77-10.32-1.71-10.4 1.31 5.42 7.77 8.23 7.64 5.9-4.64 7.17-2.2-2.17 3.42.54 4.07 4.62-2.78 7.77-2.16 8.07 2.62 10.83 5.13 5.59 5.42 5.59 5.42Z"
        className="Mexico_svg__cls-18"
      />
      <path
        id="Mexico_svg__path315"
        d="M616.12 484.18c1.92 0 2.17 1.07 2.43 1s3.48-2.78 6.54-4.47a34.7 34.7 0 0 1 7.73-2.68l.29.42s-5.55 1.38-8.24 3.27c-3.32 2.33-5.94 3.79-6.1 4.21s-1.37 1.23-3.25 1.27-2.69-1.1-2.69-1.66 1.38-1.42 3.29-1.39Zm16.73-8.48a3.92 3.92 0 0 1-2.59-.65 8.54 8.54 0 0 0-5-1.55 12.3 12.3 0 0 0-7.74 3.53 10.9 10.9 0 0 1-2.9 2.6c.76.15 2.23-.86 3.83-2.16a14.4 14.4 0 0 1 7.24-2.67c2-.31 3.32.86 4.26 1.5a5.4 5.4 0 0 0 2.85.47l.08-1.07Zm-99.33-40.59c.21-.09.18-.54 0-1.33a30 30 0 0 1-4.32-2.29c-3.26-1.94-10-7.33-10-7.33s2.82 2.73 5.63 5.26a68.6 68.6 0 0 0 7.85 5.63 3.7 3.7 0 0 0 .8 0Zm70.13 49.67s1-1.34 2.84-4.27a17.3 17.3 0 0 1 3.73-4.22c.26-.35-.7-1.78-1.24-2.88a5.06 5.06 0 0 1-.45-2.36 8 8 0 0 0 2 2.72 19 19 0 0 1 2.15 1.84s2.67-.36 2.74-.87a.9.9 0 0 0-.51-1.07c-.45-.2-1 .4-2.17-.14-2.53-1.09-3.55-4.92-5-5s-.43 4-1.09 4.12c-2.33.22-4.15-8.49-9.74-8.85-3.93-.25-4.63.49-4.82 1.36s4.76 6.1 3.1 6.84-6.93-8.2-10.76-8.3-4.15 1.37-3.87 2.21 4.25 1.58 3.33 4.37-4.76-4.17-8.3-3.79-3.93.65-4.1 1.65 1.25 2.46.74 2.82-2.75.26-4.53 1.49a26.2 26.2 0 0 0-4.28 4.6s2.33-3.3 5.42-3.66a105 105 0 0 1 10.93 0 17 17 0 0 1-2.21-1.69 12.4 12.4 0 0 1-2.14-3.14s1.73 1.62 3.39 3a23 23 0 0 0 3.74 2.4s3.32.32 3.54.71-.1 1.16-1.47 2.65-3.35 3.25-3.35 3.25 3.32-2.53 4-3.08 2.94-2.3 2.94-2.3 2.42.32 2.68.26.14-.91-1.49-3.31-3.17-5-3.17-5a37.6 37.6 0 0 1 4 4.51c2 2.66 1.72 3.89 2.55 4a20 20 0 0 0 2.78.28c.82 0 .61 1.16-.8 3.3a22 22 0 0 0-2.23 4.89 27.4 27.4 0 0 1 3-3.89c1.53-1.58 2.33-3.47 2.94-3.56s2.66.16 3 0-.5-1-1.58-3.19a18.8 18.8 0 0 1-1.44-5.24 20.6 20.6 0 0 0 2.72 4.92c1.66 2.07 2.3 3.74 2.66 3.77s1.64-.15 2.57-.14c.47 0 .53-.1.58.19.16.92-.23 1.46-1.34 3.57a34 34 0 0 0-1.85 4.18Zm-42.41-24.59a12.5 12.5 0 0 0 3.32.81s-3.29-1.94-4.15-4.7-.1-8.55-1.5-8.49-2.21 4.28-3.61 3.44.48-8.59-1.06-11.89-5.13-5.61-6-4.41-.63 8.33-2.87 6.78.19-7.65-.48-10.44-2.36-4.79-3.64-4.11.51 5.9-1.5 6-1.72-3.66-2.59-4-1.15.75-1.63 0-.22-3.37-1.27-3.12-.86 2.31-.58 3.44a17 17 0 0 0 1.37 3.5c.45.74 2 1.68 1.92 2.3s-1 1.14-2 1.17-3.55-.07-3.55-.07a31 31 0 0 0 3.61.91c1 .09 2.91-.42 3.38.45s2.78 4 2.78 4a23 23 0 0 0 .83-4.48 39 39 0 0 0 .16-5.34 25 25 0 0 1 .67 5.28A58 58 0 0 1 542 443s2.17 1.81 1.54 2.3-2.91.43-5.56.39a36 36 0 0 1-6.42-.94 27.7 27.7 0 0 0 5.75 2c2.36.39 7.5.52 7.5.52l3.51 4a15.9 15.9 0 0 0 1.92-5.76 42 42 0 0 0-.06-6.21 35.6 35.6 0 0 1 .86 5.56 23.8 23.8 0 0 1-1.15 7.48 9.7 9.7 0 0 1-3.69 1.9c-2.32.59-7 1.18-7 1.18a24.8 24.8 0 0 0 7.37-.16c3.09-.73 3.45-1.59 4.31-1.07a7.4 7.4 0 0 1 1.63 1.46 22 22 0 0 0 2.69 1.81c.13.29-1.43.93-2.22 1.43s-2.86 1.46-2.86 1.46 3-1.11 4.37-1.46c.67-.18 2.3-.78 2.3-.78l.9.49a13 13 0 0 0-.19-2.46 58 58 0 0 0-.64-3.57 11.4 11.4 0 0 1 1.37 3.21 18 18 0 0 1 .32 3.14s.25.45 2.65 1.26Zm-61.18-70.1a39.3 39.3 0 0 0 .68-7.09c0-3.8-2.64-9.68-3.07-10.28a11 11 0 0 1-.68-1.13l1.79-2.75-2.3 1.8a8.4 8.4 0 0 1-2.39-.94 5.2 5.2 0 0 1-1.66-1.73 13.3 13.3 0 0 0 2.3 1.34c1.13.46 1.41.3 1.41.3l-.89-3.83a39 39 0 0 1-3.78-1.92 27.4 27.4 0 0 1-5-3.73 59 59 0 0 0 5.52 2.95 10.4 10.4 0 0 0 3.12.88 18.6 18.6 0 0 0 3.17-1.25c1.07-.62 3.27-2.28 3.27-2.28a16.8 16.8 0 0 1-3.48 1.51c-1.38.31-3.11.51-3.11.51l-.62-4.66s-.46 0-2.19-2.28a28.6 28.6 0 0 1-3.07-5.54 24 24 0 0 0 3.22 3.36 17.8 17.8 0 0 1 2.76 2.85s1.63-.88 3.22-2 5.51-3.94 5.51-3.94-2.24 1.19-5.36 2.64-3.22 1.3-3.22 1.3a6.9 6.9 0 0 1 .21-2.91c.46-.88 1.43-2.33 1.27-3.21s-.81-.57-1.07-1.29.82-5.18.82-5.18.25 1.6.31 2.43-.41 2 .71 2 6.39-5.29 7.05-6.28 1.64-3.67-1.13-2.58-2.09 3.44-4.39 3.26c-.66-.05-1.43-3-2.3-2.28s-2.81 2.54-3.17 4.61.47 5.24-.71 6.17-2.2-3.58-4.5-3-2.81 3.79-2.45 5 5.37 7.05 3.78 7.78-5.47-4.93-7.56-1.09 6.59 7.77 7.66 8.71.11 1.19 1.64 3.11 3.58 2.38 4.65 3.68 4.24 7.46 4.24 11.45a38 38 0 0 1-.25 5.45Zm23.07 33.64a8.3 8.3 0 0 1-1.42-6.56c.7-4.08 3.51-11.28 2.55-12.18s-4 4.4-4.73 3.17 1.73-8.42.45-11.4-1.4-4.86-4-4.6-3.64 8.68-4.85 7.19.7-5.24-.13-7.25-1.28-2.73-2.55-2.41-1.86 4.22-2.75 4.15-2.36-4.67-4.22-4 4.41 8.81 4.41 8.81a7 7 0 0 0 1.69-2.37c.58-1.39 1.15-2.91 1.15-2.91s.51 2.65.07 3.69a19.4 19.4 0 0 0-.8 3.47 9.8 9.8 0 0 1-4.06.09 17.3 17.3 0 0 1-4.6-1.42 15.3 15.3 0 0 0 4.28 1.81c2.59.68 5.34 1.53 5.34 1.53s.67.84 1.82 2.36l2.14 2.82a31 31 0 0 0 1.47-4.12c.73-2.55 2.49-6.76 2.49-6.76s-.55 5.08-1.15 7.57-1.25 6-1.25 6-2.24-.22-5.24-.78-7.09-1.58-7.09-1.58a73 73 0 0 0 7.06 2.36l5.69 1.59 2.74 3.61s.75-1.32 1.83-2.83a20.2 20.2 0 0 0 1.92-3.61 20.5 20.5 0 0 1-1.31 4.51c-.83 1.68-1.41 2.69-1.41 2.69a15.2 15.2 0 0 1-3.38.38c-1.63 0-4.95-.06-4.95-.06a38 38 0 0 0 5 1.3c2.2.35 3.8.58 3.8.58a7.5 7.5 0 0 0 1.34 2.69 9.05 9.05 0 0 0 2.67 2.51Z"
        className="Mexico_svg__cls-19"
      />
      <path
        id="Mexico_svg__path317"
        d="M628.06 497.36a12.2 12.2 0 0 0-2.9-2.21c-1.66-.87-2.22-.62-2.22-.62l-.77-.27 1.46-3.79L634.56 480l1.7-10.5h.4l6.34-.07-.07 14.34 2 .91 12.22 7.32v3.18s-.61.22-1.79.68a3.85 3.85 0 0 0-1.46.82l-4.61.43-8-5.83-3.32-3.49-6.06 7.77-3.76 1.79Z"
        className="Mexico_svg__cls-1"
      />
      <path
        id="Mexico_svg__path319"
        d="M636.66 469.51a9.8 9.8 0 0 0-.26 2.17c-.08 1.61.11 10.08-.3 11.24s-6.3 3.58-9.67 6.51-3.49 5.1-3.49 5.1a13.4 13.4 0 0 0-3.19.87 7.3 7.3 0 0 0-3 1.94 21.7 21.7 0 0 1 6.69-10.06c5.45-4.85 8.09-5.25 8.69-6.07s0-10.07.13-10.82.78-.81 1.23-.87 3.2 0 3.2 0Z"
        className="Mexico_svg__cls-20"
      />
      <path
        id="Mexico_svg__path321"
        d="M650.57 500.45a13.7 13.7 0 0 1 1.43-2.25 20 20 0 0 1 1.87-1.51s.21-.21-2.77-1.51-4.51-.87-6.64-2.37a26.7 26.7 0 0 1-4.26-4.11l-2.85 2.55a33 33 0 0 0 3.32 4c1.61 1.55 5.28 2.08 6.9 3a17.7 17.7 0 0 1 3 2.2"
        className="Mexico_svg__cls-20"
      />
      <path
        id="Mexico_svg__path323"
        d="M642 469.44s3.23-.19 3.68.31a1.8 1.8 0 0 1 .4 1.22c0 .15.17 7.83-.4 10.35a15.6 15.6 0 0 1-2.73 6c-.77.78-5.62 5-7.92 7.26a52 52 0 0 0-4.64 5.45s-.85-1-1.57-1.87-1.46-1.2-1.28-1.81a20.1 20.1 0 0 1 6.47-6.78c3.87-2.55 7.11-5.44 7.83-9.59a51.2 51.2 0 0 0 .16-10.58Z"
        className="Mexico_svg__cls-21"
      />
      <path
        id="Mexico_svg__path325"
        d="M663.57 495.65s-.78-.78-3.5-.83-3 .37-3 .37a18 18 0 0 0-3.91-3.47c-2.42-1.57-4.24-1.34-6.83-3.05a13.25 13.25 0 0 1-4-4.2l2-4.07a25.4 25.4 0 0 0 4.55 4.86c2.32 1.7 7.47 3.37 9.11 4.81s5.51 5.58 5.51 5.58Z"
        className="Mexico_svg__cls-21"
      />
      <path
        id="Mexico_svg__path327"
        d="M688.08 449.18s-7-2.73-6.51-5.19 16.22-6.61 16.22-6.61l.26-4.14a19 19 0 0 0-6.26 1.16 55.8 55.8 0 0 1-17 3 27.2 27.2 0 0 1-7.45-.76c-.73-.22-55.4-3.44-57.18-3.42-.77 0-1.75 0-3-.09-7.28-.52-12-11.66-12-11.66l-3.45.6s1.06 5.47-.77 6c-3.57.95-27.33-11.75-27.33-11.75l-1.31 5.15s14.52 7.77 14.09 10.66-4.75 2.67-4.75 2.67l1.85 3.46c.65.06 23.91 1.18 24.31 8.17.16 2.82-5.71 4.49-5.71 4.49l2 2.39v1.19s12.92.07 16.5 2.07 5.39 4.89 9.78 7.4 34.11 1.91 38.75.6c5.26-1.48 8.48-7.43 17-10s11.3-2.72 11.3-2.72l.63-2.59Z"
        style={{
          fill: "#30c2dc",
        }}
      />
      <path
        id="Mexico_svg__path329"
        d="m688.08 449.18.18-.49-.26-.11a25.5 25.5 0 0 1-3.53-1.78 9.2 9.2 0 0 1-1.76-1.35 1.9 1.9 0 0 1-.66-1.2v-.15a.65.65 0 0 1 .15-.25 4.6 4.6 0 0 1 1.17-.86 50.7 50.7 0 0 1 8.76-3.43c1.57-.49 3-.91 4.06-1.21l1.71-.47.36-.09.31-5h-.73a21.1 21.1 0 0 0-6.24 1.19 55 55 0 0 1-16.82 3 25.7 25.7 0 0 1-7.3-.75h-.16c-.33 0-1.39-.13-3.07-.24-5.83-.4-18.88-1.19-30.7-1.88-5.91-.35-11.51-.67-15.76-.9l-5.22-.28c-1.31-.07-2.14-.1-2.4-.1v.51-.51h-.36c-.69 0-1.55 0-2.58-.1a8.73 8.73 0 0 1-4.67-1.94 21.9 21.9 0 0 1-5-5.93c-.59-1-1-1.85-1.36-2.48-.16-.31-.28-.56-.36-.74l-.11-.27-.16-.37-4.36.76.1.53.05.25a17.6 17.6 0 0 1 .24 2.76 5.5 5.5 0 0 1-.19 1.68 1.4 1.4 0 0 1-.24.48.4.4 0 0 1-.25.18 1.3 1.3 0 0 1-.34 0 9.4 9.4 0 0 1-2.39-.49 121 121 0 0 1-14.87-6.46c-2.58-1.27-4.92-2.47-6.62-3.34l-2.75-1.45-.57-.31-1.57 6.18.35.19.6.33c1.34.74 4.71 2.63 7.72 4.65a37 37 0 0 1 3.95 3 9.2 9.2 0 0 1 1.18 1.28 1.67 1.67 0 0 1 .38.82V432a2.08 2.08 0 0 1-.59 1.18 3.86 3.86 0 0 1-1.83.87 7.2 7.2 0 0 1-1.61.18h-1.09l2.41 4.53h.28c.1 0 .52 0 1.22.08a87.5 87.5 0 0 1 13.17 1.87 25.8 25.8 0 0 1 6.64 2.35 7.4 7.4 0 0 1 2 1.59 3 3 0 0 1 .77 1.78v.09a2.15 2.15 0 0 1-.74 1.47 9.4 9.4 0 0 1-2.85 1.77c-.48.21-.92.37-1.24.48l-.37.12h-.13l-.76.22 2.34 2.86V455h2.57c1.89.06 4.82.19 7.59.49 1.39.16 2.73.35 3.89.59a10.7 10.7 0 0 1 2.71.89 25.2 25.2 0 0 1 4.5 3.44 30 30 0 0 0 5.27 4 9.4 9.4 0 0 0 2.89.86 110.6 110.6 0 0 0 16.56.94c4.31 0 8.62-.12 12.15-.33 1.77-.1 3.35-.22 4.63-.36a20 20 0 0 0 2.92-.47c2.77-.79 4.94-2.7 7.45-4.68a28 28 0 0 1 9.58-5.34c4.26-1.29 7.07-2 8.8-2.32.87-.17 1.47-.27 1.85-.32h.9l.83-3.42-.43-.17-.18.5-.5-.13-.62 2.6.5.12v-.52c-.06 0-2.85.14-11.42 2.74a29.2 29.2 0 0 0-9.91 5.51c-2.54 2-4.62 3.81-7.1 4.51a20 20 0 0 1-2.75.43c-3.78.41-10.24.68-16.67.68-4.26 0-8.5-.11-11.94-.39-1.72-.14-3.24-.31-4.45-.53a8.6 8.6 0 0 1-2.55-.74 29 29 0 0 1-5.11-3.84 27.2 27.2 0 0 0-4.68-3.57 14.6 14.6 0 0 0-4.25-1.22 96 96 0 0 0-12.49-.91v.51h.51v-1.37l-2.07-2.53-.4.33.14.5a17.7 17.7 0 0 0 3-1.2 8.5 8.5 0 0 0 2.09-1.47 3.15 3.15 0 0 0 1-2.21v-.14a4.2 4.2 0 0 0-1.28-2.69 14.3 14.3 0 0 0-5.74-3.1 62 62 0 0 0-11.4-2.29c-1.75-.21-3.29-.35-4.42-.44s-1.86-.13-1.94-.13v.51l.36-.32-1.85-3.46-.45.25v.51h.24a8.2 8.2 0 0 0 2.62-.43 4 4 0 0 0 1.52-.92 3 3 0 0 0 .9-1.77v-.21a2.76 2.76 0 0 0-.71-1.63 18.7 18.7 0 0 0-3.35-3A101 101 0 0 0 562.6 421l-.24.46.49.12 1.31-5.15-.49-.12-.24.45s5.53 3 11.65 5.92c3.07 1.47 6.29 2.95 9 4.07 1.38.55 2.65 1 3.73 1.35a10.8 10.8 0 0 0 2.68.53 2.3 2.3 0 0 0 .59-.07 1.53 1.53 0 0 0 .79-.53 3 3 0 0 0 .54-1.3 8.4 8.4 0 0 0 .12-1.52 20 20 0 0 0-.31-3.22l-.5.11.09.5 3.44-.6-.08-.51-.47.2a31.3 31.3 0 0 0 3.31 5.74 20 20 0 0 0 3.87 4.1 9.87 9.87 0 0 0 5.21 2.14c1.06.07 1.94.1 2.66.1h.38c.24 0 1.34 0 3 .14 5.92.3 19.3 1.07 31.26 1.79 6 .36 11.61.7 15.79 1l5 .34 1.44.11h.51v-.32l-.09.31v-.32l-.09.31a27 27 0 0 0 7.6.79 56.4 56.4 0 0 0 17.14-3 20 20 0 0 1 5.92-1.14h.39v-.52h-.51l-.25 4.15h.51l-.13-.5s-3.94 1-7.95 2.39a54 54 0 0 0-5.61 2.18 12 12 0 0 0-2 1.13 3.5 3.5 0 0 0-.66.59 1.4 1.4 0 0 0-.38.71 1.6 1.6 0 0 0 0 .37 2.3 2.3 0 0 0 .35 1.17 6.4 6.4 0 0 0 1.64 1.66 25 25 0 0 0 4.88 2.58l.18-.48-.5-.13.5.13Z"
        className="Mexico_svg__cls-23"
      />
      <path
        id="Mexico_svg__path331"
        d="M573.24 438a4.09 4.09 0 1 1-4.08-4.14 4.12 4.12 0 0 1 4.08 4.14"
        className="Mexico_svg__cls-1"
      />
      <path
        id="Mexico_svg__path333"
        d="M573.24 438h-1a3.07 3.07 0 1 1-3.06-3.1 3.1 3.1 0 0 1 3.06 3.1h2a5.11 5.11 0 1 0-5.11 5.19 5.15 5.15 0 0 0 5.11-5.19Z"
        className="Mexico_svg__cls-23"
      />
      <path
        id="Mexico_svg__path335"
        d="M596.75 418.85a4.09 4.09 0 1 1-4.09-4.14 4.12 4.12 0 0 1 4.09 4.14"
        className="Mexico_svg__cls-1"
      />
      <path
        id="Mexico_svg__path337"
        d="M596.75 418.85h-1a3.07 3.07 0 1 1-3.07-3.11 3.1 3.1 0 0 1 3.07 3.11h2a5.11 5.11 0 1 0-5.11 5.18 5.15 5.15 0 0 0 5.11-5.18Z"
        className="Mexico_svg__cls-23"
      />
      <path
        id="Mexico_svg__path339"
        d="M695.41 449.57a4.2 4.2 0 1 1-4.2-4.25 4.23 4.23 0 0 1 4.2 4.25"
        className="Mexico_svg__cls-1"
      />
      <path
        id="Mexico_svg__path341"
        d="M695.41 449.57h-1a3.18 3.18 0 1 1-3.18-3.22 3.22 3.22 0 0 1 3.18 3.22h2a5.22 5.22 0 1 0-5.22 5.29 5.26 5.26 0 0 0 5.22-5.29Z"
        className="Mexico_svg__cls-23"
      />
      <path
        id="Mexico_svg__path343"
        d="M550.71 412.7c-1.34 3.11 4 9 7.66 9.65s5.75-.25 6.39-2.07a5.54 5.54 0 0 0-.7-4.92c-2.37-3.18-12-5.77-13.35-2.66"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path345"
        d="M562.39 417.43c-.1-1.88-3.19-3.7-5.17-3.7s-4-.06-3.64 1 5.43 2.4 5.55 3-1.53 1.29-.7 2.07 1.85.2 2.68-.39 1.34-.78 1.28-1.94Z"
        className="Mexico_svg__cls-1"
      />
      <path
        id="Mexico_svg__path347"
        d="M595.09 452.94c.85 2.74-1.28 4.08-4 5.31s-8.37.52-9.65-1.68 2.05-5.77 5.43-6.61 7.47.52 8.24 3Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path349"
        d="M589.4 454.55c1.08-.18 1.09 1.63 2.05 1.49s1.78-1.68 1.53-2.72a3.93 3.93 0 0 0-3.58-2.32c-1.53.13-6.06 3.95-5.55 5s1.53.9 2.36.52 2-1.75 3.19-1.95Z"
        className="Mexico_svg__cls-1"
      />
      <path
        id="Mexico_svg__path351"
        d="M696.51 438.76c2.49 3.31 7 .26 8.17-1s4.86-3.41 3.37-5.57-4-2-5.75-1.91-5.2 2.6-5.79 3.76-1.11 3.29 0 4.75Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path353"
        d="M697.32 436.57s.22-3.61 3.58-3.76c1.92-.09 2 .52 3.45 1.34s2-1.08 2-1.08.09 2.55-2.25 2.63-1.5-1-3.79-1.38c-2-.31-3 2.25-3 2.25Z"
        className="Mexico_svg__cls-1"
      />
      <path
        id="Mexico_svg__path355"
        d="m642.65 429.56-1.65-1.07s-3.32-.17-5.58-.13-6.72.26-6.72.26l6.67 19.38 8 11.53 3.07 1.11 6.22-.42 1.06-3-2.34-18.7-8.73-8.95Z"
        className="Mexico_svg__cls-24"
      />
      <path
        id="Mexico_svg__path357"
        d="m642.65 429.56.28-.43-1.66-1.08-.27-.05s-2.64-.14-4.83-.14h-.79c-2.27 0-6.74.26-6.74.26a.53.53 0 0 0-.4.22.54.54 0 0 0-.06.46l6.69 19.4.06.13 8 11.53a.53.53 0 0 0 .25.19l3.06 1.1h.2l6.22-.42a.52.52 0 0 0 .45-.34l1.06-3v-.23l-2.35-18.71a.5.5 0 0 0-.14-.3L643 429.2l-.08-.07-.28.43-.37.37 8.62 8.82 2.3 18.4-.91 2.59-5.78.38-2.81-1-7.87-11.34-6.66-19.32-.48.17v.52l2.52-.12c1.4-.06 3.08-.12 4.2-.14h.77c1.07 0 2.26 0 3.19.07s1.64.04 1.64.04v-.53l-.28.44 1.67 1.08.27-.44-.37.37.37-.37Z"
        className="Mexico_svg__cls-25"
      />
      <path
        id="Mexico_svg__path359"
        d="m620.57 430.77.32-2.2s1.52-.19 3.62-.25a14 14 0 0 1 4.18.3c.22.16 4.66 5.59 6.19 9.15s3.32 9.53 5.3 13.16 6.26 9.72 6.26 9.72-2.14.12-4 .12-4 .07-4 .07l-3.59-1.39-11.28-17.53z"
        className="Mexico_svg__cls-24"
      />
      <path
        id="Mexico_svg__path361"
        d="m620.57 430.77.51.08.32-2.2-.51-.08.07.52h.26c.51-.05 1.75-.17 3.31-.22h.79c.85 0 1.63 0 2.21.1a6 6 0 0 1 .7.1h.19l.1-.25-.15.22h.05l.1-.25-.15.22.21-.3-.24.27.21-.3-.24.27.28.33c1.09 1.28 4.52 5.71 5.77 8.64.76 1.75 1.58 4.14 2.48 6.53a54 54 0 0 0 2.85 6.67c2 3.68 6.28 9.76 6.29 9.77l.41-.3v-.52l-1.29.06c-.77 0-1.77.06-2.7.06-1.9 0-4 .07-4 .07v.52l.18-.48-3.39-1.3-11.14-17.3-3-11.06-.5.13.51.08-.51-.08-.49.14 3 11.15.07.14 11.27 17.53a.55.55 0 0 0 .25.2l3.58 1.4h4.17c1.9 0 4.05-.12 4.05-.12a.52.52 0 0 0 .38-.83l-.69-1c-1.29-1.88-4.07-6-5.53-8.67a51 51 0 0 1-2.79-6.53c-.88-2.38-1.71-4.76-2.49-6.57a34.8 34.8 0 0 0-3.65-6c-.67-.92-1.3-1.73-1.77-2.32l-.59-.72-.19-.22-.07-.07-.1-.09a1 1 0 0 0-.28-.13 7.7 7.7 0 0 0-1.3-.19c-.59-.06-1.3-.08-2.08-.08h-.82c-2.13.07-3.66.26-3.67.27a.51.51 0 0 0-.44.44l-.32 2.2v.21l.49-.13Z"
        className="Mexico_svg__cls-25"
      />
      <path
        id="Mexico_svg__path363"
        d="M615.87 428.4s4.6-.09 5 .17a27.64 27.64 0 0 1 7.6 10.43c2 5.61 1 6.39 3.67 12.18a38.9 38.9 0 0 0 6.3 9.67s-7.66.44-12-.34-5.87-.69-6.9-1.9a18.3 18.3 0 0 0-3.4-2.68h-4.34l1-6.05-1.19-13.56.26-7 4-.91Z"
        className="Mexico_svg__cls-24"
      />
      <path
        id="Mexico_svg__path365"
        d="M615.87 428.4v.52h3.72c.31 0 .59 0 .79.06h.24l.06-.19-.11.17.06-.19-.11.17s.17.14.36.3c1.31 1.14 5.31 5.16 7 9.85a35 35 0 0 1 1.58 5.95 26 26 0 0 0 2.1 6.27 39.5 39.5 0 0 0 6.39 9.81l.37-.35v-.52l-1.38.06c-.86 0-2 .06-3.37.06a46 46 0 0 1-7.14-.46c-2.18-.39-3.67-.57-4.68-.78a5.2 5.2 0 0 1-1.19-.38 2 2 0 0 1-.73-.57 12.7 12.7 0 0 0-2.18-1.87c-.74-.53-1.34-.91-1.35-.91a.5.5 0 0 0-.26-.07h-3.74l.92-5.44v-.14l-1.19-13.53.23-6.57 3.63-.82-.12-.5-.11-.51-4 .91a.51.51 0 0 0-.4.48l-.26 7v.07l1.19 13.49-1 6a.52.52 0 0 0 .11.42.51.51 0 0 0 .39.19h4.34v-.52l-.26.45.38.23a16 16 0 0 1 2.91 2.34 3.2 3.2 0 0 0 1.06.83c1.24.59 2.89.65 6.13 1.24a46 46 0 0 0 7.31.48c2.68 0 4.81-.13 4.82-.13a.5.5 0 0 0 .44-.32.53.53 0 0 0-.1-.55l-.16-.17a39.8 39.8 0 0 1-6-9.36 24.9 24.9 0 0 1-2-6.05 37.4 37.4 0 0 0-1.63-6.1 25.4 25.4 0 0 0-4.49-7.37 31 31 0 0 0-2.15-2.29c-.29-.28-.54-.5-.73-.67l-.25-.21-.18-.13a.9.9 0 0 0-.32-.12 10 10 0 0 0-1.45-.12h-3.63l.11.51Z"
        className="Mexico_svg__cls-25"
      />
      <path
        id="Mexico_svg__path367"
        d="m661.86 432-7.33-3-13.62-.69s.5 3.63 1 7 2.9 11.31 5.11 15.2 4.43 8.64 5.62 9.76 9-2.11 9-2.11l5.11-.78-.68-5.58-.73-1.72 1.2-15.85-1.12-2.46-3.61.25Z"
        className="Mexico_svg__cls-24"
      />
      <path
        id="Mexico_svg__path369"
        d="m661.86 432 .19-.48-7.32-3h-.17l-13.63-.69a.5.5 0 0 0-.4.16.57.57 0 0 0-.13.42s.51 3.64 1 7 2.9 11.38 5.18 15.38c1.1 1.94 2.2 4.09 3.18 5.91.49.91 1 1.74 1.37 2.42a9 9 0 0 0 1.16 1.56 1.36 1.36 0 0 0 .6.3 2.8 2.8 0 0 0 .67.07 10.8 10.8 0 0 0 2.41-.38 53 53 0 0 0 5.89-2l-.19-.48.07.5 5.11-.77a.51.51 0 0 0 .43-.57l-.68-5.58v-.14l-.68-1.61 1.18-15.73v-.25l-1.11-2.46a.52.52 0 0 0-.5-.31l-3.62.26v.52l.19-.48-.19.48v.53l3.27-.24.9 2-1.16 15.66v.24l.7 1.67.61 5-4.62.7h-.12l-.91.36c-.85.33-2.19.82-3.52 1.24a14.8 14.8 0 0 1-3.48.72 2.2 2.2 0 0 1-.43 0l-.15-.06a8.3 8.3 0 0 1-1-1.35c-1.2-1.95-2.87-5.36-4.54-8.3-2.16-3.77-4.56-11.75-5.05-15-.25-1.68-.51-3.43-.7-4.76l-.32-2.23-.5.07v.52l13.54.69 7.24 3h.23v-.53Z"
        className="Mexico_svg__cls-25"
      />
      <path
        id="Mexico_svg__path371"
        d="M613.65 432.07c0 1.73 1.84 1.82 2.3 1.73a2.79 2.79 0 0 0 2-3c0-2.33-1.45-4.14-4.3-4.31s-5 3.41-5 5.83 2.43 3.67 2.43 4.58a8.4 8.4 0 0 0-2.3 6.17c.13 3.94 3.32 7 3.32 7s-3.41 2.72-3.41 5.44 2.6 4.53 5 4.53 5.53-1.55 5.53-3.62a3.38 3.38 0 0 0-3.36-3.32c-1.53 0-2.17.9-2.17 1.59"
        className="Mexico_svg__cls-24"
      />
      <path
        id="Mexico_svg__path373"
        d="M613.15 432.07a2.3 2.3 0 0 0 .28 1.15 2.13 2.13 0 0 0 1.12.92 3 3 0 0 0 1.11.2 2 2 0 0 0 .39 0 3.07 3.07 0 0 0 1.47-.81 3.72 3.72 0 0 0 1-2.73 4.72 4.72 0 0 0-1.22-3.32 5.13 5.13 0 0 0-3.56-1.51h-.23a5 5 0 0 0-3.85 2.24 7.34 7.34 0 0 0-1.48 4.12 4.94 4.94 0 0 0 1.33 3.19c.32.38.62.7.83 1a3 3 0 0 1 .22.31v.09h.51l-.34-.39a7.6 7.6 0 0 0-1.25 1.66 9.2 9.2 0 0 0-1.22 4.61v.31a10.35 10.35 0 0 0 1.8 5.22 12.2 12.2 0 0 0 1.69 2.1l.35-.38-.32-.4a12.3 12.3 0 0 0-1.78 1.76 6.82 6.82 0 0 0-1.82 4.08 4.76 4.76 0 0 0 1.79 3.69 6 6 0 0 0 3.74 1.36 8 8 0 0 0 3.94-1.1 5.3 5.3 0 0 0 1.48-1.28 2.93 2.93 0 0 0 .63-1.76 3.8 3.8 0 0 0-1.28-2.84 4 4 0 0 0-2.6-1 3 3 0 0 0-2 .66 2 2 0 0 0-.69 1.45.51.51 0 0 0 .51.52.51.51 0 0 0 .51-.52.94.94 0 0 1 .34-.67 2 2 0 0 1 1.32-.41 3.06 3.06 0 0 1 1.93.76 2.72 2.72 0 0 1 .93 2.05 1.8 1.8 0 0 1-.42 1.12 4.74 4.74 0 0 1-2 1.43 7.1 7.1 0 0 1-2.62.56 5 5 0 0 1-3.09-1.13 3.71 3.71 0 0 1-1.42-2.89 5.86 5.86 0 0 1 1.58-3.4 12 12 0 0 1 1.13-1.19 4 4 0 0 1 .37-.33l.1-.09a.49.49 0 0 0 .19-.39.51.51 0 0 0-.16-.4c-.33-.31-3-3.15-3.13-6.57a3 3 0 0 1 0-.28 8.1 8.1 0 0 1 1.08-4.08 8 8 0 0 1 .74-1.08l.24-.26.06-.07a.55.55 0 0 0 .16-.38 1.35 1.35 0 0 0-.16-.61 18 18 0 0 0-1.39-1.72 3.68 3.68 0 0 1-.87-2.25 6.27 6.27 0 0 1 1.27-3.49 4 4 0 0 1 3-1.83h.17a4.12 4.12 0 0 1 2.88 1.19 3.68 3.68 0 0 1 .94 2.61 2.64 2.64 0 0 1-.7 2 2 2 0 0 1-.92.54h-.21a1.85 1.85 0 0 1-1-.25 1.1 1.1 0 0 1-.36-.34 1.35 1.35 0 0 1-.14-.64.51.51 0 1 0-1 0Z"
        className="Mexico_svg__cls-25"
      />
      <path
        id="Mexico_svg__path375"
        d="M664.2 433.17c0 1.69-1.09 1.76-2.05 1.76s-2.24-.53-2.24-2.67 2.82-3.3 4.6-3.3 4.86 2.46 4.86 5.44a7.4 7.4 0 0 1-2.18 5s1.34.65 1.34 4.4a10.65 10.65 0 0 1-2.42 6.48 5.45 5.45 0 0 1 3.17 5.13c0 3.88-2.69 5.15-4.54 5.15s-5.09-1.11-5.09-3.76 1.67-3.6 2.94-3.6a3 3 0 0 1 2.53 2.95"
        className="Mexico_svg__cls-24"
      />
      <path
        id="Mexico_svg__path377"
        d="M663.69 433.17a1.7 1.7 0 0 1-.13.75.7.7 0 0 1-.48.39 3.2 3.2 0 0 1-.93.09 1.74 1.74 0 0 1-1.15-.4 2.22 2.22 0 0 1-.58-1.75 1.87 1.87 0 0 1 .37-1.11 4 4 0 0 1 1.67-1.23 5.6 5.6 0 0 1 2-.45 2.94 2.94 0 0 1 1.28.39 6.3 6.3 0 0 1 2.1 1.81 4.74 4.74 0 0 1 1 2.73 6.4 6.4 0 0 1-1 3.34 8 8 0 0 1-.69.95 3 3 0 0 1-.23.24l-.06.06a.56.56 0 0 0-.16.46.53.53 0 0 0 .29.39l.12-.26-.13.25.12-.26-.13.25c.17.14 1 .94 1 3.92a9.55 9.55 0 0 1-1.15 4.41 12 12 0 0 1-.8 1.29l-.26.33-.07.09a.5.5 0 0 0-.12.47.53.53 0 0 0 .31.36 4.8 4.8 0 0 1 1.48 1.05 5.07 5.07 0 0 1 1.36 3.59 4.68 4.68 0 0 1-1.4 3.64 4.07 4.07 0 0 1-2.63 1 6.24 6.24 0 0 1-3-.82 3.4 3.4 0 0 1-1.15-1 2.27 2.27 0 0 1-.44-1.4 3.2 3.2 0 0 1 .83-2.42 2.3 2.3 0 0 1 1.59-.66 1.85 1.85 0 0 1 1.35.74 2.7 2.7 0 0 1 .66 1.69.51.51 0 0 0 .51.51.52.52 0 0 0 .52-.51 3.78 3.78 0 0 0-.91-2.36 2.9 2.9 0 0 0-2.13-1.11 3.3 3.3 0 0 0-2.3.95 4.33 4.33 0 0 0-1.15 3.17 3.42 3.42 0 0 0 .63 2 5.2 5.2 0 0 0 2.36 1.75 7.4 7.4 0 0 0 2.6.52 5.07 5.07 0 0 0 3.3-1.24 5.67 5.67 0 0 0 1.75-4.42 6.05 6.05 0 0 0-1.73-4.39 5.7 5.7 0 0 0-1.77-1.22l-.17.48.37.35a11.12 11.12 0 0 0 2.56-6.83 8.15 8.15 0 0 0-.73-3.85 2.3 2.3 0 0 0-.9-1l-.22.47.34.38a7.88 7.88 0 0 0 2.35-5.37 6.1 6.1 0 0 0-1.92-4.21 6.9 6.9 0 0 0-1.71-1.26 3.9 3.9 0 0 0-1.74-.49 6.6 6.6 0 0 0-3.24.92 4.5 4.5 0 0 0-1.31 1.18 2.9 2.9 0 0 0-.56 1.72 3.25 3.25 0 0 0 .92 2.52 2.68 2.68 0 0 0 1.82.66 3.23 3.23 0 0 0 1.64-.32 1.67 1.67 0 0 0 .68-.73 2.85 2.85 0 0 0 .24-1.22.51.51 0 1 0-1 0Z"
        className="Mexico_svg__cls-25"
      />
      <path
        id="Mexico_svg__path379"
        d="M618.34 453.71a2.7 2.7 0 0 1 .83 1.07 7.7 7.7 0 0 0 1.47 2.75c1.66 1.49 14.3 2 18.14 2s15.32.52 17.5-.78 2.42-3.44 3.77-4.41 1.72-.9 1.72-.9l-1.66 1.42-.12 2.72 1 1.49a3.37 3.37 0 0 1-1.56 1.62 9.3 9.3 0 0 1-4.41 1.3c-1.85.2-26 .13-30-.52s-3.63-.58-4.78-1.42a8.5 8.5 0 0 1-1.79-1.75l.51-1.75-.64-2.79Z"
        className="Mexico_svg__cls-25"
      />
      <path
        id="Mexico_svg__path381"
        d="m657.62 430.48 2.17.95s-1.86.58-3.25 4.4-.26 5.06-1.22 5.44-11.43.07-11.43.07l-1.8-4.35z"
        className="Mexico_svg__cls-25"
      />
      <path
        id="Mexico_svg__path383"
        d="M691 429a5.4 5.4 0 0 1-2.61-2.13c-.84-1.5-1.54-3.37-.9-3.76s2 .9 1.86 2.07S691 429 691 429"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path385"
        d="M711.48 423.31a13.5 13.5 0 0 0 1.72 2.58c.45.26 2.49 1.18 2.49 1.18s-2.87 0-3.77-.78a16.8 16.8 0 0 1-2.17-2.92z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path387"
        d="M717.65 425.21a4.16 4.16 0 0 1-3.19.45c-1.47-.58-2.61-1.43-2.05-2.07s1-.39 1.73.45 3.51 1.17 3.51 1.17"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path389"
        d="M728.06 416.39a5.13 5.13 0 0 1-2.43 1.23c-1 0-3.07-.39-3.07-.84s2.69-.72 3.13-.65z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path391"
        d="M712.48 395.73s-2.3.71-3.07 1.88-.57 2.46.39 2.39 1.21-1.36 1.21-1.75a14.8 14.8 0 0 1 1.47-2.52"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path393"
        d="M702.2 401.37a7.1 7.1 0 0 0-2.17 2.07c-.45 1-.83 3 .19 3.11s1.34-1.56 1.4-2.4a25 25 0 0 1 .58-2.78"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path395"
        d="m683.82 413.79-5.63 6s13 7.26 22.92 6.93 21.34-8.09 22.1-9.72.13-8.55-1.15-10.75-8.17-7.58-10.79-7.32-7.22 3.75-11.5 7.9-3.83 7.64-9.77 7.33l-6.18-.34Z"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path397"
        d="m683.82 413.79-.37-.35-6.09 6.45.58.33a72 72 0 0 0 7.49 3.49c4.37 1.75 10 3.51 15 3.51h.67c5.11-.17 10.49-2.22 14.72-4.43a43 43 0 0 0 5.28-3.23 18 18 0 0 0 1.66-1.32A2.83 2.83 0 0 0 724 416a13 13 0 0 0 .09-1.61 28 28 0 0 0-.42-4.62 12.2 12.2 0 0 0-1.17-3.77 10.3 10.3 0 0 0-1.89-2.17 31.6 31.6 0 0 0-4.61-3.63 19 19 0 0 0-2.41-1.3 5.6 5.6 0 0 0-2.09-.53h-.25a12.9 12.9 0 0 0-5.36 2.59 59 59 0 0 0-6.44 5.46 43.6 43.6 0 0 0-4.15 5.2 5.2 5.2 0 0 1-1.73 1.46 6.3 6.3 0 0 1-2.8.53H690l-6.19-.34h-.23l-.16.16.37.36v.52l6.15.33h.77A7.2 7.2 0 0 0 694 414a8 8 0 0 0 2.91-2.85 24.7 24.7 0 0 1 3.24-4 55 55 0 0 1 6.31-5.36 12.24 12.24 0 0 1 4.88-2.41h.14a5.9 5.9 0 0 1 2.41.79 27.3 27.3 0 0 1 4.7 3.16 25 25 0 0 1 1.93 1.75 8 8 0 0 1 1.13 1.37 11.8 11.8 0 0 1 1 3.47 28 28 0 0 1 .39 4.44 13 13 0 0 1-.07 1.48 3.3 3.3 0 0 1-.21.88 3.1 3.1 0 0 1-.64.71 38.2 38.2 0 0 1-8.33 5.2 33.3 33.3 0 0 1-12.69 3.51h-.63c-4.82 0-10.35-1.71-14.65-3.44a74 74 0 0 1-6.84-3.15l-.54-.29-.24.45.36.36 5.64-6-.37-.36Z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path399"
        d="M682.38 416.18s13.88 2.07 17.88-1.47 8.35-10.45 11.16-12 4.08-1.56 4.08-1.56a34 34 0 0 1 3 2.15c1 .81 3.54 2.93 3.54 2.93l1.11 6.59.08 3.63-4.32 3.55-8 3.67-7.58 2.33-6.47-.17-13.11-3.81-3.33-2.35-.85-.76 2.81-2.76Z"
        className="Mexico_svg__cls-29"
      />
      <path
        id="Mexico_svg__path401"
        d="M703.54 408.18c0-1.18.77-1.12 1.83-1.12s2.21.2 2.21 1.38-1.15 2.89-2.21 2.89-1.83-1.96-1.83-3.15"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path403"
        d="M709.11 411.68c0-1.06.82-1.64 2.09-1.64a2.73 2.73 0 0 1 2.42 2.48 2.13 2.13 0 0 1-2.29 1.93c-1.27 0-2.22-1.7-2.22-2.77"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path405"
        d="M707.2 420c0-1.32.81-1.6 2.08-1.6s2.05.6 2.05 1.92a2.36 2.36 0 0 1-2.3 2.4c-1.27 0-1.83-1.4-1.83-2.72"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path407"
        d="M699.88 417.43c0-1.42 1.34-1.86 2.48-1.86a2.63 2.63 0 0 1 0 5.14c-1.14 0-2.48-1.86-2.48-3.28"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path409"
        d="M688.29 418.84a2.84 2.84 0 1 1 2.83 2.82 2.84 2.84 0 0 1-2.83-2.82"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path411"
        d="M709.11 411.68c0-.95 1.31-1.64 2.09-1.64a1.77 1.77 0 0 1 0 3.46c-.78 0-2.09-.87-2.09-1.82"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path413"
        d="M707.24 419.64c0-1.1 1-1.56 2.17-1.56s2 .46 2 1.56a2.11 2.11 0 0 1-4.21 0Z"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path415"
        d="M699.92 417.21c0-1.21 2-1.76 2.81-1.76s.68.81.68 2-.67 2.21-1.49 2.21a2.63 2.63 0 0 1-2-2.47Z"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path417"
        d="M703.37 408.05c0-1.11.86-1.16 1.58-1.16s1.23.33 1.23 1.44-.58 2-1.29 2-1.52-1.18-1.52-2.29Z"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path419"
        d="M688.25 418a2.64 2.64 0 0 1 2.77-2.51c1.65 0 3.32.57 3.32 1.86s-2 3.5-3.66 3.5a2.63 2.63 0 0 1-2.43-2.85"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path421"
        d="M693.57 415.75a6.65 6.65 0 0 0-2.94 1.29c-1 1-1.15 2.08-.57 2.4s1.28-.71 1.47-1.16a25 25 0 0 1 2-2.53Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path423"
        d="M702.77 413.73s-1.85 1.3-2 2.6 0 1.94.51 2 .83-1.69.64-2.34.89-2.27.89-2.27Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path425"
        d="M704.3 415.68a3.6 3.6 0 0 0-2 .84c-.83.78-1.6 1.75-1 1.82s1.47-.39 1.53-.91 1.53-1.75 1.53-1.75Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path427"
        d="M706.29 405s-1 .78-1.47 1.23-1.15 1.75-.52 2.08 1.09-.27 1.54-1.17a5.6 5.6 0 0 0 .45-2.14"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path429"
        d="M713.25 409.46s-1.8.26-2.37 1-1 1.69-.19 1.69 1-.4 1.28-1.11a7 7 0 0 1 1.28-1.62Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path431"
        d="M712.16 417.68a3.4 3.4 0 0 1-1.47 1.82c-1.09.58-1.4 1.1-1.85.32s.13-1.17.7-1.36 2.62-.78 2.62-.78"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path433"
        d="M723.27 412.12s.77 3.82-2.55 5.69-12.65 8.49-21.46 7.72-18.84-5.83-18.84-5.83l-1.4.64 2.23 1 6.83 2.85 7.79 2.27 4.86.33 4.21-.52 7.79-2.59 6.6-3.37 3.43-2.72.91-1.13-.08-1.59v-2.21l-.32-.51Z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path435"
        d="M550.21 362.31s2 1.75 1.85 3.24-.7 2.08-1.27 1.82-.58-1.82-.45-2.46a13.4 13.4 0 0 0-.13-2.6"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path437"
        d="M565.33 376.35s-.58 2.59-1.6 2.85-1.79-.84-1.6-1.29 1-.07 1.47-.46a17 17 0 0 1 1.73-1.1"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path439"
        d="M532.44 378.36a3.33 3.33 0 0 0 2 1.75c1.34.25 2-.65 1.79-1.1s-.77-.33-1.47-.33a19 19 0 0 1-2.32-.32"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path441"
        d="M538.32 389.89a5.1 5.1 0 0 0 2.87 1.63 2.51 2.51 0 0 0 2.62-1.5c.12-.39-1.92-.32-2.56.2s-2.93-.33-2.93-.33"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path443"
        d="M548.72 398.77s2.68-.52 3.13-1.23 1.15-1.94.58-2.66-1 1.1-1.35 1.81a9.8 9.8 0 0 1-2.36 2.08"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path445"
        d="M565.46 391.73s1.79-12-7.92-20.48-16-6.39-19.34-3.28-6.21 13.31 4.09 22.21 23 6.13 23 6.13z"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path447"
        d="m565.46 391.73.5.07a17.5 17.5 0 0 0 .14-2.38 24.5 24.5 0 0 0-8.23-18.56c-5.17-4.51-9.45-6.11-12.9-6.11a10.18 10.18 0 0 0-7.11 2.84 12.38 12.38 0 0 0-3.24 8.78c0 4.31 1.86 9.47 7.34 14.2a28.27 28.27 0 0 0 18.58 6.66 24.3 24.3 0 0 0 4.85-.42l.39-.08.19-5zl.5.07zh-.51l-.17 4.58h.51l-.11-.51h-.08a25.7 25.7 0 0 1-4.56.37 27.17 27.17 0 0 1-17.91-6.41c-5.29-4.57-7-9.41-7-13.41a11.44 11.44 0 0 1 2.91-8 9.17 9.17 0 0 1 6.42-2.57c3.12 0 7.18 1.46 12.24 5.86a23.5 23.5 0 0 1 7.87 17.78c0 .7 0 1.27-.07 1.65v.44a1 1 0 0 1 0 .14v.06h.51Z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path449"
        d="M535.86 379s-.19-6.6 2.93-8.57a13.53 13.53 0 0 1 18.44 6.07c5.06 9.74 5.16 14.61 3.89 19.54l-5.42-.04-8.38-3.42-7-5.13z"
        className="Mexico_svg__cls-29"
      />
      <path
        id="Mexico_svg__path451"
        d="M564.18 393.45a6.68 6.68 0 0 1-5.2 1.73c-3.49-.17-19.75-4.41-23.84-19l.25 3.19.17 1 1.07 2.94 3.43 5 4.29 3.68 5.42 2.8 3.88 1.14 5.06.88h2.91l2.56-3.37Z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path453"
        d="M555.71 389.23c0-1.3.67-1.34 1.7-1.34s1.83-.46 1.83.84-.71 3.17-1.74 3.17-1.79-1.38-1.79-2.67"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path455"
        d="M556.39 381.51a1.84 1.84 0 1 1 1.83 1.62 1.73 1.73 0 0 1-1.83-1.62"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path457"
        d="M549 390c0-.7.92-1.27 2.06-1.27s2.07.57 2.07 1.27-2 1.66-3.19 1.66-.94-1-.94-1.66"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path459"
        d="M548.34 380.93c0-1.15.55-.78 1.55-.78s2.24.33 2.24 1.47-1.24 2.68-2.24 2.68-1.55-2.23-1.55-3.37"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path461"
        d="M541.49 382.46c0-1 .65-2.31 1.87-2.31a2.85 2.85 0 0 1 2.55 2.31 2.27 2.27 0 0 1-4.42 0"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path463"
        d="M542.72 374.4c0-1 .68-.95 1.94-.95s2.28.51 2.28 1.52-1.47 2.24-2.73 2.24-1.49-1.8-1.49-2.81"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path465"
        d="M550.13 373.63c0-1 .83-.65 2-.65a2 2 0 0 1 2.13 1.75c0 1-1.5 2-2.68 2s-1.45-2.18-1.45-3.15Z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path467"
        d="M542.72 374.19a1.44 1.44 0 0 1 1.53-1.17c.88 0 1.66.17 1.66 1.17a1.72 1.72 0 0 1-1.59 1.82 1.6 1.6 0 0 1-1.6-1.82"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path469"
        d="M541.36 382.09c0-1 .49-1.9 1.49-1.9s1.79.1 1.79 1.08a2.18 2.18 0 0 1-1.88 2.12c-1 0-1.4-.32-1.4-1.3"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path471"
        d="M550.08 373.76c0-.78.67-.86 1.62-.86s1.58.19 1.58 1a1.59 1.59 0 0 1-1.73 1.4 1.44 1.44 0 0 1-1.47-1.51Z"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path473"
        d="M548.39 381.34a1.85 1.85 0 0 0 1.74 1.93 2 2 0 0 0 2-1.91 2.24 2.24 0 0 0-2-2.08 1.93 1.93 0 0 0-1.7 2.06Z"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path475"
        d="M556.69 380.22a1.87 1.87 0 1 0 1.87-1.75 1.81 1.81 0 0 0-1.87 1.75"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path477"
        d="M548.68 389.93a1.83 1.83 0 0 1 1.75-1.66 1.55 1.55 0 0 1 1.7 1.38c0 .85-1.51 2-2.38 2s-1.07-.87-1.07-1.72"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path479"
        d="M555.75 388.7c0-1 .79-1.12 1.87-1.12s1.62.1 1.62 1.14a1.93 1.93 0 0 1-2 1.89c-1.08 0-1.53-.87-1.53-1.91Z"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path481"
        d="M557.67 376.55a7.3 7.3 0 0 1 1.28 2.39c.19 1 .19 2.21-.2 2.34s-1-.65-1.21-1.62a13.3 13.3 0 0 1 .13-3.11"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path483"
        d="M551.47 369.93a4.75 4.75 0 0 1 .7 2.08c0 1-.13 2-.64 2s-.51-1-.51-1.68a14.5 14.5 0 0 1 .45-2.4"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path485"
        d="M544.19 370.91a4.7 4.7 0 0 1 .7 2.07c0 1-.13 2-.64 2s-.51-1-.51-1.68a14.3 14.3 0 0 1 .45-2.4Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path487"
        d="M541.63 372.27a5.8 5.8 0 0 1 1.79.9c.83.65 1.15 1.43.83 1.82s-1.08-.19-1.28-.65a23 23 0 0 0-1.34-2.07"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path489"
        d="M547.19 379.91a4 4 0 0 1 2.18.78c.76.71 1.4 1.3 1 1.82s-1.53-.39-2-.91a16 16 0 0 1-1.15-1.69Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path491"
        d="M540.42 379.66a7.4 7.4 0 0 1 1.92.77c.64.46.83 1.36.51 1.56s-.77-.13-1.34-.71a7.6 7.6 0 0 1-1.09-1.62"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path493"
        d="M556.77 384.77a12 12 0 0 1 .45 2.66c0 1.1.13 2.07-.38 2.07s-.77-1.36-.77-2.2a9.6 9.6 0 0 1 .7-2.53"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path495"
        d="M554.92 387.3a7.3 7.3 0 0 1 1.66.9c.51.46.64 1.17.25 1.3s-.64-.71-1-1-1-1.16-1-1.16Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path497"
        d="M547.64 387.75a5.3 5.3 0 0 1 1.77.52c.53.36.59 2 .53 2.26s-.85.07-1.18-.73a15 15 0 0 0-1.12-2.05"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path499"
        d="M544.81 365.52s-6.43 1.4-7.61 5.55a38.7 38.7 0 0 0-1.22 8.76l-.93-5.29 1.28-3.42 1.88-3.14 2.83-1.79 2.55-.88z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path501"
        d="M564.9 390.13s.66-1.6-1.23-6.68a94 94 0 0 0-5.77-11.72l3 3.42 2.39 3.89 1.18 3.58.87 3.26-.05 3.21-.41 1Z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path503"
        d="M571.39 381.91s2.24 1.47 2.46 2.27.32 1.08-.25 1.3-1.5-.68-1.76-1.3a12.5 12.5 0 0 1-.45-2.27"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path505"
        d="M562 407.25a7.7 7.7 0 0 1 2.46-2.72c1.41-.74 2.46-.65 2.84-.19s-.92 1.49-1.88 1.85-3.42 1.06-3.42 1.06"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path507"
        d="M577.82 413.32a10.1 10.1 0 0 0 2.59-1.85c1-1.1 1.15-1.87.76-2.26s-1.66.26-2.23 1.13a13.5 13.5 0 0 0-1.12 2.98"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path509"
        d="M576.09 411.82a10.2 10.2 0 0 1 1.09-2.69c.54-.65 1.3-1 1.88-.65s.22 1.27-.19 1.75a15.5 15.5 0 0 1-2.78 1.59"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path511"
        d="M602.58 399.76s-9.87-14.27-25.2-15c-12.27-.61-16.14 10.35-15.69 13.65s5 10.39 21.39 11.59 19-7.7 19.67-8.14-.17-2.07-.17-2.07Z"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path513"
        d="m602.58 399.76.42-.3a42 42 0 0 0-7-7.33c-4.43-3.7-10.83-7.53-18.65-7.92h-1a14.78 14.78 0 0 0-11.86 5.35 16 16 0 0 0-2.61 4.48 11.5 11.5 0 0 0-.8 3.81 4 4 0 0 0 0 .62c.5 3.6 5.38 10.83 21.86 12 1.05.08 2 .12 3 .12 7 0 11.12-2 13.59-4.09a13.7 13.7 0 0 0 2.6-2.94c.27-.41.48-.76.63-1a1.4 1.4 0 0 1 .18-.28v-.06.1l-.19-.22.15.25-.19-.22.15.25a1.1 1.1 0 0 0 .41-.5 1.5 1.5 0 0 0 .09-.54 3.3 3.3 0 0 0-.25-1.16 5 5 0 0 0-.24-.56l-.42.29-.45.24c0 .08.13.28.22.52a2.5 2.5 0 0 1 .15.69v.15a1 1 0 0 0-.29.3c-.12.18-.26.41-.44.72a12.8 12.8 0 0 1-4.18 4.33c-2.38 1.52-6 2.82-11.54 2.82-.92 0-1.89 0-2.91-.11-16.23-1.2-20.55-8.25-20.93-11.15a3.4 3.4 0 0 1 0-.48 10.4 10.4 0 0 1 .74-3.44 14.65 14.65 0 0 1 4.37-6.11 14 14 0 0 1 9.14-3h.94c7.51.37 13.72 4.06 18 7.68a43 43 0 0 1 5 4.94c.58.66 1 1.21 1.31 1.59l.34.45.1.15.42-.3-.45.24.45-.24Z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path515"
        d="M590.94 390a34.6 34.6 0 0 1 5.82 5.57c1.72 2.46 2.1 4.28 1.08 4.61s-9.9-7.91-17.18-9.66-13.6-.13-15 3.37-.89 8.75 2.43 10.88S587 409.4 587 409.4s7.09-1 7.35-1.1l4.53-2.53 1-2.46 1.15-3.24.51-1.3-3.77-4.14z"
        className="Mexico_svg__cls-29"
      />
      <path
        id="Mexico_svg__path517"
        d="M578.42 392c0 .92-1 1.37-1.92 1.37s-1.75-.48-1.75-1.4a1.69 1.69 0 0 1 1.72-1.65 1.93 1.93 0 0 1 1.95 1.68"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path519"
        d="M569.42 395.2c0-.92 1-.9 2.06-.9a1.78 1.78 0 0 1 1.87 1.66c0 .92-1.63 2.18-2.56 1.74a2.5 2.5 0 0 1-1.37-2.5"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path521"
        d="M579.09 400.49a2.21 2.21 0 0 1 4.41 0c0 1.16-1.66 2.42-2.87 2.42s-1.54-1.26-1.54-2.42"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path523"
        d="M571.78 402.66c0-1 1.05-1.23 2-1.23a2.24 2.24 0 0 1 2 2 2 2 0 0 1-2 1.72c-.95-.03-2-1.47-2-2.49"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path525"
        d="M584.87 406.2a1.42 1.42 0 0 1 1.34-1.57c.85 0 1.88.5 1.88 1.33a1.88 1.88 0 0 1-1.69 1.75 1.51 1.51 0 0 1-1.53-1.51"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path527"
        d="M590.75 401.72c0-1.06.6-1 1.63-1a1.87 1.87 0 0 1 2.07 1.66c0 1.06-1.29 1.62-2.33 1.62s-1.37-1.28-1.37-2.33Z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path529"
        d="M577.85 391.13c0 .82-.34 1.26-1.15 1.26s-1.79-.44-1.79-1.26.38-1.08 1.18-1.08 1.76.25 1.76 1.08"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path531"
        d="M573.16 394.94c0 .9-1.36 1.46-2.21 1.46a1.34 1.34 0 0 1-1.4-1.46c0-.89.65-1.16 1.5-1.16s2.11.27 2.11 1.16"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path533"
        d="M575.23 402.5c0 .78-.3 1.38-1.21 1.38s-2.11-.6-2.11-1.38.33-1.34 1.25-1.34 2.07.55 2.07 1.34"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path535"
        d="M583.05 399.93c0 .82-1.61 1.75-2.46 1.75s-1.21-1.51-1.21-2.33a1.5 1.5 0 0 1 1.53-1.49 2.72 2.72 0 0 1 2.14 2.07"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path537"
        d="M594.39 402.37c0 .85-1.37.81-2.14.81s-1.47-1-1.47-1.81.25-1.66 2.17-1.43c.77.09 1.44 1.57 1.44 2.43"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path539"
        d="M587.68 405.83a1.47 1.47 0 1 1-2.94 0c0-.86.66-1.2 1.47-1.2s1.47.37 1.47 1.2"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path541"
        d="M588.71 401.1a8.2 8.2 0 0 1 2.8-.39c1.22.13 1.28.58 1.28.78s-1 .58-1.4.45-2.68-.84-2.68-.84"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path543"
        d="M582.06 406.73a8.8 8.8 0 0 1 2.24-1c1-.19 1.72.13 1.66.71s-.38.72-1.34.72a12.3 12.3 0 0 1-2.56-.46Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path545"
        d="M577.79 396.89s2.74 1.16 3.32 2.26.83 1.37.25 1.69-1.21-.39-1.59-.91-2-3-2-3Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path547"
        d="M577.08 400.39a17.4 17.4 0 0 1 3.07-.58c1 0 1.21.06 1.34.52s-.21.64-1 .6-3.41-.54-3.41-.54"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path549"
        d="M570.35 400.52s2.3.3 2.88.9.57 1.15.34 1.49-1.32.13-1.66-.21-1.56-2.18-1.56-2.18"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path551"
        d="M570 403.84c.1-.11.89-1.3 1.72-1.57s1.79-.24 2 .19-.73 1.08-1.32 1.21a21 21 0 0 1-2.36.17Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path553"
        d="M568.29 393.78a4.5 4.5 0 0 1 2.27.62c.84.63 1 1.13.84 1.37a1.52 1.52 0 0 1-1.69-.09 4.2 4.2 0 0 1-1.42-1.9"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path555"
        d="M573.27 388s2.32.65 3.09 1.71.65 1.68.27 1.9-1.28-.32-1.78-.8a15.5 15.5 0 0 1-1.58-2.81"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path557"
        d="M599.82 404.67s-4.73 4-15.39 3.63-20.31-4.93-22.74-9.92l1 2.46L565 404l7.47 3.82 8.37 1.88 6.64.39 6.26-1.1 4.86-2.33a4.8 4.8 0 0 0 .76-1.24l.45-.77Z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path559"
        d="M601.22 399.61a52 52 0 0 0-4.28-4.54c-2.49-2.33-12.2-8.62-12.2-8.62l7.86 3.55 5.17 4.34 3.7 4.08-.25 1.17Z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path561"
        d="M601.67 390.15s2.68 1 3.13 1.69a12 12 0 0 0 1 1.23s-.7 1.74-1.34 1a14 14 0 0 1-1.47-1.69 20 20 0 0 1-1.34-2.27Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path563"
        d="M609.66 385.87a9.9 9.9 0 0 1 3.38 2.27c.9 1.23.7 2.27.32 2.4s-2-1.3-2.3-1.88-1.4-2.79-1.4-2.79"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path565"
        d="M612.15 385.36a14.4 14.4 0 0 1 2.74 2.53c.39.77 1.15 1.81.39 2.07s-1.86-.91-2.18-1.62-1-3-1-3Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path567"
        d="M625.62 388.53s1.85.64 2 2.2a6.4 6.4 0 0 1-.2 2.66s-1.27-1.1-1.27-1.43a2.8 2.8 0 0 0 0-1.29l-.58-2.14Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path569"
        d="M629.19 389.77a7.4 7.4 0 0 1 1.67 2.46c.19 1 .38 1.62-.45 1.74s-1.28-.84-1.28-1.68.06-2.52.06-2.52"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path571"
        d="M605.06 419.18a3.3 3.3 0 0 0 2.23.13c1.09-.39 2-1.36 1.79-2s-.77-1.23-1.6-.39-.38 1.24-1 1.55l-1.4.72Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path573"
        d="M618.34 422.8a5.67 5.67 0 0 0 3-1.56c1.22-1.29 1.73-2.19.9-2.52a1.51 1.51 0 0 0-2.11 1 11.1 11.1 0 0 1-1.79 3Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path575"
        d="M629.26 423.2a15 15 0 0 0 2.37-1.75c1-1 1.59-1.55.89-2.27s-1.22-.2-1.53.13 0 .33-.39 1.36a16.6 16.6 0 0 1-1.34 2.53"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path577"
        d="M632.58 423.13a13.4 13.4 0 0 0 1.78-2.73c.32-1 .51-2.06-.15-2a2 2 0 0 0-1.48 1.69c-.05.71-.15 3-.15 3Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path579"
        d="M599.37 405.44c.09-4.8 6.9-15.87 14.75-15.74 3.27.05 9.68 1.75 14.88 4.08 4.34 1.94 5.75 4.09 8.63 4.8a25 25 0 0 0 7.21.19l9.77-1.1-7.61 11.21-2.74 2.46s-2.43 4.73-9.39 7.45-18.72.71-24-.58-11.56-6.35-11.43-12.77Z"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path581"
        d="M599.37 405.44h.51a11.8 11.8 0 0 1 1.18-4.26 24.1 24.1 0 0 1 5.24-7.39c2.28-2.12 5-3.58 7.69-3.58h.12a29.3 29.3 0 0 1 6.59 1.17 56.6 56.6 0 0 1 8.1 2.86 27 27 0 0 1 4.77 2.82 11.6 11.6 0 0 0 3.93 2 17 17 0 0 0 4 .4 29 29 0 0 0 3.42-.19l8.65-1-7 10.22-2.78 2.51v.08c-.12.21-2.53 4.62-9.12 7.2a25 25 0 0 1-8.77 1.31 67.8 67.8 0 0 1-14.94-1.92 16.63 16.63 0 0 1-7.45-4.26 11.14 11.14 0 0 1-3.59-7.8v-.19h-1v.21a12.16 12.16 0 0 0 3.9 8.54 17.6 17.6 0 0 0 7.92 4.53 68.8 68.8 0 0 0 15.18 2 25.7 25.7 0 0 0 9.14-1.39c7.11-2.78 9.62-7.62 9.66-7.69l-.45-.24.33.38 2.79-2.49 8.35-12.2-10.89 1.22h-.26c-.51.05-1.7.15-3 .15a16 16 0 0 1-3.73-.36 10.7 10.7 0 0 1-3.6-1.86 29 29 0 0 0-4.94-2.9 58 58 0 0 0-8.24-2.92 30.7 30.7 0 0 0-6.84-1.21H614a10.9 10.9 0 0 0-5.84 1.87 22.2 22.2 0 0 0-6.61 7 16.55 16.55 0 0 0-2.68 7.34Z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path583"
        d="M646.82 406.93a4 4 0 0 1-2.75.65c-1 0-22.8-13.28-29.57-12.7s-13.22 3.5-13.41 10.43 1.54 7 2.94 8.94 14.69 4.87 14.69 4.87l8.11-.14 6.52-.71 5.74-3.11 3.14-2.52 2.1-2.6z"
        className="Mexico_svg__cls-29"
      />
      <path
        id="Mexico_svg__path585"
        d="M612.41 403.41c0 1.36-.52 2.31-1.85 2.31s-2.31-.6-2.31-2 .75-1.86 2.08-1.86 2.08.19 2.08 1.55"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path587"
        d="M614.69 397.34c0-1.13 1.09-1.62 2.34-1.62s2.22.45 2.22 1.58a2.1 2.1 0 0 1-2.24 2 2.14 2.14 0 0 1-2.32-2Z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path589"
        d="M627.73 400.88a1.89 1.89 0 1 1 1.89 1.78 1.84 1.84 0 0 1-1.89-1.78"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path591"
        d="M630.35 408.88a2.16 2.16 0 0 1 2-2.27c1.13 0 2.18.53 2.18 1.78s-.41 2.47-1.53 2.47-2.69-.73-2.69-2Z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path593"
        d="M624 414a2.14 2.14 0 0 1 4.27 0 1.81 1.81 0 0 1-2 1.77A2 2 0 0 1 624 414"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path595"
        d="M612.08 411.92a1.89 1.89 0 1 1 1.92 1.88 1.87 1.87 0 0 1-1.92-1.88"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path597"
        d="M612.34 403.11a2 2 0 0 1-4.09 0c0-1.07.91-1.5 2-1.5s2.06.43 2.06 1.5Z"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path599"
        d="M618.66 397c0 1-.32 1.71-1.42 1.71s-2.54-.71-2.54-1.71a2 2 0 0 1 4 0Z"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path601"
        d="M631.3 400.32a1.87 1.87 0 1 1-1.85-1.62 1.74 1.74 0 0 1 1.85 1.62"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path603"
        d="M624.6 405.67c0 1.37-.52 2.32-1.85 2.32s-2.31-.61-2.31-2 .75-1.86 2.08-1.86 2.08.16 2.08 1.51Z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path605"
        d="M615.46 411.47a2 2 0 0 1-4.08 0c0-1.07 1.29-1.62 2.42-1.62a1.44 1.44 0 0 1 1.66 1.62"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path607"
        d="M624.21 405.44a2 2 0 1 1-2-1.94 2 2 0 0 1 2 1.94"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path609"
        d="M634.54 408.11a1.94 1.94 0 0 1-2 2.12 2.18 2.18 0 0 1-2.23-2.13c0-1.18.36-1.58 1.59-1.58s2.6.41 2.6 1.59Z"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path611"
        d="M627.92 413.54a1.68 1.68 0 0 1-1.88 1.75c-1.13 0-2.21-.63-2.21-1.75s1-1.56 2.09-1.56 2 .46 2 1.56"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path613"
        d="M628.69 407.06s3.25-.32 3.83.26a1.34 1.34 0 0 1 .25 1.68c-.25.26-1.53.33-1.85-.12a17.6 17.6 0 0 0-2.23-1.82"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path615"
        d="M625.49 396.57a9.6 9.6 0 0 1 3.52 1.68c1 1 .83 2.08.64 2.27a1.4 1.4 0 0 1-1.79-.39 39 39 0 0 1-2.37-3.56"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path617"
        d="M618.08 401.62s2.91 1.59 3.55 2.49.8 1.63.51 2-1.73-.1-1.95-.58-2.11-3.92-2.11-3.92Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path619"
        d="M616.81 403.86s3.26.42 4.05 1 1.38.65 1.31 1.14a.82.82 0 0 1-.92.78 7.2 7.2 0 0 1-2.24-1l-2.2-2Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path621"
        d="M613.06 394.32s3.32.52 4 1 .86 2 .09 2.43-1.62-.43-1.87-1a16.5 16.5 0 0 0-2.22-2.42Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path623"
        d="M605.91 399.33s3.05 1.45 4 2.81c.51.73 1 1.35 0 1.68s-1.79-1.29-1.79-1.68a17.6 17.6 0 0 0-2.21-2.81"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path625"
        d="M605.23 403.3a19.4 19.4 0 0 1 2.89-.43c.94 0 2.28-.32 2.3.43s-1.15.91-1.84.69-3.35-.69-3.35-.69"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path627"
        d="M622.14 414.22s2.14-1.33 3.19-1.1 1.4.13 1.4.78-1.24.52-1.63.52-3-.2-3-.2Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path629"
        d="M610.3 412.5s.82-1.23 1.72-1.35 1.28-.07 1.4.31-.76 1.11-1.15 1.11-2-.07-2-.07Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path631"
        d="M644.14 410.34a23.5 23.5 0 0 1-7.79 5.86c-4.53 1.95-8 2.59-14.3 2.2s-9.39-1.36-13.67-3.56-7.67-5.37-8.31-6.74.71 2.27.71 2.27l3.9 5.12 4.66 2.07 6.83 1.68 6.45.78 4.92-.12 5.87-.92 3.77-1.35 2.56-1.56 2-1.62 2.42-4.11Z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path633"
        d="M638.05 398.77s-1.77.59-5.66-1.82-8.56-5.5-17.38-5.57-11.62 6-12.19 6.42 3.95-5.25 3.95-5.25l4-2.14 3.13-.52 3 .13 3.9 1 3.51 1.1 4.09 1.36 3.57 2 4.32 2.25 1.73 1Z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path635"
        d="M649.9 401.37s-5.18-.07-6.65.06-1.53.39-1.73.78a8 8 0 0 1-.57.9l-1.59-3.43 7-1 3.83 1.43-.31 1.24Z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path637"
        d="M640.37 437.51a2.6 2.6 0 0 0 2.2 1.82h3.2l7-.41 2.46-2.82 1.5-6.32s1.89-2.3 1.89-2.4 6.51-3.59 6.51-3.59l5.63-1.63 3.6-.38 5-1.65 3.68-1.92 1.59-2.36 1.57-3.6-1.57-4.86-3.9-5.21-6.6-2.69h-5.47l-6.13 2.23-10.79 2.56s-5.94 2.59-8.4 7.22-2.42 5.84-2.84 12-.1 14.09-.1 14.09Z"
        className="Mexico_svg__cls-29"
      />
      <path
        id="Mexico_svg__path639"
        d="m640.37 437.51-.47.19a3.7 3.7 0 0 0 1 1.46 2.58 2.58 0 0 0 1.67.69h3.22l7.22-.44 2.68-3.08 1.53-6.44-.5-.12.4.33s.47-.57.94-1.17c.24-.29.47-.58.65-.82s.17-.22.23-.3l.08-.12v-.13a.6.6 0 0 0 0-.19h-.51l.42.29a.5.5 0 0 0 .09-.29h-.51l.42.29-.39-.26.3.36.09-.1-.39-.26.3.36-.14-.18.13.19-.14-.18.13.19.37-.22c.72-.42 2.24-1.25 3.57-2l2.5-1.35-.25-.45.14.49 5.58-1.61 3.62-.38 5.07-1.68 3.82-2 1.7-2.52 1.66-3.82-1.65-5.13-4-5.4-6.83-2.78h-5.65l-6.18 2.26-10.81 2.56a21.7 21.7 0 0 0-3.37 1.92 16.55 16.55 0 0 0-5.28 5.53 20.8 20.8 0 0 0-2.24 5.55 49 49 0 0 0-.66 6.62c-.17 2.42-.22 5.14-.22 7.52 0 3.69.12 6.62.12 6.62v.16l.48-.18h.52s0-.72-.06-1.91-.06-2.83-.06-4.66c0-2.38.05-5.07.21-7.46a51.5 51.5 0 0 1 .64-6.46 19.8 19.8 0 0 1 2.14-5.29 15.56 15.56 0 0 1 5-5.16 24 24 0 0 1 2.27-1.37c.28-.16.52-.27.68-.35l.19-.08-.2-.48.12.51 10.82-2.57 6.08-2.21H674l6.39 2.59 3.75 5 1.48 4.6-1.47 3.37-1.5 2.21-3.51 1.83-4.9 1.63-3.59.38-5.72 1.65-3.26 1.76-2.24 1.23-.75.43-.22.14-.09.06-.06.06-.08.07a.8.8 0 0 0-.08.3h.49l-.46-.17a.4.4 0 0 0 0 .17h.49l-.46-.17.36.13-.34-.19v.06l.36.13-.33-.19-.35.46c-.54.69-1.47 1.84-1.47 1.84l-.09.09-1.5 6.31-2.22 2.55-6.79.42v.51-.51h-3.17a1.62 1.62 0 0 1-1-.44 2.5 2.5 0 0 1-.7-1l-.49.18h.52-.52Z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path641"
        d="M643.29 435.1c2.06 0 .47-3.42 2.81-7.48s5.19-9 5.92-9 .84.74 1.7.48a5.73 5.73 0 0 0 2.39-1.91 6 6 0 0 1 1.86-4.1c1.8-1.47 4.31-3.54 5.5-3.8s1.75-.48 2 .08-.69 1.34.13 1.6 2.68.18 3.15-1a3.85 3.85 0 0 0 .34-1.86 4 4 0 0 1 3.58-.69c2.34.52 2.63.39 2.85 1.3s-1.07 1-.81 1.68-.18.57.06 1.07.61 1.87 2.19 1.82a2.94 2.94 0 0 0 2.26-.95l.46-.83s.44-1-.16-1.37-.39-.86.21-.6 3 3.58 3.79 2.2.9-3.33.47-3.8-3.79-5.53-3.79-5.53l-6-2-7.95.65-7.71 4.4-7.07 3.76s-.39 5.79-1.66 4.75-3.11-3.88-3.66-2.94-1.79 5.19-2.52 7.3-2.81 8.64-2.6 11.06 1.54 5.75 2.31 5.75Z"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path643"
        d="M650.4 425.74a3.1 3.1 0 0 0-1.62.93 2 2 0 0 0-.38 1.77c.23.76 1.34 1.49 1.43 1.58h.88l1.92-.56a2.9 2.9 0 0 0 .65-1.6 1.08 1.08 0 0 0-.79-1.23c-.28-.09-2.09-.87-2.09-.87Z"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path645"
        d="M662.57 415.68a1.34 1.34 0 0 0-1.76.68 2.54 2.54 0 0 0-.11 1.11s.24 1.51.81 1.79 2.08.79 2.55.27a2.21 2.21 0 0 0 .94-1.84c0-1-1.38-1.45-1.38-1.45l-1-.56Z"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path647"
        d="M672.37 418c0-.37-1-.63-1.64-.52a1.71 1.71 0 0 0-1.19 2.16c.3 1.23 1.47 1.34 2.39 1.1s.74-1.54.74-1.73a7 7 0 0 0-.3-1.01"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path649"
        d="M644.05 420a2.33 2.33 0 0 0 2.39 1.64 2.55 2.55 0 0 0 2.35-1.94c.12-.83-.73.68-1.76.94s-1.61.52-2.08 0a1.5 1.5 0 0 0-.9-.6Z"
        className="Mexico_svg__cls-27"
      />
      <path
        id="Mexico_svg__path651"
        d="M653.28 427.84a2.21 2.21 0 0 1-.76 1.9 2.8 2.8 0 0 1-2 .58 1.67 1.67 0 0 1-1.46-.62 6.3 6.3 0 0 1-.66-1.26 2.49 2.49 0 0 0 2.56 1.21 4.13 4.13 0 0 0 2.32-1.81"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path653"
        d="M679.65 411.5a2.16 2.16 0 0 1-1 1.78 3.2 3.2 0 0 1-1.93.61 2.16 2.16 0 0 1-1.57-.83c-1.16-1.8-.48-3-.48-3s.84 3.14 2.44 2.92a4.1 4.1 0 0 0 2.54-1.49Z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path655"
        d="M656.14 417.12s-.8 2.46-2.42 2.46-1.48-.47-1.37-.78.73.31 1.45.09a10.2 10.2 0 0 0 2.34-1.77"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path657"
        d="M660.69 416.68s-.16 1.78.44 2.39a2.76 2.76 0 0 0 2 .91 1.89 1.89 0 0 0 1.7-.86 1.56 1.56 0 0 0 .21-1.43 1.4 1.4 0 0 1-.5.89 1.77 1.77 0 0 1-1.44.6c-.51 0-1.39-.06-1.65-.67s-.76-1.83-.76-1.83"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path659"
        d="M669.05 408.1a2.43 2.43 0 0 1-.51 2.42c-1 1.08-3 .48-3 .48s1.58.38 2.34-.48a6.7 6.7 0 0 0 1.17-2.42"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path661"
        d="M642.4 438.85s10.36-.18 11.19-1.6-.89-7 5.37-11.4 11.11-4.35 14.43-4.61 10.49-2.49 11.75-8.87c.77-3.89-4.47-4.15-6.45-7.84s-7.09-2.2-7.34-2.2-5.93-.16-8.62 2.46c-1.6 1.56-1.41 3.5-2.18 4.41s-7.6 0-8.36 1.1.19 3.43-.33 3.95-2.16-1.5-2.16-1.5l.57-5.5 8.75-5.12 10-5.51s6.52.33 6.77.2 6.71 3.37 6.9 3.43 3.38 3.89 3.38 3.89a17.7 17.7 0 0 1 .9 4.6 10.4 10.4 0 0 1-.31 3.82c-1.61 5.73-7.23 9.59-13.14 9.88a27.83 27.83 0 0 0-13.94 4.92c-2.71 2-4 10.6-4.09 11.63s-12.88.34-12.88.34l-.17-.48Z"
        className="Mexico_svg__cls-28"
      />
      <path
        id="Mexico_svg__path663"
        d="M646.76 418.66c-.52.42-1.3.4-1.47-.2-.48-1.69.53-4.2.53-4.2a18.7 18.7 0 0 0 .17 3.06c.2.43.72.33 1 .69.01.13.19.31-.23.65"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path665"
        d="M653.28 417.33c-.51-.15-.42-1.75 0-2.43a23.5 23.5 0 0 1 3.3-2.82s-.93 2.14-1.29 2.92-1.34 2.53-2 2.33Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path667"
        d="M650.71 427.86c-.4.08-.54-.81-.54-1.95s2-3.2 2-3.2a22 22 0 0 0-.67 2.39c-.06.59.32 1.1.25 1.79s-.56.87-1 1Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path669"
        d="M655.54 424.94a8.6 8.6 0 0 1-2 1.66c-1 .57-2.2 1.45-2.84 1.26s.41-1.58.77-1.72a31 31 0 0 1 4-1.2Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path671"
        d="M664.41 412.28a6.8 6.8 0 0 0-1.75 2.36c-.58 1.39-.83 2.53-.26 2.79s1.44-1.59 1.51-2.21.5-2.94.5-2.94"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path673"
        d="M667.67 416.71a5.5 5.5 0 0 0-2.3-1.12c-1.46-.37-2.14 0-2.29.38s-1.25 1.09-.71 1.41 1.18-.56 1.63-.67a3.74 3.74 0 0 1 1.76-.28c.79.13 1.91.28 1.91.28"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path675"
        d="M665.77 408c.52.46 1.32-.38 2.05-1.21a9.1 9.1 0 0 0 1.28-2.33 17 17 0 0 0-2.13 1.3c-.65.51-1.49 2-1.2 2.24"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path677"
        d="M679.31 407.71a8.5 8.5 0 0 0-2.34 1.6c-.59.78-1.36 1.64-.77 2.07s1.15-.38 1.62-1 1.49-2.64 1.49-2.64Z"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__path679"
        d="M675.43 416.78a5.5 5.5 0 0 1-1.69 1.94c-1.11.74-2.43 1.08-2.64.69s.17-1.21.59-1.42a9.6 9.6 0 0 1 1.66-.43 14.5 14.5 0 0 0 2.08-.78"
        className="Mexico_svg__cls-26"
      />
      <path
        id="Mexico_svg__polygon681"
        d="m590.51 371.58-3.36 8.4 2.75-.38 1.58-7.39z"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__path7828"
        d="M581.78 385.83c-.72 4.61 1.19 8.75 4.28 9.24s6.16-2.84 6.88-7.44-1.2-8.75-4.28-9.24-6.16 2.84-6.88 7.44"
        style={{
          fill: "url(#Mexico_svg__radial-gradient)",
        }}
      />
      <path
        id="Mexico_svg__polygon683"
        d="m591.77 372.08-1.38-.89-.12.29.24.1-.13.22.82.53-1.51 7.03-2.14.3 3.2-7.98-.24-.1-.13.22.13-.22-.24-.1-3.52 8.81 3.36-.46z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path685"
        d="M592.08 368a2.33 2.33 0 1 0 1.88 2.59 2.27 2.27 0 0 0-1.88-2.59"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__path687"
        d="M592.08 368v-.23h-.29a2.5 2.5 0 0 0-2.39 2.23v.33a2.47 2.47 0 0 0 2.1 2.51 1.5 1.5 0 0 0 .29 0 2.5 2.5 0 0 0 2.42-2.26 2 2 0 0 0 0-.33 2.48 2.48 0 0 0-2.1-2.51v.47a2 2 0 0 1 1.7 2v.28a2 2 0 0 1-2 1.85h-.23a2 2 0 0 1-1.7-2.05v-.27a2 2 0 0 1 2-1.85h.23v-.24Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path689"
        d="M592.9 368.33s.68.36-.1.12-2.64.67-2.64 2a2 2 0 0 0 2 2.05c1 0-.36.18-.36.18l-1.27-.37-.52-.76-.42-1.06.32-1.13.75-1 1-.35.65.07.67.25Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path691"
        d="M591 374s-.54-.11-1 .61-1.46 2.08-1.46 2.08l1.87-4.62 1 .53z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__polygon693"
        d="m736.79 389.01-8.28 7.77 3.41.87 5.68-7.48z"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__polygon695"
        d="m737.93 390.17-1.1-1.55-.21.21.17.18-.2.16.7.99-5.47 7.2-2.79-.71 7.94-7.44-.18-.2-.2.16.2-.16-.17-.18-8.63 8.09 4.02 1.02z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path697"
        d="M740.48 385.79a3 3 0 0 0-3.93 1.12 2.62 2.62 0 0 0 .87 3.75 3 3 0 0 0 3.93-1.11 2.63 2.63 0 0 0-.87-3.76"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__path699"
        d="m740.48 385.79.11-.2a3 3 0 0 0-1.44-.37 3.34 3.34 0 0 0-2.8 1.56 3.14 3.14 0 0 0-.48 1.64 2.77 2.77 0 0 0 1.44 2.45 3 3 0 0 0 1.44.36 3.29 3.29 0 0 0 2.78-1.56A2.93 2.93 0 0 0 742 388a2.74 2.74 0 0 0-1.44-2.45l-.1.2-.11.2a2.29 2.29 0 0 1 1.19 2.05 2.57 2.57 0 0 1-.41 1.38 2.86 2.86 0 0 1-2.4 1.35 2.5 2.5 0 0 1-1.22-.31 2.3 2.3 0 0 1-1.2-2 2.7 2.7 0 0 1 .41-1.39 2.87 2.87 0 0 1 2.41-1.34 2.6 2.6 0 0 1 1.22.3l.11-.2Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path701"
        d="M741.29 386.52s.61.73-.19.09-3.42-.51-4.11.95a2.28 2.28 0 0 0 1.22 3.2c1.15.47-.51 0-.51 0l-1.29-1-.21-1.1v-1.38l1-1.1 1.38-.72 1.32.06.71.4.67.58Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path703"
        d="M736.14 391.93a1.45 1.45 0 0 0-1.52.2c-.93.57-2.78 1.62-2.78 1.62l4.59-4.26.92 1.08z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__polygon771"
        d="m526.37 344.18 4.37 9.62 1.88-2.68-4.95-7.29z"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__polygon773"
        d="m527.79 343.54-1.78.46.13.28.23-.1.06.24 1.14-.29 4.74 6.99-1.52 2.17-4.19-9.23-.23.12.06.24-.06-.24-.23.1 4.55 10.04 2.24-3.2z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path775"
        d="M524.62 340a2.68 2.68 0 0 0-.24 3.74 2.58 2.58 0 0 0 3.67.45 2.68 2.68 0 0 0 .25-3.75 2.59 2.59 0 0 0-3.68-.44"
        className="Mexico_svg__cls-16"
      />
      <path
        id="Mexico_svg__path3910"
        d="M541.64 359.5c2.33 4.44 1.81 9.34-1.16 10.95s-7.27-.7-9.6-5.15-1.81-9.3 1.12-10.95 7.31.7 9.64 5.15"
        style={{
          fill: "#f15770",
        }}
      />
      <path
        id="Mexico_svg__path2929"
        d="M541.64 359.5c2.33 4.44 1.81 9.34-1.16 10.95s-7.27-.7-9.6-5.15-1.81-9.3 1.12-10.95 7.31.7 9.64 5.15"
        style={{
          fill: "url(#Mexico_svg__radial-gradient-2)",
        }}
      />
      <path
        id="Mexico_svg__path777"
        d="m524.62 340-.14-.18a2.78 2.78 0 0 0-1 2.15 3 3 0 0 0 .7 1.93 2.94 2.94 0 0 0 2.27 1.1 2.7 2.7 0 0 0 1.73-.63 2.79 2.79 0 0 0 1-2.15 3.08 3.08 0 0 0-.7-1.93 2.94 2.94 0 0 0-2.27-1.1 2.7 2.7 0 0 0-1.73.63zl.15.18a2.22 2.22 0 0 1 1.44-.52 2.51 2.51 0 0 1 1.92.92 2.64 2.64 0 0 1 .59 1.64 2.34 2.34 0 0 1-.81 1.79 2.24 2.24 0 0 1-1.44.52 2.49 2.49 0 0 1-1.92-.93 2.6 2.6 0 0 1-.55-1.6 2.32 2.32 0 0 1 .81-1.79l-.15-.18Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path779"
        d="M525.55 339.5s.84-.29 0 .2-1.55 2.8-.45 3.86a2.24 2.24 0 0 0 3.28-.05c.8-.84-.14.46-.14.46l-1.32.79-1.06-.16-1.23-.48-.69-1.18-.21-1.43.48-1.12.58-.49.75-.4Z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path781"
        d="M528.78 345.68a1.29 1.29 0 0 0-.3 1.37c.22 1 .58 2.92.58 2.92l-2.38-5.32 1.26-.46z"
        className="Mexico_svg__cls-17"
      />
      <path
        id="Mexico_svg__path783"
        d="M526 360.35a5.44 5.44 0 0 0 2.9-.09c1-.52 1.19-1.3 1.44-1.55a2.8 2.8 0 0 0 .43-1.81 7.34 7.34 0 0 0-1.87-2.85c-.43-.18-1.88 0-2.13-.26s.21-.83-.34-1-3.4 3.12-2.9 3.64.81-.26 1 .17a9 9 0 0 1 .05 2.15c0 .52 1.44 1.56 1.44 1.56Z"
        className="Mexico_svg__cls-33"
      />
      <path
        id="Mexico_svg__path785"
        d="M528.81 354.3a7 7 0 0 0 1.7 2 4.5 4.5 0 0 0 2.13.05c.43-.18 1.79-1.47 1.83-2a2.9 2.9 0 0 0-.25-1.55c-.26-.57-.11-2.07-.62-2.16a1.4 1.4 0 0 1-1-.45c-.26-.31.16-.85-.23-1.41s-4.93 2.12-4.59 2.64.81 0 1 .3-.21 2.07 0 2.59Z"
        className="Mexico_svg__cls-33"
      />
      <path
        id="Mexico_svg__path787"
        d="M539.11 353.14c.25-.69.17-2.94-.3-3.42s-1.24-.51-1.28-.82.56-.43.56-.95-5.07.17-4.73.74 1.2.26 1.15.6-.85.78-.94 1.22a5.6 5.6 0 0 0 .47 2.2c.22.35-.08.77.51 1s.51.22 1.07.39a6.75 6.75 0 0 0 2.81-.13c.25-.22.42-.13.68-.82Z"
        className="Mexico_svg__cls-33"
      />
      <path
        id="Mexico_svg__path789"
        d="M529.14 356.17c.41.63-.14 2.14-.48 2.56s-2.61-.19-2.64-.61-.2-1.14.09-1.54 1.07-1.31 1.64-1.19a2.76 2.76 0 0 1 1.39.78"
        className="Mexico_svg__cls-34"
      />
      <path
        id="Mexico_svg__path791"
        d="M529.74 353.35a1.51 1.51 0 0 0 .41 1.53 3.37 3.37 0 0 0 2.37.45c.45-.28 1.13-2.8.81-3.19a2 2 0 0 0-1.48-.42 7.3 7.3 0 0 0-2.11 1.63"
        className="Mexico_svg__cls-34"
      />
      <path
        id="Mexico_svg__path793"
        d="M535.18 350.78a1.76 1.76 0 0 0 0 1.45 3.55 3.55 0 0 0 1.87.93c.63 0 .92-1.79.92-2.13s-.18-.47-.62-.67a6.5 6.5 0 0 0-2.21.42Z"
        className="Mexico_svg__cls-34"
      />
      <path
        id="Mexico_svg__path795"
        d="M582.18 378.45s.83 1.44 1.75 1.78a3.14 3.14 0 0 0 1.8 0 2.35 2.35 0 0 0 1.36-.79 6.6 6.6 0 0 0 .66-2.85c-.15-.38-1.1-1.19-1.09-1.5s.63-.35.38-.77-3.9-.33-3.92.29.63.36.47.72a7.2 7.2 0 0 1-1.3 1.29c-.32.31-.11 1.83-.11 1.83"
        className="Mexico_svg__cls-33"
      />
      <path
        id="Mexico_svg__path797"
        d="M587.51 376.66a6.1 6.1 0 0 0-.25 2.27 4 4 0 0 0 1.22 1.36 3.83 3.83 0 0 0 2.32 0 2.35 2.35 0 0 0 .8-1.07c.2-.49 1.21-1.28 1-1.66a1.13 1.13 0 0 1-.3-.88c0-.35.61-.39.73-1s-4.19-1.88-4.31-1.36.5.48.39.79-1.4 1.09-1.57 1.55Z"
        className="Mexico_svg__cls-33"
      />
      <path
        id="Mexico_svg__path799"
        d="M594.26 382.48c.57-.24 1.9-1.61 1.92-2.18s-.4-1.09-.24-1.29.58.1.91-.21-3.08-3.09-3.22-2.55.53.9.3 1.08-1-.09-1.29.12a4.5 4.5 0 0 0-1.08 1.58c-.09.34-.53.4-.31.9s.16.46.38.91a5.8 5.8 0 0 0 1.73 1.7 1 1 0 0 0 .9-.06"
        className="Mexico_svg__cls-33"
      />
      <path
        id="Mexico_svg__path801"
        d="M586.55 378c-.14.63-1.39 1.17-1.85 1.2s-1.4-1.76-1.17-2 .58-.8 1-.84 1.43-.1 1.7.34a2.36 2.36 0 0 1 .32 1.33Z"
        className="Mexico_svg__cls-34"
      />
      <path
        id="Mexico_svg__path803"
        d="M588.65 376.69a1.25 1.25 0 0 0-.7 1.16 3 3 0 0 0 1.11 1.75c.43.12 2.38-.93 2.43-1.36a1.7 1.7 0 0 0-.61-1.17 5.9 5.9 0 0 0-2.23-.38"
        className="Mexico_svg__cls-34"
      />
      <path
        id="Mexico_svg__path805"
        d="M593.42 378.63a1.52 1.52 0 0 0-.88.87 3.1 3.1 0 0 0 .53 1.73c.39.37 1.63-.47 1.84-.66s.19-.4.05-.79-1.54-1.15-1.54-1.15"
        className="Mexico_svg__cls-34"
      />
      <path
        id="Mexico_svg__path807"
        d="M724.32 393.36a4.77 4.77 0 0 0 .69 2.33 3 3 0 0 0 1.51.85 2.18 2.18 0 0 0 1.49 0 6.1 6.1 0 0 0 1.8-2.1c0-.37-.41-1.51-.26-1.77s.67 0 .65-.47-3.13-2.12-3.42-1.6.37.6.08.83a7 7 0 0 1-1.65.46c-.4.11-.89 1.49-.89 1.49Z"
        className="Mexico_svg__cls-33"
      />
      <path
        id="Mexico_svg__path809"
        d="M729.35 394.4A5.8 5.8 0 0 0 728 396a3.2 3.2 0 0 0 .28 1.58 3.7 3.7 0 0 0 1.85 1 2.4 2.4 0 0 0 1.18-.44c.4-.28 1.6-.4 1.6-.8a1 1 0 0 1 .21-.79c.2-.24.68 0 1.06-.39s-2.37-3.31-2.72-3 .14.59-.1.77-1.65.17-2 .44Z"
        className="Mexico_svg__cls-33"
      />
      <path
        id="Mexico_svg__path811"
        d="M730.41 401.73a4.6 4.6 0 0 0 2.73-.14c.39-.34.44-.92.68-.94s.33.43.74.44 0-3.81-.45-3.57-.25.89-.52.85-.59-.66-.94-.73a4.6 4.6 0 0 0-1.76.29c-.28.16-.62-.08-.8.36s-.19.38-.34.79a4.55 4.55 0 0 0 0 2.12c.17.19.1.32.64.53Z"
        className="Mexico_svg__cls-33"
      />
      <path
        id="Mexico_svg__path813"
        d="M728.32 394.77c-.39.47-1.67.33-2.07.14s-.41-2.15-.09-2.26.83-.39 1.2-.23 1.24.59 1.28 1.08a2.34 2.34 0 0 1-.32 1.27"
        className="Mexico_svg__cls-34"
      />
      <path
        id="Mexico_svg__path815"
        d="M730.23 395a1.23 1.23 0 0 0-1.13.54 2.36 2.36 0 0 0 0 1.81 4.07 4.07 0 0 0 2.62.1 1.46 1.46 0 0 0 .1-1.16 5.3 5.3 0 0 0-1.58-1.29Z"
        className="Mexico_svg__cls-34"
      />
      <path
        id="Mexico_svg__path817"
        d="M732.4 398.83a1.53 1.53 0 0 0-1.16 0 2.63 2.63 0 0 0-.79 1.38c0 .48 1.4.74 1.66.74s.4-.12.56-.44-.27-1.68-.27-1.68"
        className="Mexico_svg__cls-34"
      />
      <path
        id="Mexico_svg__polygon819"
        d="m610.38 268.8-1.11-2.91-4.45-1.67-1.3-.26.94-2.17 3.62-1.32 3.62-.15 3.8-.15 1.76 1.21 1.95 4.51-7.22 4.3-1.17.39z"
        className="Mexico_svg__cls-35"
      />
      <path
        id="Mexico_svg__path821"
        d="M636.36 221.4s-13.8-2.6-13.57 8.89c.07 3.63.87 4.88 3.79 5.7s8.77 1.11 13.73 5.55 5.32 7.7 5.32 10.37a12.9 12.9 0 0 1-1.23 5.09l3.13 15.18 3.14 11.25 9.34-5.4 5.48-16.66-7-30-22.12-10Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path823"
        d="m636.36 221.4.08-.38a20 20 0 0 0-3.26-.26 13.7 13.7 0 0 0-6.9 1.61c-2.2 1.31-3.89 3.7-3.88 7.64v.28a7.73 7.73 0 0 0 .89 4.12 5.15 5.15 0 0 0 3.18 2c1.51.42 3.67.69 6.09 1.42a19.3 19.3 0 0 1 7.49 4.05 16.4 16.4 0 0 1 4.42 5.72 10.7 10.7 0 0 1 .77 4.36 11.4 11.4 0 0 1-.6 3.43c-.15.46-.31.84-.42 1.1s-.1.23-.13.3l-.05.1-.04.11 3.17 15.33 3.26 11.67 9.9-5.73 5.56-16.91-7.08-30.28L636.48 221h-.05l-.07.38-.15.35 21.94 9.92 6.93 29.7-5.39 16.41-8.79 5.09-3-10.77-3.14-15.16-.37.08.33.18a13.2 13.2 0 0 0 1.28-5.29 11.5 11.5 0 0 0-.82-4.67 17.24 17.24 0 0 0-4.63-6 19.9 19.9 0 0 0-7.77-4.22c-2.48-.74-4.69-1-6.1-1.41a4.46 4.46 0 0 1-2.75-1.64 7 7 0 0 1-.77-3.7V230c0-3.72 1.51-5.76 3.5-7a12.9 12.9 0 0 1 6.51-1.5 21 21 0 0 1 2.25.12l.64.08h.22l.07-.38-.15.35.15-.35Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path825"
        d="M650.06 279.16s4.81-1.81 6.05-5.7c.34-1.07-4.86-5.74-5-5.74a29.5 29.5 0 0 1 3.91 2.5c1.28 1.17 2.26 1.64 2.64 1.47s2.6-5.31 1.75-6.44-2.17-3.75-4.18-5.09a8.4 8.4 0 0 0-4.64-1.17s3.67-1.16 5.5-.13 2 2.25 2.21 1.82a21.8 21.8 0 0 0-1.21-7.3 4.62 4.62 0 0 0-3.9-3 19.8 19.8 0 0 0-4.59-.27s3.19-1.77 5.61-1.16 2.39 1.81 2.6 1.55-1.2-4.7-1.76-5.83a13.2 13.2 0 0 0-4.29-3.63 21.6 21.6 0 0 0-3.45-.34h-1.27a6.94 6.94 0 0 1 4.18-1.06c2.33.22 2.46 1 2.8.87s-.26-.43-1.68-1.43-8.33-3.93-8.33-3.93l-6.3-.09a1.92 1.92 0 0 1 1.77-1.9c1.83-.3 2.36.24 2.23-.24s-5.31-1.61-5.31-1.61-3 .08-4.27.13-5.91.58-5.91.58a5.2 5.2 0 0 1 1.31-1.81 7 7 0 0 1 2.67-1.21c2-.56-1.15-2.16-1.15-2.16l1.7-2.59 7.67.65 16.18 9.46 7.58 6.52 4.82 12.28-1.45 21.08-10.82 8.94s-4.76.74-4.76.52 1.1-4.54 1.1-4.54Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path827"
        d="M636 226.81a11.5 11.5 0 0 1-.51-3.37c0-1.88.32-1.81.32-1.81s-5.17-.72-8.94 2.26-1.6 8.17-1.6 8.17a12.1 12.1 0 0 1 3.75-2.4 20 20 0 0 1 5.9-.65c.32-.32-.83-1.81-2.24-2.14a25.6 25.6 0 0 0-4.15-.32 6.94 6.94 0 0 1 4.35-.84c2.74.26 3.12 1.1 3.12 1.1"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path829"
        d="m652.15 281-3.5 1.22 2.13 14.68 14 23.93 7.33-1.29 2.47-4.41a3 3 0 0 1 2 .87c.84.86 3.58 5.52 5.88 6.47s3.48.61 5.53 2.25 9.52 12.77 9.9 13.19-.43-4.77-.43-4.77l-2.27-6.65-2.83-4.64-.43-1.25h3.88l2.4 1.47 3.68 3.08 1.92 2.27 1 2.34.42 2 1 3.18 2 4.41 2.45 4.19.78-1.71-1.24-4.83-3.75-12-2.29-4a34 34 0 0 0 3.82 2.45c.81.29 3.56 4.39 3.56 4.39l1.75 4.23 1.26 3.93.86 3.44 1.26 3.67 2.17-1.25-.38-2.66-1.87-8.2-.81-8.87a3.37 3.37 0 0 1 2.31 1.38 17.5 17.5 0 0 1 2.44 4.58l.94 8 1.27 7.37 2.38 7.51 2.49 4.73 1.62 2.65s.09-3.75.06-3.92-3-31.44-3-31.44l.41-1.32s.36-.2 1.4 1.29a29 29 0 0 1 2.09 3.82l.91 4.91.45 3.39.64 6.39.85 6.93 3.2 7.44 1.72 4 1-4.77-1.52-33.63.71-1a13 13 0 0 1 2.38 2.51 10.5 10.5 0 0 0 1.71 2l1 7.41.94 21.21.74 5.47 6.24-55.55 3.85-.84.45-1.06-2.81-2.16-6.32-9.81-4.26-9.48-7.47-13.77-13-15.81s-8-6.87-10.09-8.42a41 41 0 0 0-3.74-2.53l.64-2 2.14-3.47-.35-.16-1.67.1-4.33.61-4.38-1.29-8.59-6-9.19-4.37-5.4-1.91-13-3.31-13-1.75-5.82-.08-5.3 1s-2.69 1.11-3.54 2.78-.9 2.82-.64 5.25 1.72 3.7 5.36 5.19 12.2 7.19 12.2 7.19l4.12 4.15 1.53 2 .23 1.53 2.77 21.93-5.49 11.89-3.94 2Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path831"
        d="M666.16 315.05s2.34 4 5.66.91-1.45-11.79-1.4-12.31S672 303 672 303l2.43 4.49a10.18 10.18 0 0 1 .89 6.26c-.55 3.85-4.26 7.18-4.26 7.18l-4.21-1-.64-4.88Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path833"
        d="m747.73 366.31-3-8.88s-.88-5.7-.88-6.87-.58-15.62-.84-18.33-.12-5.84-.41-6.22-3.26-4.31-3.26-4.31l-1.27-1.33.9-.65s1.11 1.21 1.41.56 0-3.8-1.28-8.72-7.54-16.46-7.54-16.46l.68.56 1.75 1.77 3.7 3 8 2.94 4.31.63 2.81 5.62s2 9.67 1.88 14.55-.43 8.86-2.3 13.74-2.34 20.34-2.6 22.8a22 22 0 0 1-1.19 4.88l-.9.68Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path835"
        d="M747.75 340.63a13.6 13.6 0 0 0 2.41-4.75c.74-2.74 1-24.28-1.53-26.95s-7.77-4.76-8-4.59 2.09 7 2.09 7a15 15 0 0 1 1.58 2.79 20.3 20.3 0 0 1 1.15 3.44c.29 1.86 1.82 6.22 2 11.85s.29 11.19.29 11.19Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path837"
        d="M736 354.15a124 124 0 0 0 .59-17.66c-.51-7.46-1.13-8.4-1.84-9.75a63.4 63.4 0 0 1-5-12.44c-1.74-6.22-2.86-11-4-12.23s-3.38-3.94-3.89-3.21a5.05 5.05 0 0 0-.51 2.28l-3.07-.83-.71-2 1-3.18-.19-1.36-.36-2.24 4 3.15 8.13 5.57 4.09 16.87 3.79 10.5.53 17.78-.38 15.65z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path839"
        d="M740.76 305.51a24.7 24.7 0 0 0 3.37 2.71c1.25.69 3.59 2.14 3.13 2.3s-2.67-.7-4-1.48a11 11 0 0 1-2.31-1.73l-.15-1.8Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path841"
        d="M724.91 350.13a19.1 19.1 0 0 0 1.37-8.12c-.26-4.54-2.43-15.47-3.11-16.85s-3.91-3.45-6.81-9.59-2.6-7.38-4.51-9.63-3.93-4.79-3.93-4.79l.6-6.57 7.07 3.59 3 1.51 3.58 17.19 3.2 4.79 1.35 6.87 1.71 16 .93 12.74-.5 1.12-4-8.29Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path843"
        d="M716.76 342.85a35.7 35.7 0 0 0-1.09-9.58c-1.28-4.54-2.17-7.92-3.58-9.34a69 69 0 0 1-8.17-9.91 114 114 0 0 0-7.6-9.85l.12-6.43a19.5 19.5 0 0 0 3.92 2.87c1.81.88 4.52 2.4 4.52 2.4l1.89 7.37 2.44 5.31 3.57 4.74 2.28 2.11 1.46 7.94.78 4.46 1.89 6.38-.63 3.19z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path845"
        d="m710.88 342.92-2-1.88a4.63 4.63 0 0 0 .55-3.79 30.3 30.3 0 0 0-2.34-7.36c-1.14-2.39-1.49-3.85-2.19-4.56s-6.68-6.36-8.76-8.07-5.26-5-7.24-6.25a11.8 11.8 0 0 0-3.42-1.59l-1.12-7.91s2.62 3.5 4.18 4.08 4.13 1.4 4.13 1.4l5.55 9.81 1.88 2.5 5.15 4.11 2.1 4.24 1.57 4.9 1.95 6.74.35 4.08-.39-.45Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path847"
        d="M700 340.71s-3.27-3.75-3.79-6.18.35-2.42-.68-5.18-4.43-6.82-7.24-9.07-6.81-5.53-6.55-7.34.76-1.9.76-1.9l1.71 1.46 8.76 9.34 2.69 4.88 2 6.09 1.37 2.85 1.31 3.63-.38 1.42Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path849"
        d="M731.6 294.93s6 7.5 7.58.6c.68-3.06-2.1-8.9-2.1-8.9s-5.61-9.84-7.53-12.22S718.27 260 718.27 260l-6.85-3.2 2.34 4s5.11 5.1 11.63 16.37 5.23 17.49 5.23 17.49l1 .22Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path851"
        d="M696.51 249.75s12 10.23 19.74 21.31 10.79 18.47 9.06 20-6.58-.84-8.55-3.95-3.65-8.56-10.93-16.85-10.83-9.57-10.83-9.57l-5.24-8.48 6.71-2.46Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path853"
        d="M690.26 274.3a156 156 0 0 1 11.55 10.7 74 74 0 0 1 6.78 8.23l2.87 2.85s-1.73-3-.77-4.08a1.88 1.88 0 0 1 2.11-.52l-22.55-23.65v6.48Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path855"
        d="M688.78 275a36.3 36.3 0 0 0 6.07 8.1c3.77 3.69 7.92 7.64 7.92 7.64l1.6 5.77s-10.29-7.9-10.35-6 2.49 6 2.49 6l-3.13-1.68-4.38-6.34-2.62-5.44-2.94-7.52 5.3-.58Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path857"
        d="M657.68 299.31s5.37 4.8 8.31.13.64-10 .64-10 7.57 11.17 9.7.71c.39-1.88-4.6-9.14-4.6-9.14l1.79-1.68 3.83 6.48a6.7 6.7 0 0 0 3.58-6.09c0-4.47-3.7-10.24-3.7-10.24l3.53 3.93s7 .15 7.13-4.12-5.89-8.79-5.89-8.79 4.79.32 4.72-2.46-6.51-4.73-6.64-6.48 1.92-4.73 4.85-3.11 7 2.91 8.69-.26-.13-3.82-.13-3.82-3.77-.78-4.15-.91-6.71-3.56-6.71-3.56l-5.31-2-5.48-.72 2 4.09 1.41 11.2.06 5.19 1 11.27-2.68 9.4-1.31 1.67-1 1.26-2.34 5-3.28 3.56-4.2 5.37-3.83 4.15Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path859"
        d="M695.7 320.37a15.1 15.1 0 0 0-4.25-5.61c-2.9-2.25-7.5-2.42-7.5-2.42l7.88 8.34z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path861"
        d="M706.73 322.27a40.8 40.8 0 0 0-5.53-8.21c-3-3.11-5-7.12-5.76-7.12a5.7 5.7 0 0 0-1.4.17l.77 6.43 5.45 5.28s5.11 3.8 6.47 3.45"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path863"
        d="M715.79 321.88a50.8 50.8 0 0 0-4.29-11.62c-3-5.7-6.22-8-6.22-8l.72 6.09 2.48 5.87 4 5.79 3.31 1.9Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path865"
        d="M723.21 318.55s2.12-12.18.21-15.55a8.63 8.63 0 0 0-5.53-4l-1.16 1.76 1.16 8.69 2.89 6.65 2.43 2.46Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path867"
        d="M730.5 298.25s1.78.91 4 5 5.24 16.25 5.19 16.89-1.14.5-1.44.35-7.67-11.67-7.67-11.67l-1.17-10.75 1.14.17Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path869"
        d="M679.07 312.4s3.9-.84 3.9-2.2-4.66-4.08-4.28-6.29c.19-1.1 4 .2 4.22-.58s-3.89-7.26-2.62-8.74 4.79 7 4.79 7 2.1 4 1.34 6.29c-2.37 7.06-7.35 4.53-7.35 4.53Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path871"
        d="M688.2 303.59c.19-.57 6.14.78 6.2.39.23-1.4-5.36-5.7-5.36-5.7s-1.28-2.46-.89-2.85 4 .39 4.15-.13-4.1-6.16-4.1-7.19 1.16-.13 1.16-.13a50 50 0 0 1 5.18 6.35c1.78 2.85 3.46 5.18 2.86 9.71-.63 4.86-9.7 1.1-9.2-.45"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path873"
        d="M715 294.65s-1-4-.39-4.54a7.7 7.7 0 0 1 2.12-1s-3.17-2-4.67-2-1.72-.47-2.11.16 2.72 4.54 2.72 4.54l2.33 2.82Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path875"
        d="M697 297.76s9.13 2.27 9.52 1.62-7.29-7.78-7.29-7.78a4.7 4.7 0 0 1-.38-1.75c.13-.45 3.32-.51 4.28.26s0 2.27.32 2.85 3.2 5 3.71 4.28-.58-6.09-.32-6.48 3.51 3 4.4 3.63 6 4.6 6.52 2.72.83-2.2.63-3.31 1.71 5.19-.68 6-5.13-.83-5.13-.83l-2.11-1.63-1.27-1.34s1.36 4.86-.24 5.37a8.7 8.7 0 0 1-3.44.27l-3.83-.39-4.73-3.5Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path877"
        d="M571.7 277.63c-.08 0-7.57.64-12.72-.25-2.86-.5-4.21-5.06-4-13.57a5.7 5.7 0 0 0 0-.92 2.8 2.8 0 0 0-.4-.6c-.8-1.08-2.67-3.6-2.28-5.9.5-2.91 10.11-10.69 11.34-11.09a5.23 5.23 0 0 1 2.65.52l.14.05.11-.1c1-1 2.58-2.32 3-2.32s.79.39 1.1.88a1 1 0 0 1 .19.74 7.3 7.3 0 0 1-1.06.94c-1.12.87-2.64 2.08-2.82 3.15a13 13 0 0 0-.14 1.37 5.5 5.5 0 0 1-.76 3c-.3.46-.69 1-1.1 1.5a9.9 9.9 0 0 0-2 3.26c-.05.25-.11.5-.17.74-.22.9-.44 1.82.45 2.26s4.21.1 7-1.16a14.2 14.2 0 0 0 3.38-2.21 3.5 3.5 0 0 1 .68-.5l-.09-.12c0 .42-1.73 3.2-4.48 4.35-1 .42-1.87.86-2.65 1.25-1.54.76-2.77 1.38-3.7 1.23h-.18l-.07.16a3.55 3.55 0 0 0 .13 3c.59.95 1.79 1.47 3.55 1.55 5.14.22 8-1.1 8.09-1.16l-.32-.27-3.07 10.39zm3-10.44a18.15 18.15 0 0 1-7.87 1.11c-1.6-.07-2.67-.52-3.18-1.33a3.17 3.17 0 0 1-.1-2.56l-.24.14c1.08.16 2.36-.47 4-1.28.77-.38 1.65-.82 2.62-1.23 2.83-1.19 4.75-4.08 4.76-4.77a.34.34 0 0 0-.2-.32c-.28-.12-.56.11-1.11.58a13.7 13.7 0 0 1-3.28 2.14c-2.81 1.27-5.84 1.55-6.61 1.17-.53-.26-.44-.77-.21-1.72q.1-.37.18-.78a9.8 9.8 0 0 1 1.88-3c.41-.54.8-1.06 1.12-1.53a6.2 6.2 0 0 0 .83-3.2 10 10 0 0 1 .13-1.33c.15-.88 1.65-2.07 2.65-2.86a4.9 4.9 0 0 0 1.19-1.09 1.39 1.39 0 0 0-.21-1.2 2.12 2.12 0 0 0-1.49-1.09c-.77 0-2.91 2-3.33 2.44l.25-.05c-.08 0-2-.84-3-.52-1.28.42-11.11 8.31-11.65 11.45-.43 2.5 1.53 5.14 2.36 6.26a4 4 0 0 1 .33.47v.79c-.08 3.27-.3 13.22 4.41 14 5.2.91 12.75.27 12.83.27h.15l.05-.16 3.04-10.52.14-.5-.47.22Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path879"
        d="M717.93 291.52s9.74 5.85 10.71 4.81-2.55-14.76-2-16.19c.46-1.15 7.92 15.59 4.28 17.88-2.78 1.74-4.15.52-4.15.52L722 296l-4.06-4.49Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path881"
        d="M745.05 316.16a7.2 7.2 0 0 0 2.13 1c.39.12 1.56.47 1.24.51s-2.6.3-2.76.37-.61-1.88-.61-1.88"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path883"
        d="M735.6 283.93a9 9 0 0 0 1.5.69 3.6 3.6 0 0 1 1.32.62 1.82 1.82 0 0 1-1.24.34 3.4 3.4 0 0 1-.83-.21z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path885"
        d="M732.79 279.14a2.36 2.36 0 0 0 2.27-.45c1.28-.91 1.37-1.51 1.26-2s-2.11-.47-2.78-.93a1.52 1.52 0 0 1-.65-1.27h-2.19l-.81.3Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path887"
        d="M741.4 307.41a25.7 25.7 0 0 0 3.82 1.91c.82.17 2.23.95 2 1.2a4.76 4.76 0 0 1-3.51-.19c-1.12-.65-1.49-.25-1.49-.25l-.86-2.67Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path889"
        d="M725.34 263a3.3 3.3 0 0 0 1.19.13c.57-.06 1-.41 1.24-.19.4.45.08 2.53-.73 3.12a5.9 5.9 0 0 1-1.93 1c-.14 0-3.14-4.33-3.14-4.33Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path891"
        d="M711.36 250.51s2-.12 2.93-.11a6.35 6.35 0 0 1 3 1.26c.88.55 1.76 6.44 1.28 7.55s-7-3.81-7.22-4.25-3-4.86-3-4.86l3.06.41Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path893"
        d="M705.2 247.84s4.78.3 4.34-2.74a6.33 6.33 0 0 0-2.63-4.37l-5.73 4.07 4 3Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path895"
        d="M692.38 242.25a3.4 3.4 0 0 0 2.7.14c1.42-.55 5.18-5.44 7.92-6s3.28-.55 3.8.08.26 3.4-.37 4.18-8.58 4.14-8.58 4.14a20.4 20.4 0 0 1-2.94-.39 20 20 0 0 1-2.6-.86l.07-1.26Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path897"
        d="M690.9 233.45c-1.21-2.82-3.36-4-4.17-3.79s2.74 3 3.25 6.89a35 35 0 0 1 .4 6.72c-.07.22 1.65.24 1.65.24l.32-1.48.21-1.06v-1l-.24-2-.42-1.58-.34-1.22a11 11 0 0 0-.64-1.75Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path899"
        d="M679.58 229.43a30.2 30.2 0 0 0-10.75-7.32c-.45 0 7.73 4.92 9.58 8.1s1.92 7.45 2.74 8 1.6-.29 1.67-.38.67-1 .57-1.24-.51-2-.51-2l-1.27-2.14-.77-1.33-1.26-1.68Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path901"
        d="M668.73 225c-4.64-4.09-13-6-19.84-6.12s-10.28.51-9.29 4.24 4.06 5.34 9.8 5.34 7.13-.61 10.23.36a18.9 18.9 0 0 1 7 3.89c1.12 1.16-2.13-2.85-5.07-5.06s-4.87-3.35-4.87-3.35-.56-1.21 3.4-.66 9.26 3.11 10.69 6.41a11.4 11.4 0 0 1 1.19 5.83c0 .72 1.37-.38 1.37-.38l.57-1.63a4.66 4.66 0 0 0-.54-2.75 15.4 15.4 0 0 0-2.68-4.05c-1.79-2.11-2-2.07-2-2.07Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path903"
        d="M649.85 281.06c2.89-.08 9.37-5.61 10.31-13.3s-3.84-23.33-4.94-25 1.78-.77 3.36.87 4.81 12.78 4.81 20.9-1.62 10.46-6 14.6-7.84 3.72-7.84 3.72l.26-1.82Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path905"
        d="M659.9 303.87s1.45 1.81 3.06 1.21c3-1.12 7.58-3.32 7.58-7.6 0-2.77-3.57-5.19-3.74-6.22a6 6 0 0 1 0-1.9l3.14.69.9 4.4s1.24 1.3 2.51.78 4.94-3.2 4.43-5.79-4-5.79-4.34-7.08a4.4 4.4 0 0 1 .08-2.42l3 .51.91 3.79a2.35 2.35 0 0 0 2.49 1c1.7-.35 4.68-3.46 4-4.93s-2.89-4.92-3.06-5.27a5.8 5.8 0 0 1-.09-1.64l1.2.67a5.83 5.83 0 0 0 3.45-.22c2.3-.69 4.53-2.24 4.5-3.83s-1.73-3.11-1.86-4a3.7 3.7 0 0 1 0-1.23l1.5.22 1.86 2.3.44 2.76-.67 2.36-2.8 3.05-2.79 1.17-.76-.07 1.69 2.95-.54 3.92-2.46 2.26-3.3 2-.25 3.66-1.82 4-4.21 2.49h-1.24l-.49 2.4-2.68 3.74-4.54 3-3.32.61-1.92-2.78.17-.95Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path907"
        d="M685.1 262.36s7.64 2.16 7.4-2.68c-.13-2.72-7.49-9-8-10a5.8 5.8 0 0 1-.35-2.46l3.81 3.49s4.87 1.16 6.25-1.65.27-4.57 0-4.63 1.12-.25 1.12-.25l2.25.46-.27 4.33-2.49 10.88s.66 4.27-2.71 4.58-7.08-2.05-7.08-2.05Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path909"
        d="M692.34 320.33a5.05 5.05 0 0 0-1.57-3.74 30.8 30.8 0 0 0-5.52-3.3c-.53-.32 5.47 6.82 5.47 6.82z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path911"
        d="M703.41 320.69a68 68 0 0 1-4.66-6.35c-.84-1.61-2.81-5.18-4.41-5.35s1.5 5.9 1.5 5.9l6.22 5.67z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path913"
        d="M713.91 320.6s-3.28-6.22-4.09-8-2.52-6.77-4.47-8.13.26 2.27.26 2.27l2.08 6.44 3.64 5.61 2.58 1.85Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path915"
        d="M721.64 316.09a85 85 0 0 0-.87-9c-.63-3.69-3.5-6.77-3.69-6.64s.22 6.58.22 6.58l4.34 9.07Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path917"
        d="M737.61 320.08s-2.68-6.39-3.77-9.4-3.77-8.07-4.05-8.13.8 5.8.8 5.8l3.25 9.33z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path919"
        d="M751.47 303.37a23.4 23.4 0 0 0-7.76-4.61 37.3 37.3 0 0 0-10.6-2.3l.64.68 2.4 2.05 5.55 2.81 7.23 1.75 2.54-.42Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path921"
        d="M694.56 306.51s0 4.62 2.42 7.43 8 7.94 9.12 9 2 6.74 3.7 11.49 2.05 8.64 2.77 10 2.21 3.5 1.11 3.28-2.14-1.51-2.82-3.24-.47-1.72-.38-4.1-3.62-14.56-5.32-15.89-9.54-7.87-12.57-12.36-2.38-5.53-2.38-5.53h4.35Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path923"
        d="M707.2 337c-1.66-3.42-2-6.44-2.47-8.47s-7.11-7.56-8.69-8.29c-1.2-.56-3.68.15-4.68-.61s-7.24-7.83-7.24-7.83-.94.88-.64 1.14 6.77 7.26 9.11 9.5 3.62 7.26 5.32 11.14 1 3.11 1.2 5 1.36 3 2.55 3 1.49-.57 1.05-.89a20.3 20.3 0 0 1-4.28-6.87c-1.29-3.37-2.94-9.59-5-11.92-.13-.15-.28-.33-.46-.52.49-.06 1.3-.21 2.55-.28 1.58-.09 8.09 5.92 8.65 7.69s0 2.46 2.68 8.38 4 7.3 4 7.3h.47s-2.47-4.06-4.13-7.47Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path925"
        d="M697 297.76s4.73 3 6.13 3.37a19 19 0 0 0 2.43.52s.7 8.62 4.15 13.47 6.25 6.61 6.25 6.61.13 9.39 2.69 15.88 3.06 14.31 2.49 15.54-2.75-3.82-4.15-8.29-2.75-9.32-3.71-12.31-3.57-7.45-5-8.68-.29-1.1.57-.33a22.25 22.25 0 0 1 5 8.82c1.6 4.95 2.24 10 3.1 10a1.62 1.62 0 0 0 1.5-1.82c0-1-1.12-3.59-1.91-8.22s-1.6-7.81-2.37-9.11-1.89-1.52-4.85-6.7-4.28-8.07-4.79-10.47.09-2.17-.42-2.53-.89 0-3.16-1.22-3.86-4.54-3.86-4.54Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path927"
        d="M709.2 296a30.3 30.3 0 0 0 4.51 2.94 14.2 14.2 0 0 0 4 .82s-.59 8.16 2.6 13.48a42.8 42.8 0 0 0 6.52 8.42s.51 2 1.53 13.39 1.06 11.62 1.36 16.2.44 20.8-.21 20.3c-2.47-1.9-.43-10.71-1.66-14.34s-3.19-4.24-5.58-14.51-.85-12.62-2.55-16.46-4-4.19-4-4.19a6.51 6.51 0 0 1 4.47 3.84c1.32 3.24 1.52 11.85 2.6 16.11 2.42 9.64 5.75 14.52 5.75 14.52s-.73-12.1-1.67-19-.87-12.52-2.16-15.2-4.05-4.76-5.71-8.26-2.26-10.36-3.07-12.13-1.27-1.22-2.42-1.69c-3.75-1.51-4.31-4.23-4.31-4.23Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path929"
        d="M717.93 291.52a29.3 29.3 0 0 0 6.12 5c3.58 2.12 5.37 1.47 5.92 1.9s-.72 7.69 3 14.39 5.11 6.82 5.19 7.74.77 20.64 1.24 27.33 1 29.16-1.79 29.16-.26-16.59-1.62-20.48-1.32-2.76-2.64-5.86-1.27-15.46-3.35-22.7c-1.57-5.44-3.19-6.31-3.19-6.31s2.65 1.43 3.88 5.92 1.62 19.57 3.06 22 3.53 5.4 4 7.65-.3-28.65-.94-30.5-6.86-13.05-7.33-19.22-.68-6.79-1.23-7.26-2.34-.09-5.27-2.85a38 38 0 0 1-5-5.87Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path931"
        d="M732 295.08c.17-.59 1.94 3.32 7.5 5.53s10.86 1.81 11.56 2.39 4.22 8.95 4.34 20.09-1.91 10.11-3.64 19.7-1.79 29.09-2.87 32.07a16.6 16.6 0 0 0-1.66 3.43c-.58 1.88.44 5.45-1.28 5.51s-1.92-2.72-1.92-4.21 1.8-6.8 1.8-12.12-1.16-6-1.92-12.31-.83-26.56-1.53-28.51-4.18-6.15-4.18-6.15 3.73 2.39 4.62 5.11 1 25.18 2 29.68.7-1 1.09-3.63 1.72-13.61 1.53-19.5-2.69-18.66-4.73-20.8a16.5 16.5 0 0 1 2.23 4.05 6.7 6.7 0 0 0 1.59 1.3c.89.51 1.9.77 1.93.86a5.9 5.9 0 0 1-2-.49 4.7 4.7 0 0 1-1.14-.79 47.1 47.1 0 0 1 2.65 15.87c.18 10-1.46 32.14.14 32.4s1.28-12.05 2.94-22 3.89-11.41 3.19-19.57-2.87-17-4.6-18.08-6.64-.71-11-3.5-6.79-5.71-6.6-6.3Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path933"
        d="M661.58 306.31a4.3 4.3 0 0 0 3.45-.19c1.85-.91 6.77-4.79 6.77-6.42s.07-3.23.07-3.23.06.71 1.47.9 5.42-2.85 5.73-4.79.33-5.38-.12-6.09 1.21.71 2-.07 4.73-3.3 4.67-5.89a9.25 9.25 0 0 0-2.17-5 11.1 11.1 0 0 0 3.06 0c1.15-.26 5-2.53 4.85-4.86s-1.46-5.9-4.47-6.16a8.8 8.8 0 0 0 4.41-.25c2.17-.78 2.94-2 2.94-4.48s-4.4-7.77-5.17-8.22 4.72 1.55 6.13-.65 1.59-3.76 1.21-5a2.4 2.4 0 0 0-1.53-1.55 8.38 8.38 0 0 0 5.56-1c3.19-1.62 6-3.76 7.47-3.69s-4.67 3.3-5 5.12c-.13.75 1.68 2 4.45 4.07a4 4 0 0 0 .53.39c1.26.68 6 .87 6.36 1.11s-4.62.19-4.19.51a67.5 67.5 0 0 1 11.23 10.59 4.64 4.64 0 0 0 1.85 1.13c1.12.31 2.39.21 2.55.43s-3.23-.09-3.11.07c2.4 3.13 4.57 6.3 6.44 9.24a5.06 5.06 0 0 0 1.8 1.51c1 .42 2.08.31 2.22.54.25.39-2.74 0-2.51.39 3.74 6.13 6.5 11.82 6.5 11.82a126.8 126.8 0 0 0-13.36-18.8c-7.34-8.23-9.07-9.33-9.45-8.55s5.49 8 8.62 13.15a118 118 0 0 1 6 11.49s-7.37-15.31-17.72-24.71-11.43-10.95-12.58-10.56-2 7.32-1.34 8.75 8.23 7.12 14.68 14.71 14.63 20.6 14.63 20.6a139.5 139.5 0 0 0-15.64-19.83c-9.84-10.43-13.6-12.83-14.37-12.76s-.84 1.94-2 3.5-3.5 1.42-3.5 2.11 8.31 8.42 10 9.33 2.56.46 3.83 1.17a19 19 0 0 1 2.66 1.9s-1.76-.67-3-1.06-2.56-.45-2.56-.06 6.78 8.68 7.92 9.2 1.79.26 3.33.84a21.5 21.5 0 0 1 3.71 2.14 17 17 0 0 0-4-1.69c-1.66-.32-2.37 0-2.3.46s5.17 7 4.92 7.12-7.92-9.07-14.44-14.83-9.45-7-9.77-6.81-.13 1.88-1.73 2.46-3.06.78-3.06 1.36 5.88 6.1 10 10.7 7.73 8.94 7.73 8.94-4.21-4.21-8.81-8.55-7-6-7.41-5.77-.51 2.46-.06 3 8.94 10.63 8.69 10.89-10-12.05-10.67-12.05-1 1.55-1.66 2.27-3.39.71-3.39 1.68 13.8 14.51 13.42 14.83c0 0-11.43-9.84-11.82-9.26s4.79 10 4.47 10.24-6.71-9.92-7.29-9.85-.5 1.17-2.16 2.66-3.77.84-3.84 1.49 9.52 11.27 9.27 11.46-9.71-10.1-10-9.52a1.59 1.59 0 0 0-.31 1.49c.7 2.48 2.83 7 2.55 7.38 0 0-3.07-6.28-3.9-6s-.83 1.49-2.24 2.4-2.55.71-2.68 1.36 1.66 1.75 2.44 3.24a25 25 0 0 1 1.4 4.73 19.4 19.4 0 0 0-2.3-4.47c-1.34-1.75-2.56-2.92-3.58-2.92a2.42 2.42 0 0 0-1.72 1l-1-2.27Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path935"
        d="M751.06 303s3.13-.19 3.51-.84-1.15-.19-4-3.23-10-23.83-17.82-34.28C720 247.54 708 239.7 708 239.7a88.2 88.2 0 0 1 25.36 24.43c11.23 16.42 14 29.29 17.11 32.66s6.22 4 6.05 4.92a2 2 0 0 1-1.88 1.82c-1.19.17-4.09.43-4.09.43l.56-.95Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path937"
        d="M656.66 298.47s.08.25.66.32 4.47-3.8 4.25-4.92a9.8 9.8 0 0 1-3.12-2.07 7.54 7.54 0 0 1-1.73-3.7s1.28 2.53 2.37 3.24 2.81 1.1 3.44.59 6.36-4.75 6-6.42a5.93 5.93 0 0 1-3.45-1.17 6.13 6.13 0 0 1-2-3.76 7.37 7.37 0 0 0 2.77 2.86c1.7.82 3.36.47 3.83-.13s4.22-5.75 3.79-7.26a5.72 5.72 0 0 1-3.62-1c-1.7-1.21-2.59-4.24-2.59-4.24s1.23 2.55 3.4 3a3.55 3.55 0 0 0 4.3-2.41c.34-1.56 1.53-7.35-.29-8.82 0 0-2.82.91-4.82-.12a6.42 6.42 0 0 1-2.72-3.59s1.7 2.33 4 2.63a3.09 3.09 0 0 0 3.62-1.81 11.5 11.5 0 0 0-.21-6c-.68-1.82-2.09-1.69-2.42-4.41 0 0-.73 1.08-3.63 1.08s-4.43-3.28-4.43-3.28 2.31 2.12 4.61 1.94a3.44 3.44 0 0 0 3.19-3.54c0-1.47-1.15-2.77-1.79-4.28s-.68-3.32-1.11-3.11-1 1.6-4 1.12-3.62-2.5-3.62-2.5 2.18 1.51 3.84 1.38 2.72-.9 2.72-2-.63-3.2-4.38-6.39-6.82-5.4-6.82-5.4a61.4 61.4 0 0 1 8 5.31 29.6 29.6 0 0 1 4.93 5.19s3.46 1.12 3.84 0 .32-2.62-.76-4.69a30.5 30.5 0 0 0-4-5.06 22.4 22.4 0 0 1 4.57 5.22c1.46 2.65.8 4.5.92 5.15s6.58 3.14 8 2.27.77-2.76-.45-4.67l-2.21-3.5a23.5 23.5 0 0 1 2.59 3.53c1.09 1.88 2 3.38 1.57 4.25s-1.31 1.26-1.21 1.62 2.23 1.49 4.4 2.62 4.69 2.14 5 1.52a8.9 8.9 0 0 0 .35-4.21 26 26 0 0 0-1.41-5.31 22.2 22.2 0 0 1 1.69 5.31c.26 2.21-.28 3.86.23 4.64s2.1 1 2.1 1-1.27.9-4.11.06-15-7-15.62-6.41 5.68 4.37 8.56 7.09a21.8 21.8 0 0 1 4.28 5.58 32 32 0 0 0-4.41-3.08c-2.17-1.2-8.69-4.54-9.1-4.09s2.46 1 2.68 1.56-2 2.56-2 3.4 9.29 7.29 9 8-2.36 2.4-2.74 2.3-5-3.63-5-3.07 2.64 2.78 2.62 3.27-1.76 1.65-1.45 2.75 5.18 5.09 5.15 6.45-2.78 2.53-2.27 3.4 3 3.95 3 3.95a29.4 29.4 0 0 1-3.55-2.72c-.86-.94-2.59-3-2.89-2.66s-2 4.12-1.89 5 2.33 2.14 2.75 4.44a8.3 8.3 0 0 1-.49 4.7c-.16 0-3.22-4-3.83-4a1.9 1.9 0 0 0-1.88 1.2c-.51 1-2.3 4.15-2.07 4.73s3.22 1.26 3.28 3.66a6.65 6.65 0 0 1-2.07 4.63c-.19 0-3.74-4.76-4.09-4.76a27 27 0 0 0-4.47 5c-.1.55 2.74 2.56 2.24 3.34s-2.44-.29-3.52.32a14 14 0 0 1-3.38 1.39c-.39 0-1-1.29-1-1.29Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path939"
        d="M707.85 239.9a5.2 5.2 0 0 1 .93-1.91c.6-.65 3.07-3.37 2.14-3.92s-4.06.46-6 .29-3.28.33-9-4.44c0 0-18.23-12.74-46.47-14.38-8.94-.52-12.94 2.68-13.37 4.36 0 .39 2.35-3.63 11.33-3.5 4 0 32.39 2.34 47.13 13.91.77.6 5.65 5.28 10.22 4.76s5.53-1 5.43-.39-1.53 2.34-1.85 3.11a18 18 0 0 0-.64 2.21l.22-.1Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path941"
        d="M658.58 243.66s0-.08-.07-.23c-.26-.78-2.08-3.32-5.17-6.18-3.7-3.44-15.2-8.23-15.78-8.43s11.81 5.7 15.27 9c5.55 5.31 5.75 5.83 5.75 5.83Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path943"
        d="M658.56 264a10.25 10.25 0 0 0-3.17-2.8 19.5 19.5 0 0 0-4.86-2.21s4 0 5.62 1.43a9.4 9.4 0 0 1 2.41 3.58"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path945"
        d="M657.11 253.38s-.77-1.1-4.22-2.21-4.28-1-4.28-1 3.2-1.36 5.62-.13a5.4 5.4 0 0 1 2.88 3.37Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path947"
        d="M655.06 244.69s-.7-1.55-3.77-2.65a23 23 0 0 0-5.24-1.3 10.8 10.8 0 0 1 6.27.32c3.06 1.23 2.74 3.63 2.74 3.63"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path949"
        d="M651.36 239.12s-.9-1.23-6.64-2.59a46 46 0 0 0-8-1.43s8.18-.65 10.35.26 4.28 3.76 4.28 3.76Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path951"
        d="M640.82 233.09a42 42 0 0 0-6.9-1.23 69 69 0 0 0-8.69.19s9.84-1.55 12.46-1 3.13 2 3.13 2Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path953"
        d="M608.46 354.84a6.74 6.74 0 0 0 5.2 3.19c3.45.13 6.13 5.06 6.13 5.06L616 366.8l-9.11.43-2.89-4.71 4.51-7.68Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path955"
        d="m608.46 354.84-.22.13a7.3 7.3 0 0 0 1.35 1.61 6.36 6.36 0 0 0 4.06 1.71c1.6 0 3.09 1.26 4.18 2.49a14.5 14.5 0 0 1 1.27 1.68c.15.22.27.42.35.55l.12.2.22-.12-.18-.19-3.72 3.65-8.89.45-2.77-4.45 4.43-7.55-.22-.13-.22.13.22-.13-.22-.13-4.59 7.82 3.1 5 9.36-.44 4-3.92-.09-.2a14.6 14.6 0 0 0-1.8-2.54c-1.13-1.26-2.7-2.58-4.54-2.66a5.8 5.8 0 0 1-3.73-1.57 8 8 0 0 1-1-1c-.1-.13-.18-.25-.23-.33l-.08-.12-.21-.38-.23.38.22.13Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path957"
        d="M608.68 351.69c.3-.6-2.69-6.48-4.81-7.47s.72 1.9.25 3.11a6.54 6.54 0 0 0-.61 2.91c.17.22 1.76 2.7.91 3.83s4.26-2.38 4.26-2.38"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path959"
        d="m608.68 351.69.23.11.05-.23a4.9 4.9 0 0 0-.5-1.55 22 22 0 0 0-2-3.48A7.8 7.8 0 0 0 604 344a1.8 1.8 0 0 0-.73-.22.4.4 0 0 0-.43.41 1.6 1.6 0 0 0 .2.63c.16.34.39.74.58 1.15a2.8 2.8 0 0 1 .33 1.06v.23a9.7 9.7 0 0 0-.67 2.75.63.63 0 0 0 .1.41 7.6 7.6 0 0 1 .6 1.05 4.4 4.4 0 0 1 .5 1.77 1.1 1.1 0 0 1-.19.68l-.1.15v.2l.12.24.19.06a1.2 1.2 0 0 0 .43-.14 24 24 0 0 0 2.42-1.45l1.59-1h.06v-.07l-.23-.11-.15-.22s-.94.65-1.95 1.3c-.5.32-1 .64-1.44.88-.21.12-.4.23-.54.29l-.17.07v.19l.11-.15h-.11v.19l.11-.15-.13.18h.22l-.09-.18-.13.18h.21-.16.15v-.08a1.64 1.64 0 0 0 .3-1 4.9 4.9 0 0 0-.55-2 8.5 8.5 0 0 0-.66-1.14l-.09.07h.1l-.09.07h.1v-.3a9.3 9.3 0 0 1 .64-2.57 1.1 1.1 0 0 0 .07-.41 4.4 4.4 0 0 0-.58-1.71c-.14-.27-.28-.52-.38-.73a1.3 1.3 0 0 1-.15-.4h-.05.05-.05.05l-.13-.05.07.12.06-.07-.13-.05.07.12v-.08.09-.08.09a1.4 1.4 0 0 1 .53.18c.9.41 2.13 2 3.06 3.55a22 22 0 0 1 1.17 2.23 4.7 4.7 0 0 1 .45 1.34h.07-.06.07-.06l.23.12-.15-.22.15.22Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path961"
        d="M607 360.66a4.76 4.76 0 0 0 2.89.44 6.3 6.3 0 0 0 2.42-1.68"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path963"
        d="M606.93 360.89a5.9 5.9 0 0 0 2.27.55 2.8 2.8 0 0 0 .81-.1 6.45 6.45 0 0 0 2.53-1.75l-.37-.35v.05a5.8 5.8 0 0 1-2.25 1.55 2.5 2.5 0 0 1-.67.08 5 5 0 0 1-1.41-.24l-.46-.18-.17-.08-.23.47Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path965"
        d="M605.39 358.38s5.12-3.72 4.69-5.7-1.45-1.9-2.13-1.73-3.83 2.77-4 3.37 1.44 4.06 1.44 4.06"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path967"
        d="m605.39 358.38.15.21a27 27 0 0 0 2.38-2 12.7 12.7 0 0 0 1.65-1.81 3.4 3.4 0 0 0 .79-1.87 1.5 1.5 0 0 0 0-.3 3.06 3.06 0 0 0-.75-1.59 1.5 1.5 0 0 0-1.06-.42 2.4 2.4 0 0 0-.63.09 3.6 3.6 0 0 0-1 .55 23 23 0 0 0-2 1.59c-.31.28-.59.55-.8.78a1.8 1.8 0 0 0-.44.63v.18a3.6 3.6 0 0 0 .24 1.05c.42 1.25 1.24 3 1.24 3l.14.29.24-.18-.15-.21.24-.11s-.37-.78-.73-1.66c-.18-.43-.36-.89-.49-1.3a3.5 3.5 0 0 1-.22-.88 1 1 0 0 1 .15-.22 14 14 0 0 1 1.91-1.77c.39-.31.78-.6 1.1-.82a3.3 3.3 0 0 1 .66-.38 2.2 2.2 0 0 1 .51-.07 1 1 0 0 1 .71.27 2.65 2.65 0 0 1 .6 1.33v.2a3 3 0 0 1-.69 1.55 16 16 0 0 1-2.44 2.51c-.41.35-.78.65-1.05.86l-.42.32.14.21.24-.11-.24.11Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path969"
        d="M601.78 360.93s.94 2.46 2.6 2.46 4-1.34 4.08-2.33-1.66-2.81-2.76-3.33-3.67.82-3.67.82z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path971"
        d="m601.78 360.93-.24.09a7 7 0 0 0 .71 1.29 2.74 2.74 0 0 0 2.13 1.33 6 6 0 0 0 2.77-.82 4.8 4.8 0 0 0 1.07-.8 1.53 1.53 0 0 0 .5-.95V361a3.54 3.54 0 0 0-1-2 6.6 6.6 0 0 0-1.88-1.53 1.8 1.8 0 0 0-.74-.14 6.4 6.4 0 0 0-2.07.49c-.61.24-1.07.48-1.07.48l-.13.07-.27 2.57v.06l.24-.09h.25l.26-2.37h-.26l.12.23.29-.14a7.3 7.3 0 0 1 2.62-.77 1.3 1.3 0 0 1 .53.1 6 6 0 0 1 1.71 1.4 3.2 3.2 0 0 1 .91 1.65 1.07 1.07 0 0 1-.35.62 5.68 5.68 0 0 1-3.48 1.47 2.26 2.26 0 0 1-1.72-1.12 6 6 0 0 1-.48-.82l-.12-.26v-.1l-.24.1h.25-.25Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path973"
        d="M606.42 357.57c-.26.77-3.49 2.28-4.56 2.37s-3.23-2.63-2.34-3 2-.35 2.81-.78 1-1.51 1.49-1.56a2.51 2.51 0 0 1 2.18 1.1c.34.83.72 1.09.47 1.87Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path975"
        d="m606.42 357.57-.24-.09a1.74 1.74 0 0 1-.58.56 11.6 11.6 0 0 1-2 1.07 6.6 6.6 0 0 1-1.76.57 1.2 1.2 0 0 1-.63-.25 5 5 0 0 1-1.11-1.1 2.1 2.1 0 0 1-.5-1.05v-.13c.82-.36 1.93-.31 2.83-.78a2.8 2.8 0 0 0 1-1 3.5 3.5 0 0 1 .28-.41c.08-.09.13-.11.15-.11h.06a2.7 2.7 0 0 1 1 .25 1.56 1.56 0 0 1 .82.72 7 7 0 0 0 .38.78 1.1 1.1 0 0 1 .15.51 1.2 1.2 0 0 1-.07.38l.24.09.24.07a1.8 1.8 0 0 0 .1-.54 1.7 1.7 0 0 0-.21-.75c-.11-.23-.24-.45-.36-.74a2 2 0 0 0-1.08-1 3 3 0 0 0-1.2-.3h-.11a.73.73 0 0 0-.49.29c-.33.4-.59 1-1.1 1.29-.71.39-1.82.36-2.79.77a.61.61 0 0 0-.37.59 2 2 0 0 0 .3.9 5.8 5.8 0 0 0 1.11 1.34 2.3 2.3 0 0 0 1.35.69h.07a9.4 9.4 0 0 0 2.68-1 10 10 0 0 0 1.34-.78 2 2 0 0 0 .76-.82l-.24-.07Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path977"
        d="M603.09 359.72s-5 6.78-7.1 6.44.85-9.64.85-9.64a11.2 11.2 0 0 0 2.47 1c1.66.52 3.32 1.12 3.78 2.16Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path979"
        d="m603.09 359.72-.2-.16s-.29.4-.77 1a39 39 0 0 1-3 3.39 13.3 13.3 0 0 1-1.67 1.41 2.63 2.63 0 0 1-1.3.55H596c-.17 0-.28-.13-.39-.39a3.5 3.5 0 0 1-.15-1.14 23.2 23.2 0 0 1 .8-4.9c.19-.81.39-1.52.54-2s.25-.83.25-.83l-.24-.08-.14.22a10.6 10.6 0 0 0 2.53 1.07 13.6 13.6 0 0 1 2.3.87 2.75 2.75 0 0 1 1.34 1.15l.22-.11-.2-.16.2.16.24-.11a3.18 3.18 0 0 0-1.57-1.39 15 15 0 0 0-2.38-.91 12 12 0 0 1-1.82-.7l-.45-.22-.11-.06-.28-.18-.1.32s-1.6 5.05-1.61 7.92a3.8 3.8 0 0 0 .19 1.33 1.06 1.06 0 0 0 .77.72h.2a4 4 0 0 0 2.17-1.06 36.8 36.8 0 0 0 5-5.49l.09-.12-.06-.15-.24.11Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path981"
        d="M594.15 354.88s6.48 1.13 6.78 2.17-3.11 2.41-4.94 2.41-1.84-4.58-1.84-4.58"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path983"
        d="M594.15 354.88v.26l1 .19c.91.18 2.29.48 3.46.82a11 11 0 0 1 1.5.55 2 2 0 0 1 .45.26c.11.08.15.14.15.15v.06c0 .12-.13.35-.43.59a8.7 8.7 0 0 1-4.27 1.45 1 1 0 0 1-.84-.6 6.2 6.2 0 0 1-.65-2.31c0-.39-.07-.75-.08-1s0-.42 0-.42h-.26v.26-.26h-.25a14 14 0 0 0 .23 2.34 5.2 5.2 0 0 0 .58 1.66 1.51 1.51 0 0 0 1.28.84 9 9 0 0 0 3.23-.78 6 6 0 0 0 1.35-.77 1.41 1.41 0 0 0 .63-1v-.2a1.06 1.06 0 0 0-.49-.54 15.4 15.4 0 0 0-3.81-1.26c-1.43-.33-2.67-.54-2.67-.54l-.3-.05v.3Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path985"
        d="M578.06 364.69s.85 3.11 3.66 3.29 5.45-2.94 5.45-2.94l-6.64-2.59z"
        className="Mexico_svg__cls-41"
      />
      <path
        id="Mexico_svg__path987"
        d="M578.06 364.69h-.15a5.4 5.4 0 0 0 .81 1.63 3.88 3.88 0 0 0 3 1.77h.28c2.83 0 5.32-3 5.34-3l.14-.17-6.93-2.7-2.61 2.37v.09h.15l.11.12 2.39-2.19 6.56 2.56v-.14l-.11-.1s-.15.17-.43.45c-.81.82-2.72 2.44-4.68 2.43h-.22a3.64 3.64 0 0 1-2.77-1.64 5.8 5.8 0 0 1-.58-1.06c-.06-.14-.1-.26-.13-.34v-.13h-.15l.11.11-.11-.11Z"
        className="Mexico_svg__cls-42"
      />
      <path
        id="Mexico_svg__path989"
        d="M579.93 363.82s1.11 2.34 4.77 2.42 6.56-2.94 6.56-2.94l-5.79-4.58z"
        className="Mexico_svg__cls-41"
      />
      <path
        id="Mexico_svg__path991"
        d="m579.93 363.82-.13.07s1.16 2.42 4.9 2.51h.16c3.67 0 6.5-3 6.51-3l.12-.12-6-4.76-5.71 5.26v.1l.13-.07.11.11 5.44-5 5.69 4.49.09-.12-.11-.11-.12.13c-.58.55-3.11 2.77-6.17 2.77h-.15a6 6 0 0 1-3.67-1.21 4.3 4.3 0 0 1-.75-.78 3 3 0 0 1-.17-.26v-.09l-.14.07.11.11-.11-.11Z"
        className="Mexico_svg__cls-42"
      />
      <path
        id="Mexico_svg__path993"
        d="M580.42 364.36a7 7 0 0 0 3.54 1.45 17.5 17.5 0 0 0 4.3-.5l-2.2.8-1.57.17-1.49-.23-1.34-.5-1-.78-.2-.41Z"
        className="Mexico_svg__cls-42"
      />
      <path
        id="Mexico_svg__path995"
        d="M584.7 361.14s1.62 4 5 3.55 3.49-2.42 3.49-2.42l-3.83-5.53-4.68 4.4Z"
        className="Mexico_svg__cls-41"
      />
      <path
        id="Mexico_svg__path997"
        d="m584.7 361.14-.14.07a7.5 7.5 0 0 0 1.13 1.82 4.6 4.6 0 0 0 3.52 1.85 5 5 0 0 0 .53 0 4.57 4.57 0 0 0 3.12-1.42 2.1 2.1 0 0 0 .51-1.15l-4-5.71-4.89 4.59v.1l.14-.06.1.12 4.56-4.28 3.73 5.38.12-.09h-.15v.07c-.06.34-.42 1.82-3.35 2.2a3 3 0 0 1-.49 0 4.29 4.29 0 0 1-3.28-1.74 7 7 0 0 1-.82-1.2c-.09-.16-.16-.3-.2-.39a1.4 1.4 0 0 1-.07-.16l-.14.06.11.12-.11-.12Z"
        className="Mexico_svg__cls-42"
      />
      <path
        id="Mexico_svg__path999"
        d="M585.17 361.92s2.05 2.48 3.84 2.44a6.36 6.36 0 0 0 2.91-.72l.09.29-.94.47-1.62.33-1.66-.22-1.36-.82Z"
        className="Mexico_svg__cls-42"
      />
      <path
        id="Mexico_svg__path1001"
        d="M578.72 365.9s1.57 1.62 3 1.68a9.15 9.15 0 0 0 3.66-1.16l.28-.09-.38.35-1.5.81-1.78.51-1.42-.26-1.09-.66-.66-.84-.1-.35Z"
        className="Mexico_svg__cls-42"
      />
      <path
        id="Mexico_svg__path1003"
        d="M593.77 354.53c1.53-.21 4.72 4.15 4.72 6.31s-.93 5.4-2.51 5.31-5.15-3.28-6-4.92-1.62-2.77-1-3.63 4.77-3.07 4.77-3.07Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1005"
        d="M593.77 354.53v.26h.08a2.23 2.23 0 0 1 1.22.64 10.7 10.7 0 0 1 2.13 2.63 6.4 6.4 0 0 1 1 2.79 10 10 0 0 1-.63 3.36 4.2 4.2 0 0 1-.72 1.25 1.17 1.17 0 0 1-.85.45 3.7 3.7 0 0 1-1.36-.54 14 14 0 0 1-4.38-4.25 8.6 8.6 0 0 1-1.2-2.84.9.9 0 0 1 .16-.52 4.1 4.1 0 0 1 .93-.77c.7-.49 1.64-1.05 2.4-1.48s1.34-.74 1.34-.74l-.11-.23v.26-.26l-.12-.23s-1 .56-2.17 1.22c-.56.33-1.14.69-1.63 1a4.7 4.7 0 0 0-1.06.92 1.43 1.43 0 0 0-.25.81 8.8 8.8 0 0 0 1.25 3.08 12 12 0 0 0 2.76 3.12 14 14 0 0 0 1.82 1.33 3.7 3.7 0 0 0 1.6.61h.08a1.65 1.65 0 0 0 1.22-.61 8.4 8.4 0 0 0 1.48-5 8.3 8.3 0 0 0-1.77-4.1 10 10 0 0 0-1.55-1.72 2.62 2.62 0 0 0-1.55-.76h-.15l.12.23Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1007"
        d="M577.89 354.92s-2.55-2-3.58-.94-.68 4.49 0 5.18 3.75-1.64 3.75-1.64l-.17-2.59Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1009"
        d="m577.89 354.92.15-.2a8 8 0 0 0-1-.65 4.34 4.34 0 0 0-1.95-.65 1.3 1.3 0 0 0-1 .37 3.9 3.9 0 0 0-.72 2.59 8 8 0 0 0 .19 1.75 2.7 2.7 0 0 0 .53 1.21.77.77 0 0 0 .55.2 2.7 2.7 0 0 0 1.08-.29 16 16 0 0 0 2.45-1.52l.11-.09-.18-2.85-.1-.07-.15.2h-.26l.18 2.59h.25l-.16-.21a5 5 0 0 1-.37.27 14 14 0 0 1-1.44.92 3.4 3.4 0 0 1-1.41.52.33.33 0 0 1-.19 0 2.3 2.3 0 0 1-.39-1 7.6 7.6 0 0 1-.17-1.63 3.42 3.42 0 0 1 .56-2.22.8.8 0 0 1 .62-.23 4 4 0 0 1 1.71.6c.26.15.49.3.66.41a3 3 0 0 1 .25.19l.16-.21h-.25.25Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1011"
        d="M577.55 357.34s-3.41.35-3.41 1.91 1.62 3.19 2 3.54 3.4-1.38 3.4-1.38Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1013"
        d="M577.55 357.34v-.25a9.5 9.5 0 0 0-1.76.38 4.3 4.3 0 0 0-1.25.62 1.48 1.48 0 0 0-.63 1.16 4.37 4.37 0 0 0 .9 2.37 9.6 9.6 0 0 0 1.14 1.35.43.43 0 0 0 .33.12 2.7 2.7 0 0 0 .91-.24 24 24 0 0 0 2.47-1.22l.21-.12-2.15-4.44h-.17v.25l-.24.12 2 4.06.23-.11-.12-.23s-.63.36-1.34.71c-.36.17-.74.35-1.07.48a2.3 2.3 0 0 1-.72.2v.12l.08-.08v.12l.08-.08a9.3 9.3 0 0 1-1.08-1.29 3.9 3.9 0 0 1-.81-2.07 1 1 0 0 1 .44-.75 4.6 4.6 0 0 1 1.7-.71c.28-.07.55-.12.74-.15h.3v-.26l-.24.12.24-.12Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1015"
        d="M578.92 360.2s-3.5 1-3.5 2.24 1.54 3.46 2.64 3.46 2-2.17 2.39-2.6-1.53-3.1-1.53-3.1"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1017"
        d="m578.92 360.2-.08-.25a13 13 0 0 0-1.78.68 6.2 6.2 0 0 0-1.25.75 1.45 1.45 0 0 0-.64 1.06 4.53 4.53 0 0 0 1 2.34 4.9 4.9 0 0 0 .91 1 1.73 1.73 0 0 0 1 .43 1.47 1.47 0 0 0 1-.41 6 6 0 0 0 1-1.29 6.4 6.4 0 0 1 .61-1 .52.52 0 0 0 .14-.37 2.3 2.3 0 0 0-.28-.89 18 18 0 0 0-1.37-2.19l-.1-.14-.18.05.08.25-.21.15.25.35c.22.31.55.81.82 1.29a6 6 0 0 1 .35.69 1.2 1.2 0 0 1 .12.44h.12a3.4 3.4 0 0 0-.43.64 12 12 0 0 1-1 1.22 1.34 1.34 0 0 1-.94.61 1.2 1.2 0 0 1-.72-.31 4.8 4.8 0 0 1-1.15-1.39 3.4 3.4 0 0 1-.51-1.49c0-.17.14-.41.45-.66a7.2 7.2 0 0 1 1.78-.95c.3-.13.57-.22.76-.29l.32-.09-.07-.25-.21.15.21-.15Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1019"
        d="M580.61 350.09a1.7 1.7 0 0 0-2.13-.35 4.29 4.29 0 0 0-2.81 4.41 11.4 11.4 0 0 0 1.11 3.88l5.28-1.81z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1021"
        d="m580.61 350.09.21-.15a1.77 1.77 0 0 0-1.42-.66 2.7 2.7 0 0 0-1 .22 5.3 5.3 0 0 0-2 1.48 4.1 4.1 0 0 0-1 2.68 4 4 0 0 0 0 .51 11.6 11.6 0 0 0 1.14 4l.1.19 5.7-2-1.49-6.36-.21.15-.24.06 1.39 5.9-5.06 1.74.08.24.23-.12v-.07a11.6 11.6 0 0 1-1-3.72 4 4 0 0 1 0-.46 3.66 3.66 0 0 1 .86-2.35 4.85 4.85 0 0 1 1.82-1.33 2 2 0 0 1 .82-.18 1.26 1.26 0 0 1 .77.23l.19.15v.05l.2-.15-.24.06.24-.06Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1023"
        d="M581 354.15s-4.51 1.47-4.68 3.19a3.77 3.77 0 0 0 2.21 3.8c1.2.35 5-3.36 5-3.36z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1025"
        d="m581 354.15-.08-.25a18.5 18.5 0 0 0-2.31 1 8.2 8.2 0 0 0-1.65 1.06 2.24 2.24 0 0 0-.9 1.4v.36a4.26 4.26 0 0 0 .74 2.36 3.12 3.12 0 0 0 1.67 1.35h.25a3.26 3.26 0 0 0 1.46-.57 25.4 25.4 0 0 0 3.56-2.9l.16-.15-2.79-4-.18.06.08.25-.21.15 2.56 3.63.21-.15-.18-.19-.56.52a25 25 0 0 1-2.14 1.77 8.4 8.4 0 0 1-1.14.74 2.1 2.1 0 0 1-.84.29h-.1a2.74 2.74 0 0 1-1.39-1.15 3.8 3.8 0 0 1-.65-2.07v-.31a1.85 1.85 0 0 1 .72-1.06 10.5 10.5 0 0 1 2.38-1.37c.39-.17.75-.31 1-.4l.41-.15-.08-.24-.21.15.21-.15Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1027"
        d="M585 361.33s-4.43 2.92-5 2.92-2.21-2.33-1.87-3.88 3.32-2.68 4.51-3.11 2.39 4.07 2.39 4.07Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1029"
        d="m585 361.33-.14-.22s-1.11.73-2.29 1.46c-.58.37-1.19.73-1.68 1l-.64.32-.2.08h-.07a1.3 1.3 0 0 1-.43-.35 4.86 4.86 0 0 1-1.21-2.81 1.7 1.7 0 0 1 0-.4c.12-.63.89-1.3 1.81-1.8a16 16 0 0 1 2.54-1.12h.07a.44.44 0 0 1 .27.12 5.9 5.9 0 0 1 1.18 2.14c.16.43.3.85.39 1.15s.14.49.14.49l.25-.06-.14-.22.14.22.24-.07a19 19 0 0 0-.69-2.08 8 8 0 0 0-.74-1.46 3 3 0 0 0-.45-.52 1 1 0 0 0-.59-.23h-.24a18 18 0 0 0-2.62 1.15 3.88 3.88 0 0 0-2.06 2.15 2 2 0 0 0-.06.5 5.44 5.44 0 0 0 1.47 3.3 1.13 1.13 0 0 0 .71.4 1.4 1.4 0 0 0 .49-.15 32 32 0 0 0 2.82-1.63c1-.64 1.85-1.2 1.85-1.2l.16-.11v-.17l-.24.07Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1031"
        d="M588.83 345.26a6 6 0 0 0-4.08-1c-2.69.2-4.66 3.7-5 5.45s-.07 5 1 5.57 6.58-4 6.58-4l1.53-6.08Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1033"
        d="m588.83 345.26.17-.21a6 6 0 0 0-3.66-1.05h-.61a5.22 5.22 0 0 0-3.56 2.24 8.55 8.55 0 0 0-1.66 3.42 9.5 9.5 0 0 0-.13 1.69 11.3 11.3 0 0 0 .27 2.51 2.47 2.47 0 0 0 1 1.65.7.7 0 0 0 .32.06 4 4 0 0 0 1.71-.65 44 44 0 0 0 4.82-3.4l.07-.05 1.59-6.33-.12-.11-.17.21-.24-.07-1.54 6.09.25.06-.16-.2-.79.62c-.73.56-1.85 1.4-2.92 2.1-.54.34-1.06.65-1.5.88a2.7 2.7 0 0 1-1 .34h-.1a2.14 2.14 0 0 1-.69-1.32 10.6 10.6 0 0 1-.25-2.38 8.3 8.3 0 0 1 .13-1.6 8 8 0 0 1 1.55-3.19 4.7 4.7 0 0 1 3.19-2h.58a6.6 6.6 0 0 1 2.51.47 6 6 0 0 1 .63.32l.15.11.16-.19-.24-.07.24.07Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1035"
        d="M583.4 358.53c-1.85-.2-3.51-2.86-3.19-4.47s4-4.41 5.87-4.08 1.53 5.12 1.53 5.12-2.36 3.62-4.21 3.43"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1037"
        d="M583.4 358.53v-.26a3.27 3.27 0 0 1-2.08-1.38 4.4 4.4 0 0 1-.93-2.41 2 2 0 0 1 0-.37 3 3 0 0 1 .66-1.17 9.3 9.3 0 0 1 2.23-1.87 5.15 5.15 0 0 1 2.41-.86h.28a1 1 0 0 1 .66.45 6.8 6.8 0 0 1 .69 3.46v.93h.26l-.22-.14s-.13.2-.37.51a11.7 11.7 0 0 1-1.56 1.78 3.27 3.27 0 0 1-1.92 1h-.12v.51h.17c1.07 0 2.09-.94 2.9-1.81a17 17 0 0 0 1.38-1.75v-1.12a10.8 10.8 0 0 0-.28-2.6 3.4 3.4 0 0 0-.51-1.17 1.54 1.54 0 0 0-1-.65 2.3 2.3 0 0 0-.37 0 6.73 6.73 0 0 0-3.56 1.53 9.8 9.8 0 0 0-1.47 1.38A3.4 3.4 0 0 0 580 354a2.4 2.4 0 0 0-.05.47 4.76 4.76 0 0 0 1 2.72 3.62 3.62 0 0 0 2.43 1.58v-.25Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1039"
        d="M589.3 358.12a7.1 7.1 0 0 1-2.81 3.12c-1.87.94-3 .16-4.09-1.39s.51-2.25 1.36-3a10.8 10.8 0 0 1 3.32-1.38l2.22 2.68Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1041"
        d="m589.3 358.12-.23-.11v.09a6.73 6.73 0 0 1-2.66 2.9 3.06 3.06 0 0 1-1.38.39 2.06 2.06 0 0 1-1.24-.44 5.6 5.6 0 0 1-1.14-1.25 1.46 1.46 0 0 1-.33-.84 1.37 1.37 0 0 1 .54-.94c.33-.3.77-.59 1.12-.9a6 6 0 0 1 1.89-.93l.92-.29.4-.11-.06-.25-.2.17 2.21 2.68.2-.17-.23-.11.23.11.19-.16-2.31-2.81h-.16s-.62.15-1.36.41a6.4 6.4 0 0 0-2.07 1c-.3.28-.73.56-1.11.9a1.82 1.82 0 0 0-.71 1.33 2 2 0 0 0 .42 1.14 6 6 0 0 0 1.26 1.36 2.52 2.52 0 0 0 1.54.55 3.5 3.5 0 0 0 1.61-.45 7.2 7.2 0 0 0 2.93-3.23l.07-.15-.11-.12-.19.16Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1043"
        d="M586.32 352.43s-2.09 1.68-.89 3.62 2.13 2.64 3.61 2.89 2.47-.34 3.67-1.77 2.93-2.07 2.76-3.84-.85-3.15-1.91-3.67-4.3 0-7.24 2.77"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1045"
        d="m586.32 352.43-.16-.21a3.8 3.8 0 0 0-1.36 2.59 2.6 2.6 0 0 0 .41 1.38 7.9 7.9 0 0 0 1.76 2.15 4.34 4.34 0 0 0 2 .86 4 4 0 0 0 .69.06c1.25 0 2.19-.69 3.21-1.91a21 21 0 0 1 1.8-1.71 2.8 2.8 0 0 0 1-2.07v-.26c-.18-1.82-.87-3.3-2.06-3.88a2.5 2.5 0 0 0-1.09-.21 10.38 10.38 0 0 0-6.43 3l.17.2-.16-.21.16.21.17.19a9.85 9.85 0 0 1 6.09-2.88 2.2 2.2 0 0 1 .87.15c.94.45 1.61 1.74 1.77 3.47v.21a2.3 2.3 0 0 1-.88 1.7 21 21 0 0 0-1.84 1.74c-1 1.19-1.78 1.73-2.82 1.74a3.4 3.4 0 0 1-.61-.06 3.74 3.74 0 0 1-1.8-.76 7.4 7.4 0 0 1-1.64-2 2 2 0 0 1-.33-1.1 2.7 2.7 0 0 1 .58-1.55 4.4 4.4 0 0 1 .41-.47l.13-.12h.05l-.17-.19Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1047"
        d="M592.25 344.09a5 5 0 0 0-3.81.14 6.06 6.06 0 0 0-2.87 4.76 28.4 28.4 0 0 0 .32 4.36 11.9 11.9 0 0 0 3.75-1.88c1.47-1.23 2-1.56 1.75-2.2a3.94 3.94 0 0 1-.73-2.33c0-2.66 1.59-2.85 1.59-2.85"
        className="Mexico_svg__cls-41"
      />
      <path
        id="Mexico_svg__path1049"
        d="M592.25 344.09s-2.48-.42-3.73.39a6.27 6.27 0 0 0-2.74 3.62c-.45 1.63-.13 2-.13 2a6.5 6.5 0 0 1 .2-2.76 5.48 5.48 0 0 1 3-3.45 6.8 6.8 0 0 1 3.38.15Z"
        className="Mexico_svg__cls-42"
      />
      <path
        id="Mexico_svg__polygon1051"
        d="m672.31 368.76-.45-10.83-29.19 9.01 11.56 10.82z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1053"
        d="M618.25 349.91 615.8 348a14.4 14.4 0 0 0-2.75-1.54 5.4 5.4 0 0 0-2.23-.07l-.4.58.38 1 2.66 3.11 4.45 2.29c.11 0 1.57 1.51 1.57 1.51l1 .43-2.26-5.38Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__polygon1055"
        d="m614.85 354.91 1.93-.29.79-.12 1.66.22 1.66 1.91 1.04 2.03 1.36 2.7.43 1.56-3.26-.71-9.45-2.93.81-2.25 1.66-1.52z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__polygon1057"
        d="m626.41 346.37-7.67-9.08-1.57 5.23 2.25 9.18 1.67 5.5 2.63 5.07 1.56-.13 1.06-.9-.5-3.54z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path1059"
        d="M618.21 341.54s-.51.95.13 3.92 1.75 9.64 4.39 14.18-2.56-3.59-2.56-3.59-4.09-9.2-3.45-16.16 1.49 1.65 1.49 1.65"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1061"
        d="M623.79 347.27a11.3 11.3 0 0 0-1.92 3.76 18.7 18.7 0 0 0 .13 4.32s-.26-2.07 1.45-2.55 1.48 4.67 1.57 5.14 1-9.2 1-9.2l-2.21-1.47Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1063"
        d="M624.64 366.28a23.7 23.7 0 0 1-8.64-2c-4.47-2-6.84-3.55-6.75-4.62s7.94.26 9.09.52a38 38 0 0 1 4.66 2h2l3.67-1.62.51 3.91-4.56 1.77Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1065"
        d="M610.21 364.65s2.13 1.51 1.11 2.16a8.7 8.7 0 0 1-4.6.52c-.86-.22 8.34 2 8.34 2s1.79-1.52 1.66-1.6-6.51-3.11-6.51-3.11Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1067"
        d="M607.92 362.36c.33-.52.58 1.21 3.56 1.6s4.34-.52 4.34-.52l1.32.86 1.58.35-1.45 2.16-5.45-1.6-2.94-1.64-1-1.21Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__polygon1069"
        d="m629.77 350.87-3.13-2.07.7 9.65 1.54 2.2.95-4.79z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1071"
        d="m618.72 350.37-2.55-4.28-3.32-6.09 2-3.5 2.49 3.62a11.9 11.9 0 0 0-.25 4.8 42 42 0 0 0 1.59 5.45Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1073"
        d="M601.22 365.92a4.87 4.87 0 0 1 3.7-2.05 14.8 14.8 0 0 1 4.69.34l5.28 2.76 1.11 1.73-10-1.33-4.77-1.45Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path1075"
        d="M627.15 348.3s.19 6 .38 7.84 1.35 3.69 1.16 4.47-.58 1.16-1.86 1.62a10.3 10.3 0 0 1-3.83 0s2.49-.33 2.62-.84-.77-2.79-.9-4.87.13-4.34-.57-4.34-1.47.91-1.6 1.17.7-7.39 1.53-8.23 3.07 3.18 3.07 3.18"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1077"
        d="M608.93 364s-1-.95-1-1.6 1.19 3.13 6.66 2.92 5.15-.31 5.15-.31h2.56s-.58 2.39-1 2.6-4.25 2.78-4.32 2.85l-1.36.75.11-.38h-.26l-.45-4.21-4.72-1.82-1.34-.82Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1079"
        d="M618.72 350.37s-6.32-6.55-8.43-10.89-.83-10.3-.83-10.3l5.94 7.82a7.6 7.6 0 0 0-.51 3.95c.26 2.47 3.83 9.47 3.83 9.47Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1081"
        d="M614.68 374.21a3.48 3.48 0 0 1 .76-3.41c3.76-4.69 13.27-8.06 13.27-8.06v5.73l-12.2 5.87-1.84-.13Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1083"
        d="M615.39 369.87c.53-.38 2.66-1.95 2.73-2.63s-1.44-.91-4.21-1.47a19.6 19.6 0 0 1-5-1.81 34.6 34.6 0 0 0 4.72 3.15c1.32.52 1.2 1 1 1.38s.67 1.44.75 1.38Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1085"
        d="M631.72 371.2a25.6 25.6 0 0 1-2.32-4.2 30 30 0 0 1-.7-4.22c-.1 0-1.17.85-2 1.22s-3.6 1.27-3.75 1.37 3.88-.08 3.85 1.32-5.8 2-5.82 2.1 4.65-1 4.37.1-2.35 1.25-4.86 2.28a38 38 0 0 0-4.53 2.1 8.5 8.5 0 0 0-1.37.94 5.8 5.8 0 0 0 2.9.57 43 43 0 0 0 5.69-1l7.54-2.87 1 .36Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1087"
        d="M631.72 371.2s-2.11-.73-3.6-9.51-1.06-11.14-1.06-11.14l3.55 2.48 3.18 5.78z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1089"
        d="M632.86 356.61s-1.66 4.92-1.66 7.77-.3 4.79.52 6.82 3.61 4.53 3.61 4.53l1.27-1.33.58-4 .32-6.61-4.64-7.2Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1091"
        d="M637.85 363.3s.81 12.39-2.33 12.73c-1.5.16-3.77-4.67-3.8-4.82s2.74 4.49 3.77 4.07c2-.81 1.37-12.89 1.37-12.89l1 .91Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1093"
        d="M631.72 371.2s-.53-.23-1.4-1.63c0 0-.11 1.24-6.71 3.58s-9 1-9 1 2.21 1.72 8.88-.23 6.07-2.36 7-2.55a7 7 0 0 1 1.25-.2Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1095"
        d="M619.43 355.42a11 11 0 0 1 2.23 3.31l2.05 4.1.29-.3a25.7 25.7 0 0 0-1.91-4.15c-1.11-1.82-4.3-6.22-4.3-6.22z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1097"
        d="M615.41 370.81s.68-2.32 0-2.75-1.33 0-5.84-.52a67 67 0 0 1-8.34-1.62 26.6 26.6 0 0 0 6 2.66c2.94.77 6.77 1.64 6.77 1.64l1 .17.39.42Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1099"
        d="M615.41 370.81a1.4 1.4 0 0 0-.42-1.1c-.51-.55-1.44.26-6.9-1.27s-6.86-2.52-6.86-2.52 1.94 1.72 6.77 2.95 7.41 1.94 7.41 1.94"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1101"
        d="M617.86 354.48s-4.13.23-5.46 1.29a22 22 0 0 0-3.15 3.91l2.68.31s-.33-2.49 1-3.74 3.21-1.36 5-1.77Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1103"
        d="M610 346.62a11.3 11.3 0 0 0 3.38 3c1.73.77 3.45 1.42 4.29 2.26a13.4 13.4 0 0 1 1.72 3.56s-5.94-2.65-7.09-3.95-2.3-4.87-2.3-4.87"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1105"
        d="M615.8 348a5 5 0 0 0-2.17-1.64c-1.63-.74-2.83-.62-3.29-.29s-.3.56-.3.56l2.17 3.27 1.21-.3s-3.23-2-2.47-2.67c1.58-1.35 4.85 1.07 4.85 1.07"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__polygon1107"
        d="m629.45 348.87 2.37-8.36 33.24-17.17 15.74 21.9-28.74 7.7-15.2 1.3z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1109"
        d="M656.36 391.3s1.8-.76 3-1.44 3.93-2.44 3.93-2.44l.86 4.48-3.44 2.66h-3l-1.82-1.33.44-2Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1111"
        d="m656.36 391.3.09.23s1.81-.75 3.07-1.44 4-2.44 4-2.44l-.14-.23-.25.06.83 4.31-3.25 2.51h-2.84l-1.61-1.18.4-1.8-.25-.05.09.23-.09-.23-.25-.06-.44 2a.27.27 0 0 0 .1.27l1.82 1.33h3.15l.15-.06 3.45-2.65a.29.29 0 0 0 .09-.27l-.86-4.46-.15-.19h-.24s-.67.44-1.49 1-1.81 1.14-2.42 1.47-1.36.69-2 1l-1 .46-.15.18.25.06Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1113"
        d="M651.55 391.74a12.6 12.6 0 0 0 2.15.11c2.09 0 2.3-.73 2.67-.55s1 2.41 1 2.41l-.77 1.41-3 1.71-2.55-1.4-.2-3.53.76-.16Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1115"
        d="m651.55 391.74-.18.19.12.07.45.05c.3 0 .83 0 1.75.06h.2a4.3 4.3 0 0 0 1.81-.31c.18-.08.31-.16.41-.21h.12v-.06a1.3 1.3 0 0 1 .23.4 12 12 0 0 1 .42 1.19c.11.37.19.66.19.66l.25-.06-.23-.13-.72 1.34-2.84 1.6-2.3-1.26-.19-3.16.55-.11-.05-.26-.18.19.18-.19v-.25l-.77.16a.26.26 0 0 0-.21.27l.21 3.52.13.21 2.55 1.4h.25l3-1.71.09-.1.77-1.4v-.19s-.15-.56-.34-1.15a7 7 0 0 0-.33-.85 1.6 1.6 0 0 0-.18-.34.66.66 0 0 0-.25-.25h-.22a.85.85 0 0 0-.38.11 3 3 0 0 1-.63.29 5 5 0 0 1-1.35.18h-.18c-1.05 0-1.59 0-1.85-.06h-.23v.13-.12.13-.12l-.08.24.18-.18-.1-.06-.08.24.18-.18-.23-.07v.24Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1117"
        d="M675.47 390.31a9.5 9.5 0 0 0-1.8-2l-4.26-3.71v9.69l4.47-.11 2.14-3-.53-.84Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1119"
        d="m675.47 390.31.22-.14a11 11 0 0 0-1.85-2.09l-2.58-2.25-1.68-1.47h-.27a.26.26 0 0 0-.16.24v9.69l.08.19.19.07 4.47-.11.2-.1 2.13-3V391l-.52-.84-.21.14-.22.14.43.69-1.95 2.75-4.08.1v-9.43h-.25l-.16.19s3.06 2.69 4.25 3.72a10.7 10.7 0 0 1 1.32 1.37c.14.19.25.34.32.45l.11.16.22-.14Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1121"
        d="M651.55 391.74A2.63 2.63 0 0 0 649 391c-1.88.21-3.88 1.75-4.08 3s0 5.09 1 5.81a4.82 4.82 0 0 0 4.34.57c2.05-.52 12.47-6.95 12.47-6.95l-2.65.58a4.8 4.8 0 0 1-2.76-.32 6.27 6.27 0 0 1-3.07 1.87 2 2 0 0 1-2.4-1.55 8.2 8.2 0 0 1-.31-2.29Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1123"
        d="m651.55 391.74.21-.14a2.66 2.66 0 0 0-2.25-.92 3.6 3.6 0 0 0-.55 0 5.8 5.8 0 0 0-2.79 1.16 3.63 3.63 0 0 0-1.52 2.1 10 10 0 0 0-.07 1.24 14.8 14.8 0 0 0 .25 2.76 3.46 3.46 0 0 0 .95 2.07 4.5 4.5 0 0 0 2.73.85 7.4 7.4 0 0 0 1.82-.24 17 17 0 0 0 2.87-1.33c3.81-2 9.67-5.65 9.67-5.65a.26.26 0 0 0 .11-.32.25.25 0 0 0-.29-.15l-2.66.56a3.6 3.6 0 0 1-.79.09 4.8 4.8 0 0 1-1.28-.19l-.39-.13-.1-.05a.28.28 0 0 0-.3.06v.07a5.9 5.9 0 0 1-2.86 1.72 4 4 0 0 1-.44 0 1.44 1.44 0 0 1-1.14-.46 3 3 0 0 1-.54-1 5 5 0 0 1-.25-1.36v-.98l-.21.14h-.25v.88a5.8 5.8 0 0 0 .28 1.51 3.7 3.7 0 0 0 .64 1.13 2 2 0 0 0 1.52.63 3.4 3.4 0 0 0 .52-.05 6.53 6.53 0 0 0 3.22-1.95l-.19-.18-.11.25a5.7 5.7 0 0 0 2 .42 4 4 0 0 0 .9-.1l2.65-.57v-.25l-.13-.22-1.66 1c-1.51.92-3.83 2.3-6 3.5-1.06.61-2.08 1.16-2.92 1.59a11 11 0 0 1-1.85.81 6.9 6.9 0 0 1-1.71.24 4 4 0 0 1-2.43-.77 3 3 0 0 1-.74-1.73 14.6 14.6 0 0 1-.25-2.67 8.4 8.4 0 0 1 .07-1.16 3.15 3.15 0 0 1 1.32-1.77 5.3 5.3 0 0 1 2.54-1.06h.49a2.7 2.7 0 0 1 1.45.37 2 2 0 0 1 .31.23l.06.08.21-.15Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1125"
        d="M641.33 403.43s-1.61-2.72.3-3.71 2.94 0 4.09.08.77-2.94.52-3.55a7.1 7.1 0 0 0-1.33-2.23c-.47-.35-6.8.28-6.75 4.53 0 4.09 3.17 4.88 3.17 4.88"
        className="Mexico_svg__cls-41"
      />
      <path
        id="Mexico_svg__path1127"
        d="M658.52 395.11a12.6 12.6 0 0 0-2.12 1 17 17 0 0 1-2.63 1.14l.78 3.16 4.44 1.14 2.78-2.3v-3.18l-3.28-1Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1129"
        d="m658.52 395.11-.1-.24s-.39.14-.84.35a7.5 7.5 0 0 0-1.33.69 8.3 8.3 0 0 1-1.47.69c-.58.24-1.1.41-1.1.41a.28.28 0 0 0-.16.31l.79 3.17.18.18 4.44 1.14.22-.05 2.78-2.3.1-.2v-3.18a.26.26 0 0 0-.19-.25l-3.29-1h-.16l.1.24-.08.25 3.11.92v2.85l-2.59 2.14-4.17-1.06-.74-3-.25.07.08.24s.52-.18 1.11-.41a8.5 8.5 0 0 0 1.59-.77 9 9 0 0 1 1.22-.63l.83-.34-.08-.24-.08.25.08-.25Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1131"
        d="M679.14 392.87s-.71-.65-1.54-1.58a2.33 2.33 0 0 0-2.14-1c-.28.17-2.39 2.89-2.39 2.89l-.16 2 2.46 1.33 1.72.32 2.27-1.49-.22-2.53Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1133"
        d="m679.14 392.87.17-.18-.45-.44c-.27-.28-.65-.67-1.06-1.14a3.06 3.06 0 0 0-2.08-1.11.7.7 0 0 0-.38.09 1.2 1.2 0 0 0-.25.22c-.61.65-2.22 2.72-2.22 2.73v.14l-.16 2a.26.26 0 0 0 .13.25l2.46 1.33h.07l1.72.33h.19l2.27-1.49a.25.25 0 0 0 .11-.24l-.22-2.53-.08-.16-.17.18h-.26l.21 2.37-2.14 1.4-1.59-.3-2.27-1.23.15-1.87h-.25l.19.17s.53-.69 1.09-1.38c.28-.35.57-.7.81-1l.3-.33.1-.11h.14a2.53 2.53 0 0 1 1.68.94 22 22 0 0 0 1.56 1.6l.17-.19h-.26.26Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1135"
        d="M663.91 391.32A16 16 0 0 0 661 393c-1 .81-2.46 1.71-2.46 2.07a18 18 0 0 0 2.24 2.67l2.22.26 4.92-3.44-.32-3.14-3.7-.06Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1137"
        d="m663.91 391.32-.11-.24a16.8 16.8 0 0 0-3 1.76c-.46.39-1.08.82-1.57 1.19a5 5 0 0 0-.64.53l-.22.24a.5.5 0 0 0-.12.31v.19a3.8 3.8 0 0 0 .48.7c.68.81 1.78 1.95 1.78 2l.16.07 2.27.19.16-.05 4.92-3.43a.26.26 0 0 0 .11-.24l-.32-3.14a.25.25 0 0 0-.24-.24l-3.71-.06h-.11l.11.24v.26l3.48.06.28 2.76-4.72 3.29-2.18-.17v.26l.17-.18s-.55-.58-1.11-1.2c-.28-.31-.55-.63-.75-.89a3 3 0 0 1-.24-.33l-.05-.1h-.12.13-.12.12-.08.07a1.2 1.2 0 0 1 .26-.28c.48-.41 1.42-1 2.11-1.62a11.3 11.3 0 0 1 1.78-1.13c.61-.33 1.09-.55 1.1-.55l-.1-.23Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1139"
        d="M682.59 395.4a5.6 5.6 0 0 0-1.15-1.49 3.4 3.4 0 0 0-2.3-1c-.57.06-2.49 2.92-2.49 2.92l-.24.8 1.77 2.06 3.15.77 2.17-2.19-.91-1.83Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1141"
        d="m682.59 395.4.23-.12a6.1 6.1 0 0 0-1.21-1.56 3.86 3.86 0 0 0-2.34-1.12h-.16a.72.72 0 0 0-.39.19 9.3 9.3 0 0 0-1.45 1.66c-.46.62-.83 1.17-.83 1.17v.07l-.24.81.05.25 1.77 2.05.14.08 3.14.77.24-.07 2.17-2.19a.26.26 0 0 0 .05-.3l-.91-1.83-.23.12-.23.12.83 1.65-1.93 2-2.94-.71-1.62-1.88.19-.68-.24-.07.21.14s.48-.71 1-1.42c.28-.36.56-.71.82-1a2.3 2.3 0 0 1 .33-.31l.11-.08h.14a3.43 3.43 0 0 1 2 1 7.6 7.6 0 0 1 .83 1c.08.14.16.25.2.33l.06.12.23-.11Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1143"
        d="m674.48 398.83 2.24.39a1.31 1.31 0 0 0 .57 1.1c.64.52.71.13.71.13a6.7 6.7 0 0 0 2.68 3.95s2.75.91 4.15.13 1.21.24 1.21.24l4-4.9a1 1 0 0 0-1-1s.7-3-1.85-3.69a7.64 7.64 0 0 0-4.6.26s-2 3.59-3.13 3.11a4.9 4.9 0 0 1-1.4-1 11.4 11.4 0 0 1-1.41-1.75 2.2 2.2 0 0 1-1.78-.39 7.2 7.2 0 0 1-1.79-2.21 5 5 0 0 1-2-.77 8 8 0 0 1-1-1.54l-3.66 2.62s-.11 1.16-2.24 2.72a6.6 6.6 0 0 1-3.41 1.56s-.59 3.19-3 2.67-4-3.19-4-3.19a3.13 3.13 0 0 0-2.81 1.2c-1.11 1.47-1.63 2-1.63 3.46a7.05 7.05 0 0 0 1.71 4.23c.77.69 3.16 2.59 6 1.12s1.88-3.88 1.88-3.88-.09.17 1.62-.95 3.57-2.85 4.85-3.37"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1145"
        d="m674.43 399.09 2.24.39v-.26h-.25v.08a1.62 1.62 0 0 0 .67 1.26 1.1 1.1 0 0 0 .68.32.4.4 0 0 0 .35-.18l.08-.17-.25-.05h-.26a7.1 7.1 0 0 0 2.79 4.12h.08a10.2 10.2 0 0 0 2.71.46 3.4 3.4 0 0 0 1.63-.35 1.55 1.55 0 0 1 .72-.26h.11v.13a.28.28 0 0 0 .14.29.25.25 0 0 0 .3-.07l4-4.91.06-.16a1.6 1.6 0 0 0-.14-.61 1.19 1.19 0 0 0-1.05-.69v.26l.25.06a5 5 0 0 0 .09-1 3.75 3.75 0 0 0-.38-1.71 2.57 2.57 0 0 0-1.75-1.32 7.83 7.83 0 0 0-4.77.27l-.12.11s-.1.19-.28.48a12 12 0 0 1-1.15 1.63 4 4 0 0 1-.69.67 1 1 0 0 1-.55.25h-.14a4.6 4.6 0 0 1-1.31-.91c-.53-.58-.88-1-1.09-1.29s-.18-.25-.22-.32v-.07a.25.25 0 0 0-.3-.12 1.7 1.7 0 0 1-.34 0 2.15 2.15 0 0 1-1.22-.39 5.2 5.2 0 0 1-1.19-1.28c-.15-.23-.28-.43-.37-.59l-.14-.24-.19-.13-.22-.05a7 7 0 0 1-.86-.25 2.2 2.2 0 0 1-.75-.4 5.8 5.8 0 0 1-.68-.92c-.19-.32-.32-.56-.32-.56l-.16-.14h-.21l-3.66 2.62-.11.19c0 .07-.18 1.1-2.14 2.54a8.8 8.8 0 0 1-2.43 1.32 4 4 0 0 1-.63.16h-.15a.27.27 0 0 0-.26.21v.1a4.5 4.5 0 0 1-.59 1.42 1.9 1.9 0 0 1-1.61 1 1.8 1.8 0 0 1-.45-.05 5.7 5.7 0 0 1-2.76-1.72 8 8 0 0 1-.8-1l-.21-.29-.06-.11-.19-.12a3 3 0 0 0-.35 0 3.34 3.34 0 0 0-2.7 1.32 15 15 0 0 0-1.25 1.77 3.75 3.75 0 0 0-.42 1.85 6.9 6.9 0 0 0 .59 2.51 5.6 5.6 0 0 0 1.2 1.92 6.25 6.25 0 0 0 4 1.73 4.7 4.7 0 0 0 2.26-.58 3.52 3.52 0 0 0 2.16-3.17 3 3 0 0 0-.17-1 .25.25 0 0 0-.22-.16.27.27 0 0 0-.25.14v.12l.1.21.16.06a.5.5 0 0 0 .19-.06 11.6 11.6 0 0 0 1.56-.94c1.72-1.14 3.61-2.87 4.81-3.35a.27.27 0 0 0 .14-.34.25.25 0 0 0-.33-.14c-1.36.56-3.21 2.28-4.9 3.39-.64.43-1 .67-1.26.79a1.3 1.3 0 0 1-.22.12v.14-.15.24l.15-.19-.15-.06v.25l.15-.19-.15.19h.25l-.1-.19-.15.19.22.12v-.12H659l.22.12-.23-.12-.24.1a2.3 2.3 0 0 1 .14.84 3 3 0 0 1-1.89 2.71 4.3 4.3 0 0 1-2 .51 5.7 5.7 0 0 1-3.65-1.6 5.2 5.2 0 0 1-1.07-1.73 6.4 6.4 0 0 1-.55-2.31 3.1 3.1 0 0 1 .37-1.6 14 14 0 0 1 1.2-1.69 2.81 2.81 0 0 1 2.29-1.13h.28v-.25l-.22.14a9 9 0 0 0 1.14 1.44 6.15 6.15 0 0 0 3 1.87 3 3 0 0 0 .56.06 2.53 2.53 0 0 0 2.2-1.5 5.4 5.4 0 0 0 .52-1.44l-.24-.05v.47a6.83 6.83 0 0 0 3.55-1.61c2.18-1.58 2.35-2.82 2.35-2.9h-.25l.15.2 3.65-2.62-.15-.21-.23.12a8.5 8.5 0 0 0 1.1 1.6 3.05 3.05 0 0 0 1.28.65 6 6 0 0 0 .83.2l.05-.26-.23.13a7.5 7.5 0 0 0 1.87 2.3 2.7 2.7 0 0 0 1.5.48 2.4 2.4 0 0 0 .51-.06l-.08-.25-.22.12a10.7 10.7 0 0 0 1.44 1.81 4.7 4.7 0 0 0 1.49 1 1 1 0 0 0 .33.07 1.77 1.77 0 0 0 1.11-.56 12.6 12.6 0 0 0 2-2.73l-.22-.13.1.24a7.6 7.6 0 0 1 4.39-.23 2.12 2.12 0 0 1 1.43 1.07 3.16 3.16 0 0 1 .32 1.47 5 5 0 0 1 0 .61v.45l.19.11a.65.65 0 0 1 .62.39 1 1 0 0 1 .09.27v.12h.2l-.2-.17-4 4.9.19.17.26.05v-.17a.8.8 0 0 0-.1-.41.67.67 0 0 0-.54-.27 2.3 2.3 0 0 0-1 .33 3 3 0 0 1-1.39.28 7.7 7.7 0 0 1-1.75-.22l-.59-.14-.22-.07-.08.25.15-.21a7.3 7.3 0 0 1-2.15-2.57 6 6 0 0 1-.35-.89c0-.11-.06-.19-.07-.24v-.09a.26.26 0 0 0-.51 0h.1l-.08-.06h.1l-.08-.06.06.05v-.08h-.06l.06.05v-.08a.94.94 0 0 1-.37-.21 1.15 1.15 0 0 1-.47-.86.27.27 0 0 0-.22-.29l-2.24-.39a.26.26 0 0 0-.29.21.28.28 0 0 0 .21.3Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1147"
        d="M670.12 379.29v6.26s.77 5.57-.45 7.32-5.62 1.36-6.25-.13-.32-6.34-.32-6.34l7-7.11Z"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1149"
        d="M670.12 379.29h-.26v6.28s.06.43.12 1.08.12 1.55.12 2.46a7.6 7.6 0 0 1-.64 3.6 3.46 3.46 0 0 1-2.82 1 5.7 5.7 0 0 1-1.95-.32 1.8 1.8 0 0 1-1.05-.81 5.7 5.7 0 0 1-.3-1.54c-.05-.65-.07-1.39-.07-2.09 0-1.39.07-2.59.07-2.6h-.25l.18.18 7-7.11-.17-.18-.19-.19-7.07 7.18v.1s-.07 1.22-.07 2.63c0 .7 0 1.46.07 2.14a6.3 6.3 0 0 0 .34 1.7 2.24 2.24 0 0 0 1.35 1.08 6.2 6.2 0 0 0 2.12.36 3.93 3.93 0 0 0 3.25-1.24 7.76 7.76 0 0 0 .73-3.89 30 30 0 0 0-.24-3.61h-.26.26v-6.89l-.43.44.19.19Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1151"
        d="M651.25 413.58s-2-2.89-.94-4.62 2-.69 2.52-.74.8-1.29-.13-3.19-2.09-2.85-2.77-2.94-4.5 2.72-3.74 6.31a6.84 6.84 0 0 0 5.06 5.18"
        className="Mexico_svg__cls-41"
      />
      <path
        id="Mexico_svg__path1153"
        d="M687 410.08s6.88 2.89 7.36-4.06c.26-3.71-3.06-6.28-4.13-6.26-.72 0-1.27.43-2.51 1.9s-2.17 2.54-1.66 3.11 2.55-.6 3.45 1.6c1.53 3.76-2.51 3.71-2.51 3.71"
        className="Mexico_svg__cls-41"
      />
      <path
        id="Mexico_svg__path1155"
        d="M665.17 398.29s-.94 1.66 2 1.9a2 2 0 0 0 1.75-.65 1.91 1.91 0 0 0 .58-1.58 2.18 2.18 0 0 0 2.35 2.4 2.39 2.39 0 0 0 2.65-2.68"
        className="Mexico_svg__cls-9"
      />
      <path
        id="Mexico_svg__path1157"
        d="M665 398.16a1.6 1.6 0 0 0-.18.72 1.25 1.25 0 0 0 .48 1 3.4 3.4 0 0 0 1.86.58h.25a2.14 2.14 0 0 0 1.7-.74 2.5 2.5 0 0 0 .67-1.58.7.7 0 0 0 0-.24.25.25 0 0 0-.27-.2.27.27 0 0 0-.23.23s0 .08 0 .19a2.67 2.67 0 0 0 .41 1.44 2.54 2.54 0 0 0 2.2 1.06h.11a2.51 2.51 0 0 0 2.33-1.16 3.2 3.2 0 0 0 .42-1.62v-.19a.26.26 0 1 0-.51 0v.15a2.5 2.5 0 0 1-.34 1.34 2 2 0 0 1-1.89.92h-.15a2.06 2.06 0 0 1-1.79-.84 2.23 2.23 0 0 1-.32-1.15V398h-.26l-.25.06v.12a2.05 2.05 0 0 1-.54 1.24 1.67 1.67 0 0 1-1.32.57h-.22a3 3 0 0 1-1.57-.47.72.72 0 0 1-.29-.59 1 1 0 0 1 .06-.33v-.1a.26.26 0 0 0-.1-.35.24.24 0 0 0-.34.09Z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__path1159"
        d="M651.25 413.58s-5.37-1.18-5.32-6.43c0-3.49 3.92-5 3.92-5s-3.6 1.91-3.66 5c-.12 5.33 5.06 6.49 5.06 6.49Z"
        className="Mexico_svg__cls-42"
      />
      <path
        id="Mexico_svg__path1161"
        d="M641.41 403.43s-3.09-.68-3.43-5.13 7-4.28 7-4.28-7 .33-6.68 4.6 3.11 4.81 3.11 4.81"
        className="Mexico_svg__cls-42"
      />
      <path
        id="Mexico_svg__path1163"
        d="M687 410.08a7 7 0 0 0 3 .61c1.58-.06 3.47-.48 4.13-3.11s.38-3.88-1.35-6.21c-1.22-1.61-2.34-1.58-2.34-1.58a3.66 3.66 0 0 1 2.13 1.69c.94 1.48 2.3 3.12 1.36 6.08a4.37 4.37 0 0 1-4.83 2.93 11 11 0 0 1-2.06-.41Z"
        className="Mexico_svg__cls-42"
      />
      <path
        id="Mexico_svg__polygon1165"
        d="m675.88 358.71.51-8.81 41.45 35.89-4.6 3.16-9.71-2.77-20.18-19.95z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1167"
        d="M729.46 378.68s-10.29-8.12-23.67-18.05-29.91-22.46-29.91-22.46l.76 10.71 34.22 31.44 11.28 5.44 5.71-1.72 2.89-3-1.28-2.33Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1169"
        d="M676.27 353.29s11.94 13.47 21 20.34S715 388 716.82 387s1.15-2.2 1.15-2.2l-42-34.21.26 2.72Z"
        className="Mexico_svg__cls-43"
      />
      <path
        id="Mexico_svg__polygon1171"
        d="m675.88 358.71 29.7 29.03-4.22 3.28-4.84-1.98-25.49-26.05 1.28-4.8z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1173"
        d="M729.46 378.68s-3.12 7.37-9.77 5.64-43.21-36.48-43.21-36.48l-.09 3.63s37.07 33.95 44.22 35.33 13-4.82 12.26-5.53c-.5-.47-3.41-2.59-3.41-2.59"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1175"
        d="M672.17 358.73s11.82 15.16 18.08 20.73 11.63 10 14.18 9.46-1.53-3.36-1.53-3.36L685 367.93l-9.13-9.2s-3.57-1.42-3.71 0Z"
        className="Mexico_svg__cls-43"
      />
      <path
        id="Mexico_svg__path1177"
        d="M675.11 358.73s30 30.58 32.38 31.27c5 1.47 12.18-3.71 12.18-3.71l-2.67-1.56-.34.95s-1.28 3.11-7.75 1.73-32.8-29.72-32.8-29.72l-1 1Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__polygon1179"
        d="m675.5 375.43-2.42-4.15-.65-5.32 21.78 21.91-3.06 2.07-2.69-.9-2.04-1.04z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1181"
        d="M706.14 388.44s-2.64 3.89-6.22 3.11a10.53 10.53 0 0 1-5.62-3.36l-20.88-20.48-.51-3.11s22.91 24.24 27 25.31c3 .78 5.2-2.85 5.2-2.85l1 1.38Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1183"
        d="M694.56 387.75s-1 3-4.09 2.6-4-1.64-4-1.64l-12.8-15.21-.25-4.05s13.3 18.39 16.37 19.43a2.84 2.84 0 0 0 3.83-2.07z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1185"
        d="M680.88 347.88s12.39 10.63 13.42 11.12 5.36.65 5.61 1.29-2.8 0-3.06.65 6.26 6 7.28 6.09 6.26.13 6.13.78-3.57 0-3.7.78 5.62 5.31 6.64 5.44 7.66.13 7.66.78-5.36-.13-5.23 1 9.07 6.74 8.68 7.52-10.73-7-11-6.61-.64 2.85-1.28 3.24 0-3.24-.51-4.79-6.52-6.09-7.15-5.57-.13 3.23-.77 3.23.13-3.36-.51-4.53-6.26-5.83-7-5.83-.26 2.46-.77 2.85-.38-2.85-1.15-3.89-13.8-12.83-13.29-13.61Z"
        style={{
          fill: "#b07229",
        }}
      />
      <path
        id="Mexico_svg__path1187"
        d="M659.63 382.27s.1 4.7-2 5.38-6.1-8.62-6.1-8.62l-.93-8.68 6.2 5.77 2.84 6.15Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1189"
        d="M676.24 379.89a14.5 14.5 0 0 0-.07-2.51c-.16-1.13-.52-2.84-.52-2.84l-.4-4.84-1.15-3.24-.93-2-1.34.1-3.26 2.31-1.12 3.13 1.73 5.87 1.59 5.35 2.43.77 3-2.06Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1191"
        d="M672 388.1c.73-.22-.68-6.65-.68-6.65l-3.83-9.51-1-3.36-3.11-1.18-2 2.34.47 3.76s3 6.26 4.43 8.47 4.51 6.52 5.78 6.13Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1193"
        d="M668.54 367.93c1.11.77 2.38 3.32 2.68 5.05 0 0 2.56 7 2.22 7.69s-1.88.78-1.88.78S675 385 676 384.56s.6-3.89.25-4.67-1.44-.26-1.87-1a30.4 30.4 0 0 1-1.79-8.21c-.08-2.76-.17-4.66.17-5.35s2.9 5.79 2.9 9.25l1.11 1.29s-.69-4.75-1.11-6.22-1.36-4-1.36-4.49a24.5 24.5 0 0 0 .51-2.94c0-1.21-.08-2-.08-2s1.35.94 1.87.86 1.27-.78 1.61-3.81-.34-11.81-.34-11.81L664.58 363l4 5Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1195"
        d="M668.54 366.41a23.9 23.9 0 0 0 1.23 9.55c1.75 4.84 2.21 5 2.56 5.7s.3 5.79-.35 6.44c0 0-3.4-8.68-4.54-13s-1.45-5.92-2.05-6.27a4.8 4.8 0 0 0-1.58-.43l4.73-2Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1197"
        d="M667.29 391.49c.38-.08.14-2 .14-2l-.55-4.54-4.66-9.57-5.11-4.6-2.69-4.14-.38 7.9s3.71 7.9 6.13 10.17 6.44 7 7.12 6.78"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1199"
        d="M648.2 369.91a13 13 0 0 1 .8 3.5v2.68s1.87 3.8 3.57 6.83 3.32 6.13 4.77 5.44 2-2.94 2-3.2-1.62 2.59-2.48 2.16-4.67-12.78-4.59-13-1-.78-1.88-1.64-2.24-2.73-2.24-2.73Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1201"
        d="M662.11 380.67s-2.64-4.31-3.49-6.21-2.3-3.38-2.73-3.38-1-3.87-1-3.87 1.41 2.58 3.19 3.44 2.9 1.56 3.76 1.21a18.7 18.7 0 0 1 .5 4c0 2-.25 4.83-.25 4.83Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1203"
        d="M653.6 374.32a24.3 24.3 0 0 0 2.63 5.31 61 61 0 0 0 4.61 5.71 49 49 0 0 1-4.84-5.54 27.5 27.5 0 0 1-2.76-5.57l.34.09Z"
        className="Mexico_svg__cls-45"
      />
      <path
        id="Mexico_svg__path1205"
        d="M662.69 371.09s.84-2.35 1.57-2.46 2.27-.57 2.27-.57a5.07 5.07 0 0 1-2.37-1.56c-1.11-1.31-1.36-1.21-2.57-2.61 0 0 .69 2.61.89 3.84a26 26 0 0 1 .21 3.36"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1207"
        d="M661.86 371.85s3.78 8.12 4.76 10.84a22.2 22.2 0 0 1 .81 6.79 35 35 0 0 0-1.32-5.27c-.85-2.38-4.3-9-4.59-9.76a5.45 5.45 0 0 1 .34-2.6"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1209"
        d="m667 366.57.89-11.93-.89-4.21-5.37-11.91s-.26 1.75-1.6 1.68a12.07 12.07 0 0 1-6.13-3.57 18.6 18.6 0 0 1 .45 5.45 23 23 0 0 1-.7 4.08L664 365.6l3 1Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1211"
        d="M646.44 374.4s1.62 2 2.56 1.69.59-4-.6-6-13.8-18.92-15.67-20 13.71 24.32 13.71 24.32Z"
        className="Mexico_svg__cls-46"
      />
      <path
        id="Mexico_svg__path1213"
        d="M655.05 367.45c.25.78 1.16 6.15-1 6.66-3 .69-16.86-18.44-19-21.07 0 0-8.69-5.43-8.86-6.82s9.37 1.88 9.37 1.88l18.57 17.75a6.2 6.2 0 0 1 .94 1.6Z"
        className="Mexico_svg__cls-46"
      />
      <path
        id="Mexico_svg__path1215"
        d="M655.05 367.45h-.06a13.8 13.8 0 0 1 .41 3.3c0 1.54-.32 3.05-1.39 3.29h-.15c-.8 0-2.26-1.14-4-2.91-5.27-5.32-13.2-16.21-14.78-18.15s-.55-.34-1.36-.88c-1.23-.79-3.07-2-4.63-3.17s-2.8-2.26-2.85-2.73c0-.08 0-.14.15-.19a1.3 1.3 0 0 1 .5-.06A24 24 0 0 1 632 347c1.9.56 3.51 1.11 3.52 1.11l18.57 17.75s.16.2.36.5a4.6 4.6 0 0 1 .55 1.08h.06a6.2 6.2 0 0 0-.94-1.61l-18.58-17.76s-6.5-2.23-8.7-2.23a1.5 1.5 0 0 0-.53.08.3.3 0 0 0-.22.28c0 .39.63 1 1.47 1.68a85 85 0 0 0 7.41 5.17c1 1.28 4.93 6.56 9 11.5 2 2.48 4.07 4.87 5.82 6.65s3.21 2.94 4.09 2.94h.17c1.17-.27 1.46-1.84 1.47-3.38a14.4 14.4 0 0 0-.41-3.34Z"
        className="Mexico_svg__cls-45"
      />
      <path
        id="Mexico_svg__path1217"
        d="M646.44 374.4a14.5 14.5 0 0 1-1.67-4.66 14.4 14.4 0 0 0-.88-3.63c-.13-.65-10.22-15.29-11.25-16.2a42 42 0 0 0-4.46-2.85 30 30 0 0 1 .39 3.37 4.2 4.2 0 0 0 .12 1.33 68.5 68.5 0 0 0 7.79 11.37c4.59 5.31 10 11.27 10 11.27Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1219"
        d="M661.86 371.85c1.35-.78.76-5.44.25-6.91s-8.77-18.65-8.77-18.65l-2.48.94-4.68-3.67-2.63-2.85a34 34 0 0 1 .85 6.1c-.09 2-.18 3.19-.18 3.19l6.56 11.49z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1221"
        d="m671.13 361.49 2-2.59-1-8.55-5.45-18.65a3.78 3.78 0 0 1-2.72-.52 15.6 15.6 0 0 1-2.77-2.51l1.32 11.14 5.63 15.64.34 4.67 2.71 1.37Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1223"
        d="M654.1 365.85s-5.49-6-7.28-8.94-3.32-5.83-3.32-5.83a4.8 4.8 0 0 1-3.45-.13c-1.92-.78-4.47-3.5-4.47-3.5s-1.53 3 6.39 11c9.07 9.2 12.13 7.39 12.13 7.39Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1225"
        d="M667.33 367.86c2.31-.92 2.23-10.63.07-17.17a63 63 0 0 0-5.76-12.18s4.48 10.5 5.43 14.78 0 7.31-.77 7-.76-2.52-2.55-6.67-3-5.18-3-5.18 6.32 17.3 4.53 17-10.6-19.5-11-20-.64.71-.64.71 7.86 24 13.67 21.71Z"
        className="Mexico_svg__cls-46"
      />
      <path
        id="Mexico_svg__path1227"
        d="m672.45 321.15 3.88 8.24 1.23 8.71.3 7.35s.26 14.49-1.53 14.84a2.49 2.49 0 0 1-2.72-1.74c-.09-.34-3.32-16.32-3.32-16.32l-3.41-16.68 1.21-1.16.41-2.46 2.63-.18z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1229"
        d="M661.86 371.85c1.54-.21 0-4.14 0-4.14s-1.28 1.9-2.31.6-2.64-6.09-2.64-6.09l-1-2.89s-1.11 3.19-2.55 3.19-9-12.7-9-12.7l-.89 1.26s10.56 21.85 18.36 20.77Z"
        className="Mexico_svg__cls-46"
      />
      <path
        id="Mexico_svg__path1231"
        d="M656.91 362.22a12.36 12.36 0 0 0 .77-6c-.51-2.86-4.34-10-4.34-10a5.4 5.4 0 0 1-2.68-.26 29 29 0 0 1-4.47-2.47 73 73 0 0 0 4.34 9.21c2.3 3.88 6.38 9.45 6.38 9.45Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1233"
        d="M663 357.82a49 49 0 0 0-4-13c-3.07-6.22-5.11-8.23-5.11-8.23a21 21 0 0 1 .19 3.89c-.06 2.53 0 3.05 0 3.05a10.58 10.58 0 0 1 4.92 4.79 67.4 67.4 0 0 1 4 9.47Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1235"
        d="M671.39 346.29a72 72 0 0 0-1.58-11.41c-1.15-4.14-2.36-9.65-2.36-9.65a1.55 1.55 0 0 1 .64-.85 1.46 1.46 0 0 1 1.28-.06c1.53.52 2.17 4.34 2.17 4.34s-.19-5.89-.32-6.15-.51-1-.51-1a2.46 2.46 0 0 1-1.22.2c-.7-.07-1.53-.2-1.53-.2s.48 1.82-.29 2.66c-.55.62-1.09-.55-1.4-.71-.12-.06-.29.84-.29.84a23 23 0 0 1 .71 3.89 13.6 13.6 0 0 1-.19 3.3 54 54 0 0 0 2.33 7 63 63 0 0 1 2.56 7.78Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1237"
        d="M677.86 345.45s1.28-10.43-1.08-17.1-4.35-8.43-4.35-8.43l-1.08 1.3s3.55 5.67 4.6 10.95c1.09 5.5 1.91 13.28 1.91 13.28"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1239"
        d="M667.39 350.7a133 133 0 0 0-2.62-13.41c-1.47-5.26-1.89-7.13-1.89-7.13l-2.23-2.07s1.31 5.57 1.18 7.19-.26 2.72-.26 2.72a35 35 0 0 0 2.56 5.11 50 50 0 0 1 3.26 7.59"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1241"
        d="M672.84 363.65c2.08.06.25-11.74-.6-14.77s-5.71-17.22-5.71-17.22 5.84 20.19 5.37 21.2c-.69 1.5-3-6.13-3.4-6.05s4.34 13.65 2.63 13.82-2.55-2.85-2.55-2.85l.17 2.94a4.77 4.77 0 0 0 4.09 2.93"
        className="Mexico_svg__cls-35"
      />
      <path
        id="Mexico_svg__path1243"
        d="M675.39 357.69c1.43 0-.39-11.14-1.41-16.07s-3.87-14.77-3.87-14.77a89 89 0 0 1 4.52 14.69c1.61 7.85 2.71 18 1.19 18.14a2.51 2.51 0 0 1-2.3-1.47l-.26-1.82a2.55 2.55 0 0 0 2.13 1.3"
        className="Mexico_svg__cls-35"
      />
      <path
        id="Mexico_svg__path1245"
        d="M656.22 370.78c.22.79.17 4.62-1.86 4.34s-5.73-3.7-6.49-5.94c0 0 4.4 4.87 5.92 4.84s1.51-5 1.26-6.33 1.17 3.09 1.17 3.09"
        style={{
          fill: "#312317",
        }}
      />
      <path
        id="Mexico_svg__path1247"
        d="M666.81 317.71s2.63 1.68 4.73.45a7.71 7.71 0 0 0 3.45-5.83 7.3 7.3 0 0 0-1.41-4.73c-1.27-1.68 2 1.43 2 4.54s.19 8.48-4.8 9.65-2.81-.26-2.81-.26l-1.15-3.82Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path1249"
        d="M662.87 308.19a43.8 43.8 0 0 1 4.36 9.78c1.21 4.64 1 6.42.22 6.51s-1.05-.55-1.24-1.71-3.34-14.58-3.34-14.58"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__polygon1251"
        d="m607.74 314.52 20.81 30.2 26.06-29.42-16.48-16.98z"
        className="Mexico_svg__cls-48"
      />
      <path
        id="Mexico_svg__polygon1253"
        d="m644.77 316.59 1.16-3.76 1.21-4.39 1.27-.46 3.2 1.23 2.11-3.04 3.38-6.09-.7-2.36-.81-1.68-5.27-9.19-1.78 3.47-1.65 1.01-3.07-1.75-3.71 4.86-4.53-2.11-1.53 3.67-1.21 4.73 2.55 8.03 4.35 4.47z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1255"
        d="M644.78 316.61s.9-.65 1.28-3a52.3 52.3 0 0 0-.19-12.64c-.64-2.91-2.56-8.68-2.94-8.23s3 6.35 2.49 13.54-.25 9.21-1.79 9.92 1.15.45 1.15.45Z"
        className="Mexico_svg__cls-49"
      />
      <path
        id="Mexico_svg__path1257"
        d="M646 304.49s3.45 4.93 5.12 3.18.83-8-.26-10.5-2.23-6-2.23-6l1-1s1.14 4.14 1.78 6.74 2.56 10.23.26 11.6-5.62-2.79-5.62-2.79l-.07-1.17Z"
        className="Mexico_svg__cls-49"
      />
      <path
        id="Mexico_svg__path1259"
        d="M634.86 307.88a4.54 4.54 0 0 1 2.72-1.85c1.58-.18 1.88.51 1.88.51l1.4 4.06 2.35 4.2 2.08 2.07-1.23 1.13-1.66.31s-4.95-2.59-5-2.77-1.36-1.81-1.36-1.81l-1.15-5.88Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1261"
        d="M643.05 350.76c-1.63.84-5.36-1-7.47-2.88s-13.22-13.19-13.22-13.19l-1.55-6.29 4.29 1.17 7.54-3.24 1.41-2.66 9.07-4.73 5-2.72 11-.19 2.62-5.38s3.68 6.37 4.29 9 .49 10.65-.46 11.17-4.53-2.4-5.05-2.59 2.69 11.27 0 11.72-7.15-4.27-7.15-4.27 1.79 10.23-.32 10.3-7.56-2.57-9.88-5.08c0 0 2.59 8.45-.15 9.88Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path1263"
        d="M640.88 337.48s1.77 2.59 2.32 3.41-.09 5.67-.43 6.56c-.68 1.86-3.19-2.2-4.55-5.78 0 0-4-6.65-4.26-7.52s6.92 3.33 6.92 3.33"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1265"
        d="M662.28 312.12s3.88 16 2 16.54-7.2-5.05-7.79-5.87-8-12.61-8-12.61l-1.57-1.6.47-.82 3.15 1.2 11.75 3.16Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1267"
        d="M634.86 342.83c-.86.55-2.51-2.07-3.28-2.77s-3.36-3.89-5.92-6.48-4.42-4.49-4.42-5-1.54-2.15-1.54-2.15l1.37-1.73 1.78-.26s10.56 8.42 11.29 9.76 1.19 8.33.72 8.64Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1269"
        d="M650.74 343c-.49.4-7.49-4.67-10.43-8.85s-6-7.87-6.73-9.81-1.32-3.71-1.32-3.71l2.13.47s17.16 21.25 16.35 21.9"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1271"
        d="M653.25 335.57c-.39.48-3.45-1.81-5.32-4.28a6.52 6.52 0 0 1-.89-5.52s6.59 9.33 6.21 9.8"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1273"
        d="M657.17 334.62c-.95.46-5-4.38-8.3-9.84-2.47-4-3.09-4.64-3.62-5a9.3 9.3 0 0 0-2.64-.82l-.34-.52 1.79-.43 1.32-1.55 2.08-2.68 8.31 16.76s2 3.76 1.4 4.05Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1275"
        d="M635.58 347.88c.07.61 0 1.23-2.3 1s-14.11-6.55-19.45-15.26-6-9.88-6-9.88l2.36-2.69L629 342.49l6.61 5.39Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1277"
        d="M635.58 347.88c.25 1-.94 1.26-2.13 1s-5.92-2-13.45-10.37-10.48-14.42-10.48-14.51-.38-3.58-.38-3.58l2.21-.95 12.95 19.74 11.28 8.72Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1279"
        d="M648.17 339.42a40.5 40.5 0 0 1-6.39-5.77c-2.48-3-7.54-9.91-7.41-11.28s2.24-1.36 2.24-1.36l-.13-3.49.64-1.17 3.64 1.49 4.6 5.64 1.68 2.29s3 7.17 2.4 7.81-4.78-4-5.3-3.43 4.8 8.75 4 9.27Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1281"
        d="M640.88 337.48s1.28 1.94.7 3.3-1.08 2.07-3-.77-4.23-6.05-4.45-5.82.24 4.39-.72 4.39-4-3.56-5.88-6.42-4.85-7.58-4.85-7.58a17.3 17.3 0 0 0 .13-4.21 49 49 0 0 0-.39-4.92 15 15 0 0 0 .62 1.77 5.3 5.3 0 0 0 .85 1.29l7 8.28 2-1.37 4.16 8.11 3.83 4Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1283"
        d="M614.25 325.42s5.43 9.53 10.47 14.84a34.3 34.3 0 0 0 10.86 7.62l-16.41-19.41z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1285"
        d="M655.89 331.06c-.29.2-3.64-3.44-5.75-6.68s-3.77-7.77-3.64-9.78.7-6.87.7-6.87 5.63 5.84 6.7 8.56 3.41 6.43 2.9 6.88-4.29-2.55-4.74-1.83 4.4 9.33 3.83 9.72"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1287"
        d="M662.28 325c-.69.35-3.51-3-4.28-5.05a29 29 0 0 1-1-6.16l-2.49-5.9.25-6.54 2.49-.39 3.77 5.19a18.05 18.05 0 0 1 1.41 7.45c-.07 4.4.63 11-.13 11.4Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1289"
        d="M618 341a81.4 81.4 0 0 1-8.11-12.06l-1.66-5.57.89.72s1.47 6.41 9.26 14.05 9.52 8.3 9.52 8.3 1.53 4.21.77 5.7A104 104 0 0 1 618 341"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1291"
        d="M626.43 349.91a113.4 113.4 0 0 1-11.92-12.52 91 91 0 0 1-8.6-13.05l2.3-2.16s4.38 10.24 7.53 14.3 10.69 13.43 10.69 13.43"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1293"
        d="M635.58 347.88s-7.71-7.64-11.62-12a42.8 42.8 0 0 1-6.09-8.68l3.23 1.25a28.4 28.4 0 0 0 4.09 6.87c2.81 3.5 10.39 12.52 10.39 12.52Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1295"
        d="M634.14 334.18a103 103 0 0 1-6.22-8.37c-2-3.24-4-7.39-4-7.39s5.67 6.48 7.33 6.91 1.61 0 1.61 0a9 9 0 0 0-.12 4.28c.55 1.94 1.45 4.61 1.45 4.61Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1297"
        d="M635.84 313.33a18.7 18.7 0 0 1 .21 5.74c-.47 2.12-1.59 2.1-1.59 2.1a50 50 0 0 0 3.46 4.38 45 45 0 0 0 4.48 3.54s-2.56-3.54-3.59-5.35-2.51-3.85-1.86-5.62 4.08 1.21 5.06 2 5 5.62 5 5.62-1.5-5-3.5-6.78-7.7-5.66-7.7-5.66Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1299"
        d="M652.83 324.21s-2.17-5.22-3.41-8.42-3.17-10.13-3.17-10.13.14 3.18 0 5.51-1 5.9-2 6.41-1.26.62-3.14.1 1.31.88 1.31.88a4.48 4.48 0 0 0 2.75-1c.83-.94 1-2.95 1.92-2.66s1.84 3.34 2.58 4.67 3.2 4.65 3.2 4.65Z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1301"
        d="M646.22 305.59s4 4.54 5.8 2.5.74-7.81.74-7.81 2.46.94 3.22.33.42-2.89.42-2.89 4.37 6.38 6.47 10.47 3.19 11.44 3.19 11.44a64 64 0 0 1-5.44-11.44c-1.68-5.08-4.12-7.39-4.57-6.9s-1.12 4-.58 5.89 2 4.25 3.07 6.87 2.17 6.74 2.17 6.74-2.08-3.15-3.29-4.86a18 18 0 0 0-3.32-3.21c-.83-.81-2.08-2.3-3.29-2.78s-3.61-1.69-3.61-.75-.47-1.85-.47-1.85z"
        className="Mexico_svg__cls-40"
      />
      <path
        id="Mexico_svg__path1303"
        d="M632.65 325a54 54 0 0 0 4 6.8c1.79 2.33 4.22 5.64 4.22 5.64a49.4 49.4 0 0 1-5.37-5.7 30.7 30.7 0 0 1-2.87-6.74Z"
        style={{
          fill: "#171717",
        }}
      />
      <path
        id="Mexico_svg__path1305"
        d="M659 326.2c-.58.22-2.43-.45-2.63.22s1.06 3.34 2.44 4.74 1.94 1.45 2.26 1.29-.14-1.39-.37-2.82-.05-2.95-.2-3.4-1.5 0-1.5 0Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1307"
        d="m611.3 297.68-2.3 1.52-2.81 5.71.77 10.45s2.6 3.67 4.19 6 6.88 8.27 8.24 7.93 2.81-4.49 3-6.74.34-6.39.34-6.39a29.3 29.3 0 0 0 3.49 4.66c2.22 2.42 4.09 4.67 5.12 4.5s4.08-6.31 4.16-7.09-7.66-19.78-7.66-19.78l-3.45-1.79-13 1Z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path1309"
        d="M628.69 313.51s1.34 4.85 2.17 7.26 0 4.47.43 4.53 4.49-5.38 4.55-7.84.07-5-1-12.51.35-9.7.35-9.7l-2.33-1.9-4 8.11-.12 12.05Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1311"
        d="M615.08 309.23s.89 7.32 1.4 9.72 1.92 6.47 2.69 6.41 3.19-6.48 3.25-8.68c0 0-1.66-3.11-1.59-10.95s-.77-8.62-.77-8.62l-5 12.12Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1313"
        d="M604.58 294.1s-6.12 8.9-6 13.78.94 3.8 2.34 8.21a76 76 0 0 1 2.26 11.49c.09.56 1-.3 1.11-.95s.29-32.53.29-32.53"
        style={{
          fill: "#45392d",
        }}
      />
      <path
        id="Mexico_svg__path1315"
        d="M604.54 295.15s-5.36 8.29-5 12.87 1.11 4.45 2.64 8.55 1.66 10.8 1.66 10.8a14 14 0 0 0 3.62-1.88 17.1 17.1 0 0 0 3.64-4.15s-.66-1.49-1.89-4.16a15.3 15.3 0 0 1-1.37-3.72l-1.57-2.25.47-7.95 1.4-5.74v-2.16l-3.62-.21Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1317"
        d="M633.54 309.42a17.8 17.8 0 0 1-3.77-1.23 4.28 4.28 0 0 1-1.53-2.2l.64-1.56Z"
        className="Mexico_svg__cls-52"
      />
      <path
        id="Mexico_svg__path1319"
        d="M605.65 296.05s-3.87 8.34-3.41 14.08 3.62 13.09 3.92 13.18.17-.56.26-1.86-.17-17.15-.17-17.15l1.87-5.57.09-2.89z"
        className="Mexico_svg__cls-38"
      />
      <path
        id="Mexico_svg__path1321"
        d="M615 297.91a10.3 10.3 0 0 1 .18 3.54c-.34 1-2.39 2.34-3.24 4a48 48 0 0 0-2 5.44 14.6 14.6 0 0 1 2.21-3.54c1.28-1.38 1.79-2.33 2-1.56s.68 4.07.42 4.67a15.3 15.3 0 0 0-2 3.89 8.2 8.2 0 0 0 .09 4.66s.44-2.79.85-4.23a3.47 3.47 0 0 1 1.45-1.91l2.13 4.59a22.7 22.7 0 0 1 .34-3.81c.34-1.64 2.12-3.95 2.7-3.95s1.47-.32-.71-1.42c-.7-.46-.25-8.43.32-8.75s3.58-.44 3.27-1.54-2.93-4.06-3.18-4.32-4.88 4.26-4.88 4.26Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1323"
        d="M633.1 314.86s-1.86-.32-2.88-.52a1.42 1.42 0 0 1-1.15-1.16l.32-1.23 2.36 1.29z"
        className="Mexico_svg__cls-52"
      />
      <path
        id="Mexico_svg__path1325"
        d="M608.41 315.81a15 15 0 0 1-1.1 2.92 23 23 0 0 0-.79 3.17s-.57-3.83-.76-6.52-.39-4.43-.7-4.6-1.25 1.26-1.25 1.26a16.6 16.6 0 0 1 .57-4.46c.58-1.46 1.06-3.53.55-3.86s-1.6.59-2.08 1.36-1.37 2.46-1.37 2.46a17.5 17.5 0 0 1 1.18-3.59c.6-1 3.51-4.38 4.05-5.67a7.8 7.8 0 0 0 .55-2.69l2-.1s2.1 1.64 2.12 3.06c0 .81-2 1.71-2.06 1.8-.13.26-1.69-.13-2.07 6.54s1.32 6.13 1.15 8.92Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1327"
        d="M626.77 298.73s.44 3.62.06 4.73-1.47 2-2.23 3.43-.71 4.86-.71 4.86a11 11 0 0 1 1-2.72c.63-1 1.14-1.95 1.4-1.95s1 1.3 1.53 3.18 1.54 5.05 1.54 5.05-.45-2.46.19-2.46a1.92 1.92 0 0 1 1.72.45c.84.65 1.79 1.56 1.79 1.56a4.1 4.1 0 0 0-1.28-2.21c-1.21-1.29-1.91-1.22-2.3-3a12.2 12.2 0 0 1-.38-4.21c.19-.71 1 .46 1.72 1.3s2.94 2.79 2.94 2.79-.95-1.49-1.21-1.95-.07-3.89 0-5.83-.07-3.76.63-4.27.84-3.05.51-3.51-7 4.74-7 4.74Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1329"
        d="M648.14 291.26a45 45 0 0 0 .73 6.48c.55 2.38 2.13 7.56 2.13 7.56a41 41 0 0 1-3.07-7.17c-.94-3.33-1.79-6.91-2.64-7.17s-1.83 1.6-1.83 3 .89 6.56 2 8.38a18.4 18.4 0 0 1-2.46-4.64c-.72-2.25-1.45-4.24-1.45-4.24a9.2 9.2 0 0 0-.43 4 18.2 18.2 0 0 0 2.1 5.14 19 19 0 0 1-1.88-1.86 11.7 11.7 0 0 0-1.37-1.38 11.7 11.7 0 0 0 .9 4.15c.76 1.25 2.25 3.24 2.25 3.24a23 23 0 0 1-2.46-2.12 5 5 0 0 1-.9-1.33 29 29 0 0 0 1.28 6.34c.89 2.2 2.85 5.84 2.85 5.84a15.35 15.35 0 0 1-3.92-5.49c-1.57-3.63-2.34-14.44-2-16.09 0 0 1.21-2 2.31-3.64s2.51-9.23 2.51-9.23 1.74 7.06 2.93 8.4a7.2 7.2 0 0 0 2.43 1.81Z"
        className="Mexico_svg__cls-48"
      />
      <path
        id="Mexico_svg__path1331"
        d="M631.24 289.14a29 29 0 0 0 1.47 2.73c.58.85 1.15 1.93 1.15 1.93a42 42 0 0 1-4.47 4.08c-2.37 1.82-5.5 3.83-6.2 2.79a3.57 3.57 0 0 1-.67-1.93 26.6 26.6 0 0 0 4.65-3.63 13.1 13.1 0 0 0 3.2-4.26 9 9 0 0 1 .87-1.71"
        className="Mexico_svg__cls-48"
      />
      <path
        id="Mexico_svg__path1333"
        d="M609.74 296.14s.36 4.41 2.22 4.34 7.34-5.64 7.72-5.89a3.86 3.86 0 0 0 .75-2.08 7.6 7.6 0 0 0-.33-1.49s-5.91 6.06-8 6.25a2.59 2.59 0 0 1-2.34-1.13Z"
        className="Mexico_svg__cls-48"
      />
      <path
        id="Mexico_svg__path1335"
        d="M609.91 290.35a23 23 0 0 0-.6 4 6.2 6.2 0 0 0 .37 1.55s-4.24 1.49-4.94.2a5 5 0 0 1-.24-3.14 17 17 0 0 0 3-.25c1.08-.26 2.36-2.33 2.36-2.33Z"
        className="Mexico_svg__cls-48"
      />
      <path
        id="Mexico_svg__path1337"
        d="M649.9 284.12a56 56 0 0 0 2.84 6.36c1.11 1.82 2.85 5.57 2.85 5.57s-2.85-3.32-3.75-4.06-2.34-1.99-2.34-1.99a8.3 8.3 0 0 0 .42-2.17v-3.75Z"
        className="Mexico_svg__cls-48"
      />
      <path
        id="Mexico_svg__path1339"
        d="M603.84 293a19 19 0 0 0 2.54.14 3.7 3.7 0 0 0 1.61-.44l1.61-2.41a10.8 10.8 0 0 0-.25 4.87c.56 2 1.73 2.33 2.19 2.33a7.57 7.57 0 0 0 4.45-2.28 46 46 0 0 1 4.14-3.7 10.6 10.6 0 0 0 .35 5.2c.92 2.6 2.4 2.55 4.4.94A48 48 0 0 0 630 292a14 14 0 0 0 1.36-2.05l2.19-1.75 1.89-10.68-1-1.4-2.77 1.32-3.31-1.32-1-1.35-1.87 3.23-2 1.3-1 .17-2.31.45-1-2.07-.61-1.61-1.12-.51-4.77 4.8-2.69-.14-2.71 4.25-1.94 2.69-2 4.72.53.9Z"
        className="Mexico_svg__cls-52"
      />
      <path
        id="Mexico_svg__path1341"
        d="M627 282.14a18.4 18.4 0 0 1-1 7.13 39 39 0 0 1-3.19 7.65 20 20 0 0 0 7.09-8.17 26.25 26.25 0 0 0 1.76-11.27l-4.7 4.66Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1343"
        d="M632.78 277.28s.57.78.06 4.79a80 80 0 0 1-1.47 7.91s.57 1 1.21 2.27 2.24 3.56 3.39 3.17a8.07 8.07 0 0 0 4.15-4.41c1.21-2.65 2.3-5.24 2.75-5.63s.64.26.83.45.56 2.46 1.71 3.44 2.65 2.49 3.35 2a3.16 3.16 0 0 0 1.26-2.44c-.12-.64-2.55-7.9-2.55-7.9l-3.07-7.84-2-3-5.58.52-4.08 6.67Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1345"
        d="M642.44 270.09a20 20 0 0 1 1.66 7 37 37 0 0 1-.72 7.43 36.4 36.4 0 0 0-.17-7.26c-.51-2.72-1.32-4.49-1.24-5.27a11.7 11.7 0 0 1 .47-1.9"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1347"
        d="M650 284.26a21.7 21.7 0 0 1 0 4.62c-.32 1.49-2.5-1-3.83-5.9s-1.09-6-2.12-8.42-1.64-4.47-1.64-4.47l2.79-.39z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1349"
        d="M636.35 293.42s5.32-3 6-12.12c.32-4.28-2.43-11.21-2.43-11.21s0 7.38-2 12.15-3.61 7.94-3.61 7.94a6.2 6.2 0 0 0 1.92-1.33c.64-.78 1.53-2.11 1.53-2.11a7.3 7.3 0 0 1-.19 3.14 28 28 0 0 1-1.24 3.54Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1351"
        d="M631.66 277.47a6.13 6.13 0 0 1-2.4 3.83 43.4 43.4 0 0 1-6.26 3.82 20.5 20.5 0 0 0 4-5.12 4.66 4.66 0 0 0 .26-3.95 4.93 4.93 0 0 1-1.66 2.27 7.15 7.15 0 0 1-3.13 1.16 5.1 5.1 0 0 1 1.3-2.52c.24-.27.19-.88.36-1.38a27 27 0 0 1 2.3-4.65A16.6 16.6 0 0 0 629 275c1.28 1.23 2.66 2.46 2.66 2.46Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1353"
        d="M648.32 266.72a34.7 34.7 0 0 1 1.78 7.78 51.3 51.3 0 0 1-.08 9.76 58 58 0 0 1-3.41-6c-.68-1.73-.68-4.32-1.27-5.62a6.4 6.4 0 0 0-2.06-2.05 4.9 4.9 0 0 0-2-.26 3.13 3.13 0 0 0 1.71-2.13 9.5 9.5 0 0 0 0-2.12 8.8 8.8 0 0 0 2.68.73 6.1 6.1 0 0 0 2.64-.13Z"
        className="Mexico_svg__cls-48"
      />
      <path
        id="Mexico_svg__path1355"
        d="M636.38 285.9a23.6 23.6 0 0 0 3.67-9.07c.77-5-.13-6.74-.13-6.74a4.33 4.33 0 0 1-2.17-1.12 25 25 0 0 1-2.51-3.41 18.8 18.8 0 0 1-.13 5.74c-.55 3.15-3.45 6.17-3.45 6.17a3.8 3.8 0 0 0 2.9-.25 5.54 5.54 0 0 0 2.68-4.88s.64.38.55 4.36a50 50 0 0 1-1.41 9.2"
        className="Mexico_svg__cls-48"
      />
      <path
        id="Mexico_svg__path1357"
        d="M602 292.83c-.62-.09 1.92-4 3.64-6.74l4.15-6.54a2 2 0 0 0 1.47.39 7.2 7.2 0 0 0 4.73-3.25 20.5 20.5 0 0 0 2-4.86c.06-.64-.2 3.5 1.78 5.77s1.92 2.08 2.75 1.88a24.6 24.6 0 0 1-.83 5.51c-.76 2.66-1.53 6.48-1.53 6.48s.32-5-.51-6.42-1.28.13-2 1.95a8.8 8.8 0 0 1-2.24 3.11 34.5 34.5 0 0 0 1.92-4.54c.76-2.33.38-2.4.19-2.46s-.57-.13-1.4.84a4 4 0 0 1-1.67 1.23 4.5 4.5 0 0 0 1.35-2 11 11 0 0 1 1.85-3.49 3.56 3.56 0 0 0 1-1.88c0-.46-.13-1.43-.52-1.43s-.89.59-2.74 2.33-2.17 1.88-2.49 2.53a48 48 0 0 0-1.73 5.12 31 31 0 0 1-2.1 5.44 4.5 4.5 0 0 1-1 .87s.64-2 1.6-4.69 2.24-6.16 1.92-6.74a.81.81 0 0 0-1.41 0c-.25.52-2.1 2.79-4 5.51s-1.85 6.09-2.3 6.22c0 0-1.23 0-1.85-.13Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1359"
        d="M650.14 263.78a2.79 2.79 0 0 1-1.83 2.94 6.86 6.86 0 0 1-4.68-.35 11 11 0 0 1-.26-2.79z"
        style={{
          fill: "#874f20",
        }}
      />
      <path
        id="Mexico_svg__path1361"
        d="M611.41 270.13a19.7 19.7 0 0 1-1.46 4.14c-1.1 2.3-2.91 4.21-2.69 4.5a3.69 3.69 0 0 0 2.84 1.33c1.6 0 2.18-9.56 2.18-9.56l-.28-.34z"
        className="Mexico_svg__cls-54"
      />
      <path
        id="Mexico_svg__path1363"
        d="M635.93 264.87s-.72 12.63-4.26 12.6-5.15-6.38-5.15-6.38-.3 8.52-4.82 8.52c-2 0-4.2-6.58-3.74-7.77 0 0-.84 4.53-3 6.21-4.24 3.33-6.94 1.7-7.08 1.19s3.57-4.07 4.08-9c0 0 .66.22 1.68-1.26s1.61-3.1 2.63-2.81 6.13-2.07 6.13-2.07l2.68-3.4s.31 1.1 2.28-.23a7.2 7.2 0 0 0 2.64-3.37l5.25 4.44.66 3.33Z"
        className="Mexico_svg__cls-52"
      />
      <path
        id="Mexico_svg__path1365"
        d="M622.1 252.89s3.18 4.81 5.31 7.48c.12.16 1.16-1 1.16-1 .7 1 1.09 1.79.88 2.3-.83 1.94-2.55 4.6-1.15 7.39a6.1 6.1 0 0 1 .32-3.57c.77-2 1.34-2.72 1.79-2.66s1.21 11.54 2 11.47 1.79-5.18 1.79-8.81.72-.65 1.06.07 3.47 5.83 6.15 5.05 2.31-5.51 2.24-6.54-1.92-7.32-1.92-7.32l-12-7.56s-.35.94-1 3.08-6.61.62-6.61.62Z"
        className="Mexico_svg__cls-54"
      />
      <path
        id="Mexico_svg__path1367"
        d="M639.16 251.76s.7.65 1.86 3.63 1.27 12.63-.26 12.56-4.6-1.81-5.11-3.11.19-6.08-.83-7.38a16 16 0 0 1-2.3-5.44c-.07-.91.19-3.83.19-3.83l2.68-1 3.77 4.54Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1369"
        d="m638.3 248.75 5.11 7.61 4.52 6.52a11.8 11.8 0 0 1 2.21.9 4.85 4.85 0 0 1-6.16 1c-1.76-1-.86-4.06-3.1-9a15.9 15.9 0 0 0-6.26-7.06l1.41-1.36 2.27 1.4Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1371"
        d="M635.48 244.61s4.57 3 6.19 6.3a91 91 0 0 0 4.51 8.47c2 3.19 4.05 4.19 4 4.4a2.18 2.18 0 0 1-2.38-.21 9.4 9.4 0 0 1-2.8-3.07c-.81-1.47-3.66-6.82-4.73-8.21s-4.47-4-4.56-3.71 1.07 1 3 4.19a13.85 13.85 0 0 1 2.3 6c-.13 0-.56-1.17-2.26-4s-5.41-6.52-5.62-6 1.83 3.88 2.85 5.83a39 39 0 0 1 2.56 6.48c-.17 0-1.37-2.55-3.41-5.71s-2.43-2.76-3.28-3.79-2.67-3.44-2.67-3.44a4.57 4.57 0 0 0 3.61-.58 8.7 8.7 0 0 0 2.71-3Z"
        className="Mexico_svg__cls-48"
      />
      <path
        id="Mexico_svg__path1373"
        d="M623.87 253a18 18 0 0 0 4.53.49 10.2 10.2 0 0 1 2.14-.13 5.3 5.3 0 0 1 1 2.78c0 1.49-1 4.28-1.47 4.34s-.38-2.52-1.08-3.43a52 52 0 0 0-5.08-4Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1375"
        d="M625.42 260.72a18.6 18.6 0 0 1 .22 7.63c-.73 4.44-3.28 9-3.94 9s-.44-5-.73-7.69c0-.29-.06-.56-.09-.82s-1 3.36-1 3 .85-4.72.81-5l-.2-1.67 3.29-3.91 1.68-.6Z"
        className="Mexico_svg__cls-54"
      />
      <path
        id="Mexico_svg__path1377"
        d="M619.82 264c-.89 1.1-2.26.8-3.53 1.2s-1.62 2.18-1.62 2.18 1-.71 1.41-.52 1 .15.08 2.35-4.38 5.95-4.21 6a26.7 26.7 0 0 0 5.11-5 9.3 9.3 0 0 0 1.36-3.54 4.2 4.2 0 0 1 2-1.49c.32-.07 1 .07 1.34 1.36s.84 5 1.09 5.12 1.15-3.37 1.53-5.12a36 36 0 0 0 .37-5.6 9 9 0 0 0-1.13-.3 14 14 0 0 1-3-1.73s.42 3.59-.78 5.07Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1379"
        d="M635.59 241.46a4.65 4.65 0 0 1-1.28 5.12 4.2 4.2 0 0 1-2.77 1.1 9 9 0 0 1-3.43-1.07l-7.63-3.18-4-1.26-2-.55.28-2.2 6 .26 5.91 2.26 2.59.84 2.2.39h1.66l1.38-.39a2 2 0 0 0 .82-.61 3.8 3.8 0 0 0 .3-.71Z"
        className="Mexico_svg__cls-52"
      />
      <path
        id="Mexico_svg__path1381"
        d="M635.59 241.46a2.91 2.91 0 0 1-1 2.46 5.47 5.47 0 0 1-3.9.19c-2.29-.52-4.66-2-7.21-2.72S619 240 617 240.09s-1-.84-1-.84a21 21 0 0 1 8.49 1c4 1.49 5.67 2.51 7.67 2.46 3-.06 3.45-1.22 3.45-1.22Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1383"
        d="M614.69 239.05a5 5 0 0 0 1.66.07 3.3 3.3 0 0 0 1.35-.59s.13 1-.39 1.36a5.8 5.8 0 0 1-2.3.2c-.25 0-.32-1-.32-1Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1385"
        d="M629.71 248.5s2.67 2.61 1.95 4.88l-5.15-2.38-8.39-3.5-4.55-1.36-.56-.71a7.5 7.5 0 0 0 1.27-1.59 2.56 2.56 0 0 0 .29-1.52l5.56.75 5.81 1.78 3.77 3.64Z"
        className="Mexico_svg__cls-52"
      />
      <path
        id="Mexico_svg__path1387"
        d="M624 252.24s4.79 6.19 3.67 8.23l-11.18-7.06-3.94 6.48-9.2-4.53s7.42-5.71 8.29-6.78a4.2 4.2 0 0 0 .92-1.46l4.15.81 6.55 2.07.73 2.24Z"
        className="Mexico_svg__cls-52"
      />
      <path
        id="Mexico_svg__path1389"
        d="M621.41 243.1a36 36 0 0 1 6.43 2.24 18.8 18.8 0 0 0 6 1.59 6.17 6.17 0 0 1-4.15 1.57c-.81 0-2.77-1.56-4.05-2.46a24.5 24.5 0 0 0-5-2l.71-1Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1391"
        d="M614.5 241a27.3 27.3 0 0 1 4.54 1.36c1.72.78 1.85.58 2.3.39s.51-.39.51-.39.35 1.69-1 1.69-1.88-.46-3.61-1.24a3.06 3.06 0 0 0-2.87 0l.12-1.81Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1393"
        d="M630 251.86s2 1.25 1.62 1.51a6.46 6.46 0 0 1-3.13.85 6.8 6.8 0 0 1-3.81-.68c-1.23-.56-2-2.72-5-3.88a35 35 0 0 0-5.54-1.86 10.6 10.6 0 0 0-2.51-.48l1.88-.77 6.42 1.29 5.5 1.6 3.32 1.6 1.23.82Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1395"
        d="m619.24 255.64 1.27 5.06-.7 3-1.72 1.1-1.6-.64-.45-.91a2.16 2.16 0 0 0 0-2.2c-.7-1-3.95-2.33-3.95-2.33s1.27-2.47 2.74-3 .76-2.46.76-2.46l3.65 2.39Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1397"
        d="M613 245.34a6.06 6.06 0 0 0 3.11 1.08 24 24 0 0 1 4.25.93c.58.18 2-.6 2.1-.56l-1.22.72a50 50 0 0 1 5 1.72 11.4 11.4 0 0 1 3.84 2.64c-.07 0-1.27-.7-3.84-1.78a35 35 0 0 0-6-1.86c-3.83-.75-7.66-.51-8.47-.77s.34-.3.77-.74a2.37 2.37 0 0 0 .42-1.38Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1399"
        d="M627.28 259.21s1.22 1.29-.06 1.75-4.76.37-6.42-1.38a7.9 7.9 0 0 0-1.06-2.44 28.4 28.4 0 0 0-4.66-3.31c-1.47-.91.51-1 .51-1s5.24 2 7.16 3.05a32 32 0 0 1 4.53 3.37Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1401"
        d="M627.36 259.34s-2.58-3.57-9.75-6.39c-.2-.08 2.44-.46 2.23-.53s-3.45.06-3.78 0c-.54-.19-1.1-.37-1.68-.55-3.77-1.14-4-1-4.3-1.55s-.73.08-1.11.73-1.45 2.05-1.36 1.92a9.9 9.9 0 0 1 4.89-.23c2.13.51 2 1.29 1.88 2.11s-2.77 4-2.47 4.06 1.78-3 3.74-2.55a4 4 0 0 1 2.6 1.51 3.5 3.5 0 0 0-.42-1.6c-.39-.47-2.56-2.5-2-2.5a20.3 20.3 0 0 1 6.51 2.33c3.4 1.73 4 2.25 5 3.29Z"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1403"
        d="M615.66 253.72s5.49 1.56 5.23 7.39-4.51 4.75-4.89 2.63.51 1 2 .73c1.68-.3 2-2 1.92-4.23a5.66 5.66 0 0 0-1.88-4.49 25 25 0 0 0-2.42-2Z"
        className="Mexico_svg__cls-52"
      />
      <path
        id="Mexico_svg__path1405"
        d="M591.89 239.68s.58.44-1 4.56-2.41 5.57-4.78 8.19c-4.45 4.89-6.39 4.93-5.91 7s2.2 1.52 2.58 1.59 8.37-11.7 8.37-11.7l1.76-7.06-.42-2-.61-.6Z"
        style={{
          fill: "#6c3f18",
        }}
      />
      <path
        id="Mexico_svg__path1407"
        d="M611.7 231.26s2.3 3.45 1.57 10-9.27 12.2-9.27 12.2l-12.56 8.68-5.25-.31a4.6 4.6 0 0 1-1.57-.09c-.83-.21-1.6-1.07-1.78-1.07-.34 0-1-2.2-1-2.2l1.66-2 4.5-4.57 2.85-4.1a13.7 13.7 0 0 0 1.45-4.67 7 7 0 0 0-.43-3.45l1.07 1.64.59 3.45-.47 3.85 3.28-2.2 4.34-1.95s1.2-.17 2-2.59a30.8 30.8 0 0 0 1.58-7.56c0-1.59-.18-3.5-.18-3.5a1.1 1.1 0 0 1 .55.15 6.75 6.75 0 0 1 1.42 3.32c0 1.15.73 5.38.73 5.38l2-2a18 18 0 0 0 1.88-2.83 10.9 10.9 0 0 0 .94-3.53Z"
        className="Mexico_svg__cls-52"
      />
      <path
        id="Mexico_svg__path1411"
        d="M613.1 263.9s.86.71.54 3.08a4.2 4.2 0 0 1-3.22 3.69l.09-3.3-2.77-2.2-3-.91a7 7 0 0 0 .55-.52 28.5 28.5 0 0 1 3.42-1.62l4.37 1.78Z"
        className="Mexico_svg__cls-35"
      />
      <path
        id="Mexico_svg__path1413"
        d="M610.93 263.93a2.4 2.4 0 0 0 2.23.49 2.44 2.44 0 0 0 1.22-3.43c-.74-.88-.42 2.1-1.31 2.43s-1.85-2.24-3.07-2.5a4.15 4.15 0 0 0-3.6 1.39c-.48.81 2 .17 2 .17l1.3.35 1 .23.32.87Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1415"
        d="M592.78 254.87a8.9 8.9 0 0 0 3.4.26 40 40 0 0 0 6.11-2.06 19.5 19.5 0 0 0 3.47-2.54c1.46-1.43 6.11-4.33 6.62-10.11a23.7 23.7 0 0 0-.68-9.16s6.86 7.5.85 16.11c-3.92 5.62-7.32 7.26-7.32 7.26s6.64-1.94 7.24-.35-.32 4.09-.49 4.47c0 0 3.77.88 4.31 2.79.33 1.15-4.27-1.33-7.75-.49a9.18 9.18 0 0 0-5 2.92s-.64-1-3.73-1-4.51 1.42-6.26 1.35-7.28-1.24-8.35-2.75c0 0 1.32-1.65 3.66-4.31 1.59-3.07 3.94-2.36 3.94-2.36Z"
        className="Mexico_svg__cls-35"
      />
      <path
        id="Mexico_svg__path1417"
        d="M607.05 239.34a21 21 0 0 0 3.58-4.58 12.6 12.6 0 0 0 1.06-3.5 7 7 0 0 1-1.27 4.49 25.5 25.5 0 0 1-3.32 4l-.05-.43Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1419"
        d="M606.31 233.46s2.2 8.51-.14 12-12.54 8-12.54 8 7.73-4.19 10.15-9a19.74 19.74 0 0 0 2.26-8.84l.28-2.2Z"
        className="Mexico_svg__cls-35"
      />
      <path
        id="Mexico_svg__path1421"
        d="M596.18 255.12a13 13 0 0 0 5.11-1.16 38 38 0 0 0 4.47-3.44s-2.42 2.14-3.13 2.14-1.27-1.1-1-1.94a6.47 6.47 0 0 1-2 2.72 12.5 12.5 0 0 1-3.45 1.68"
        className="Mexico_svg__cls-48"
      />
      <path
        id="Mexico_svg__path1423"
        d="M603.78 244.5s2.74-2.85 2.68-8.81-2.3-4.86-2.3-4.86 1.85 1.36 1.47 5.89a26.3 26.3 0 0 1-1.85 7.78"
        className="Mexico_svg__cls-48"
      />
      <path
        id="Mexico_svg__path1425"
        d="M607.1 245.08s3.09-.74 4.18-2.56 1.06-5.28 1.06-5.28-.32 3.18-1.22 4.34a30.5 30.5 0 0 1-4.02 3.5"
        className="Mexico_svg__cls-48"
      />
      <path
        id="Mexico_svg__path1427"
        d="M605.31 263.74s1.53-3 3.58-2.2a2.78 2.78 0 0 1 2 2.4 3.16 3.16 0 0 0-2.36-1.36 6.33 6.33 0 0 0-3.26 1.16Z"
        className="Mexico_svg__cls-48"
      />
      <path
        id="Mexico_svg__path1429"
        d="M599.5 258.37s4.53-1.11 7.21-1.95 5.75-2.14 5.75-2.14a21.4 21.4 0 0 1-5.56 4.72 15 15 0 0 1-6.06 2s6.26-2.72 6.77-3.82c0 0-6 1.61-8.11 1.23Z"
        className="Mexico_svg__cls-48"
      />
      <path
        id="Mexico_svg__path10630"
        d="M592.24 251.37a5.16 5.16 0 0 1 .4 7.35 5.35 5.35 0 0 1-6.36 1.22"
        className="Mexico_svg__cls-1"
      />
      <path
        id="Mexico_svg__path11603"
        d="M592 252a4.55 4.55 0 0 1 .14 6.49 4.73 4.73 0 0 1-5.5 1"
        style={{
          fill: "#f16e16",
        }}
      />
      <path
        id="Mexico_svg__path10624"
        d="M590 254.47a1.84 1.84 0 1 1-1.79 2.78"
      />
      <path
        id="Mexico_svg__path1435"
        d="M590.2 256.8a.59.59 0 0 1-.68.49.6.6 0 0 1-.48-.69.58.58 0 0 1 .68-.48.59.59 0 0 1 .48.68"
        style={{
          fill: "#d5d3ca",
        }}
      />
      <path
        id="Mexico_svg__path1437"
        d="M593.39 248.14a14.4 14.4 0 0 0 3.71-6.91 19.1 19.1 0 0 0 .26-6.16l1.65 1.71.64 3-1.07 5a4.53 4.53 0 0 0 3.33-1.51c1.1-1.51 2.85-8.25 2.25-12.39 0 0 .9 1.81-.29 7.47s-2.17 6.33-6.43 8.66c-2.19 1.2-5 3.51-7.45 8.31a37 37 0 0 1-4.6 6 48 48 0 0 0 3.22-5.34 23.4 23.4 0 0 1 3.38-5.41l1.4-2.37Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1439"
        d="M592 250.52a27 27 0 0 0 1.32-6.13 11.9 11.9 0 0 0-1.4-4.71s1.91-.26 2.08 4.45-.85 5-2 6.39"
        className="Mexico_svg__cls-35"
      />
      <path
        id="Mexico_svg__path1441"
        d="M598.06 245.47a18.1 18.1 0 0 0 1.31-5.83 8.83 8.83 0 0 0-2-4.57s2.37.45 2.56 4.7-.56 4.28-1.87 5.7"
        className="Mexico_svg__cls-37"
      />
      <path
        id="Mexico_svg__path1443"
        d="M584.11 261.41a4.46 4.46 0 0 1-1-2.5c.13-1.1 0-1.35 2.76-4.21s4.21-4.59 4.88-6.12 2.88-5.68 1.12-8.9c0 0 1.21 4.69-1.5 8.42s-4.28 5.66-6.51 7.32-2.46 2.43-2.4 3.37.29 1.88.67 2.1a5.7 5.7 0 0 0 2 .52Z"
        className="Mexico_svg__cls-36"
      />
      <path
        id="Mexico_svg__path1445"
        d="M610.42 270.67a1.05 1.05 0 0 0 1-.65 2.85 2.85 0 0 0-.57-3.11 6.55 6.55 0 0 0-3.39-2.3 29 29 0 0 0-3.92-.64 7.6 7.6 0 0 0 2.61 2.49c.85.48 2.3-.13 3.23.78s1 3.43 1 3.43Z"
        className="Mexico_svg__cls-58"
      />
      <path
        id="Mexico_svg__path1447"
        d="M610.42 270.67s3-1 3.23-3.88a4.53 4.53 0 0 0-.26-2.44 2.77 2.77 0 0 0 1.66 1.3l1.09-.42s-1.79 5.64-5.72 5.44"
        className="Mexico_svg__cls-58"
      />
      <path
        id="Mexico_svg__path1449"
        d="M589.38 270.1a5.9 5.9 0 0 1 1.71 1.54 15.4 15.4 0 0 0 1.64 1.72l7.32-1.88 2.36-2.33-2-3.14h-5.24l-5.81 4.09Z"
        style={{
          fill: "#bf802d",
        }}
      />
      <path
        id="Mexico_svg__path1451"
        d="m607.1 267.63-1.41-1.9a2.93 2.93 0 0 0-1.36-1.3c-1.07-.56-5.49-.52-5.49-.52l-3.2.65a2.9 2.9 0 0 1-2.51.48 47 47 0 0 1-5.19-1.82l-3.58-1.55s-2.68-1.12-3.28-.91a19.6 19.6 0 0 0-2.81 2.64s-.38 1.29.47 1.33-1.28.44-1.28.44-5.56 3-6.45 8.49 9.13 13.47 12.84 9.39c0 0-5.43-4-4.35-7.39s3.58-5.44 7.86-5.7 4.53-.78 6.39-2.07a6 6 0 0 1 7.85.58c2.55 2.66-9.71 5.19-9.71 5.19l1.34 1.94s15.14-5.19 13.87-8Z"
        className="Mexico_svg__cls-60"
      />
      <path
        id="Mexico_svg__path1453"
        d="m607.1 267.63.28-.22-1.4-1.9-.29.22.33-.14a3.28 3.28 0 0 0-1.52-1.48 4.2 4.2 0 0 0-1.2-.32 33 33 0 0 0-4.24-.24h-.26l-3.32.68-.07.07a2.5 2.5 0 0 1-1.5.46 3.2 3.2 0 0 1-.71-.08 27 27 0 0 1-3.15-1c-1.09-.41-2-.77-2-.77l-.13.33.14-.33-3.58-1.55s-.57-.24-1.24-.48a7.3 7.3 0 0 0-2-.49 1 1 0 0 0-.33.05 3.2 3.2 0 0 0-.8.57c-.9.8-2.14 2.16-2.15 2.16l-.06.06v.08a3 3 0 0 0-.1.71 1.26 1.26 0 0 0 .16.68.88.88 0 0 0 .74.42h.08v-.2l-.09.17v-.2l-.09.17.15-.28-.25.2.1.08.15-.28-.25.2.27-.22h-.35l.08.22.27-.22-.27-.2a.3.3 0 0 0-.07.2h.34l-.27-.2.22.16-.14-.24-.08.08.22.16-.14-.24a2 2 0 0 1-.28.08 2.8 2.8 0 0 1-.69.16.8.8 0 0 0-.42.08h-.05a15.4 15.4 0 0 0-3 2.26 11.85 11.85 0 0 0-3.67 6.49 5 5 0 0 0-.06.76c0 2.33 1.58 4.83 3.64 6.79s4.67 3.37 6.93 3.38a3.87 3.87 0 0 0 3-1.23l.27-.3-.33-.25-.18-.14a17.7 17.7 0 0 1-2.42-2.32 6.33 6.33 0 0 1-1.74-3.7 2.5 2.5 0 0 1 .13-.81 7.57 7.57 0 0 1 2.6-3.84 9 9 0 0 1 4.94-1.62 14 14 0 0 0 4.21-.67 11.3 11.3 0 0 0 2.35-1.46 6.4 6.4 0 0 1 3.57-1.13 5.17 5.17 0 0 1 3.83 1.66.72.72 0 0 1 .25.5.92.92 0 0 1-.33.61 7.1 7.1 0 0 1-2.2 1.31 35 35 0 0 1-4.72 1.56c-.72.19-1.35.34-1.8.44l-.72.16-.54.11 1.95 2.64.26-.09s3.49-1.19 7-2.75a37.5 37.5 0 0 0 4.84-2.51 9.5 9.5 0 0 0 1.65-1.31 2.17 2.17 0 0 0 .7-1.39 1.3 1.3 0 0 0-.11-.51l-.29.22-.33.15.05.2a1.53 1.53 0 0 1-.5.89 12.9 12.9 0 0 1-3.17 2.1 63 63 0 0 1-6.57 2.95c-1 .4-1.89.72-2.51.95s-1 .35-1 .35l.12.35.29-.21-1.34-1.94-.29.21.07.35s2.53-.52 5.06-1.34a21 21 0 0 0 3.53-1.44 6 6 0 0 0 1.22-.89 1.67 1.67 0 0 0 .53-1.12 1.42 1.42 0 0 0-.45-1 5.85 5.85 0 0 0-4.34-1.88 7.15 7.15 0 0 0-4 1.25 10.8 10.8 0 0 1-2.2 1.39 13.7 13.7 0 0 1-4 .62 9.63 9.63 0 0 0-5.32 1.75 8.3 8.3 0 0 0-2.86 4.2 3.5 3.5 0 0 0-.16 1.05c0 1.74 1.2 3.39 2.34 4.64a17.5 17.5 0 0 0 2.3 2.1l.21-.29-.27-.24a3.11 3.11 0 0 1-2.42 1c-1.95 0-4.46-1.31-6.44-3.18s-3.42-4.27-3.41-6.26a4.5 4.5 0 0 1 .05-.64 11.22 11.22 0 0 1 3.45-6.09 17 17 0 0 1 2-1.6l.62-.41.17-.1h.06l-.17-.32.07.35s.37-.06.75-.15c.18 0 .37-.08.53-.13l.21-.08.12-.07.08-.08a.35.35 0 0 0 .08-.23l-.07-.22a.4.4 0 0 0-.17-.13.9.9 0 0 0-.3-.06c-.14 0-.12 0-.16-.07a.65.65 0 0 1-.06-.3 2 2 0 0 1 0-.35v-.11l-.34-.1.26.24s.55-.6 1.17-1.22c.31-.31.64-.63.92-.88a3.4 3.4 0 0 1 .58-.44h.08a7 7 0 0 1 1.74.44l.85.32.35.14 3.58 1.56a47 47 0 0 0 5.25 1.83 3.8 3.8 0 0 0 .85.09 3 3 0 0 0 2-.65l-.24-.27.07.36 3.2-.65-.08-.35v.36h.21c.45 0 1.54 0 2.62.07.53 0 1.07.09 1.52.16a3.1 3.1 0 0 1 1 .25 3 3 0 0 1 1 .76 3 3 0 0 1 .19.27v.07h.07-.07.07-.07v.05l1.43 1.94.29-.22-.33.15.33-.15Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1455"
        d="M578.8 280.53s-6.13-1.5-5.62-7.13 5.62-7.71 6.52-8 .7-3.11 1.72-3.43a4.7 4.7 0 0 1 3.88.84 12 12 0 0 0 2.8 1.64s-10.86 4.83-11 11.06c-.07 4.14 1.65 5 1.65 5Z"
        style={{
          fill: "#fcf3d8",
        }}
      />
      <path
        id="Mexico_svg__path1457"
        d="M607.07 267s-.74.45-1 .08c-1.14-2.14-3.83-2.71-6-2.67-2.77 0-4.64 1.07-6.52 1.07s-1.36-.3-3.57-.39-6.94-3.58-8-3.24a2.24 2.24 0 0 0-1.36 2.31c.13.65-1.92.69-2.22.21s1.63-3.53 3.55-3.53c5.15 0 9 3.47 11.44 3.47s3.32-1.42 6.64-1.42 6.91 1.47 7 4.11Z"
        style={{
          fill: "#fdeaaf",
        }}
      />
      <path
        id="Mexico_svg__path1459"
        d="M590.2 271a24 24 0 0 0 4.31-1.29 36 36 0 0 1 4.33-1.46 42 42 0 0 1-3.83 2.25 19 19 0 0 1-4.1 1.15z"
        style={{
          fill: "#513625",
        }}
      />
      <path
        id="Mexico_svg__path1461"
        d="M581.53 283.76c-.45.18-2.6.09-6-2.2a11.23 11.23 0 0 1-4.32-6.18s-.78-3.71 2.77-7.49 4.14-2.69 4.33-2.52-.18.34-.18.34l-3.13 2.55-1.55 2.61-1.45 2.35.11 2.78 1.58 2.8 4.91 3.06 2.89 1.9Z"
        className="Mexico_svg__cls-60"
      />
      <path
        id="Mexico_svg__path1463"
        d="m579.65 262.44-.2-.47v.51a.6.6 0 0 0 .2 0l-.2-.47-.36.37a.55.55 0 0 0 .36.15V262l-.36.37.36-.37h-.51a.54.54 0 0 0 .15.37l.36-.37-.46-.21a.44.44 0 0 0 0 .21h.5l-.46-.21.4.18-.35-.26v.08l.4.18-.35-.26.09.07-.09-.07.09.07-.09-.07s-.14.15-.27.31a10 10 0 0 0-.73.95 2.4 2.4 0 0 0-.46 1.23v.18a1.39 1.39 0 0 0 .77 1.06 2.4 2.4 0 0 0 1.13.23 5.8 5.8 0 0 0 1.6-.25.52.52 0 0 0-.3-1 5.8 5.8 0 0 1-1.28.19 1.5 1.5 0 0 1-.67-.12.35.35 0 0 1-.22-.29 1.3 1.3 0 0 1 .16-.43 6 6 0 0 1 .66-.93c.11-.14.22-.26.3-.35l.1-.12.05-.06v-.13a.6.6 0 0 0 0-.19.5.5 0 0 0-.15-.37.5.5 0 0 0-.36-.15.6.6 0 0 0-.2 0 .52.52 0 0 0-.27.68.51.51 0 0 0 .67.28Z"
        style={{
          fill: "#8b5122",
        }}
      />
      <path
        id="Mexico_svg__path1465"
        d="M590.06 267.7s-7.33 2.05-7.52 2.19c-.54.38 2.35-.07 4.62-.14a8.5 8.5 0 0 1 2.63.34 6.3 6.3 0 0 0 1.78-.37c2.81-1.1 8.72-3.3 9.27-.71.46 2.16-8.17 4.06-8.17 4.06l-.07.85 6.93-1.73 3.58-1.87 1.15-1.85-3.45-2.47h-5l-2.33.65-3.37 1Z"
        className="Mexico_svg__cls-60"
      />
      <path
        id="Mexico_svg__path1467"
        d="M579.34 278.3c.54 1.52 1.77 3.74 3.15 4.45 0 0 .23 0 .15.17s-1.11.78-3.45.17-5.92-1.55-8.09-8.12l.07 1.45 1.27 2.57 2.3 2.38 3.6 2.26 2.47.61 2.09-.54.93-.71-2.15-1.99-2.68-4.45a3.94 3.94 0 0 0 .3 1.75Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__polygon1469"
        d="m603.78 343.49-.12 2.37-1.31-.13.23-2.97z"
        className="Mexico_svg__cls-13"
      />
      <path
        id="Mexico_svg__polygon1471"
        d="m594.58 275.7-2.43-2.73-1.57.24 2.4 3.41z"
        className="Mexico_svg__cls-13"
      />
      <path
        id="Mexico_svg__path1473"
        d="M603.65 349.05a30 30 0 0 0-3.36-1.83 20.7 20.7 0 0 0-4.67-1.3l-.09.61.44.08a19 19 0 0 1 4.06 1.17c.93.43 1.75.88 2.34 1.22l.7.42.24.15z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1475"
        d="M603.44 343s-1.34-.09-2.77-.09a12.8 12.8 0 0 0-2.71.21 7.7 7.7 0 0 0-2.73 1.25l.37.49a7.5 7.5 0 0 1 2.47-1.11 12.3 12.3 0 0 1 2.56-.19h2.73v-.62Z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1477"
        d="M602.73 337.76a54 54 0 0 0-5 2.63c-1.55 1-3.18 2.37-3.18 2.37l.38.48s.4-.33 1-.78 1.38-1 2.13-1.55 2-1.15 3-1.67 1.87-.92 1.87-.92l-.26-.56Z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1479"
        d="M599.49 332.4a5 5 0 0 1-.63 2.32 17 17 0 0 1-1.24 1.51c-.92 1-2.15 2.36-3.15 3.43l-1.77 1.86.44.44s1.37-1.44 2.84-3c.72-.78 1.48-1.61 2.1-2.3a15.5 15.5 0 0 0 1.29-1.59 5.4 5.4 0 0 0 .73-2.66h-.61Z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1481"
        d="M595.24 330v.12a7.5 7.5 0 0 1 .14 1.53 8.2 8.2 0 0 1-.46 2.75 40 40 0 0 1-1.92 4.26 149 149 0 0 1-1.3 2.48l.53.31a63 63 0 0 0 3.27-6.84 9 9 0 0 0 .49-3 7.4 7.4 0 0 0-.19-1.8l-.59.15Z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1483"
        d="M591.13 329.5v.65c0 .41.05 1 .05 1.59a11.1 11.1 0 0 1-.43 3.45c-.37 1-.87 2.42-1.29 3.52l-.73 2 .58.22s1.27-3.39 2-5.49a12.3 12.3 0 0 0 .47-3.66c0-1.28-.11-2.3-.11-2.31Z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1485"
        d="M588 329.48s0 1-.07 2.34a25 25 0 0 1-.41 3.81c-.48 2-1 4.95-1 4.95l.6.11s.12-.74.3-1.71.43-2.21.66-3.21a39.5 39.5 0 0 0 .5-6.28Z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1487"
        d="M584.55 330s0 .39.08 1 .09 1.38.09 2.18a10.6 10.6 0 0 1-.23 2.48 42 42 0 0 0-.8 4.88l.62.06s.07-.73.2-1.71a29 29 0 0 1 .58-3.07 11.3 11.3 0 0 0 .24-2.64c0-1.65-.17-3.22-.17-3.22l-.61.06Z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1489"
        d="M581.86 330.4v.35a16.8 16.8 0 0 1-.57 4.33c-.34 1.22-.74 2.65-1.06 3.78l-.56 2 .59.17s.94-3.3 1.62-5.75a17.5 17.5 0 0 0 .59-4.49v-.37h-.62Z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1491"
        d="M578.86 330.43v1.36a8.8 8.8 0 0 1-.86 4.11 11.2 11.2 0 0 1-2.72 2.94c-.49.39-.94.71-1.27.93l-.39.25-.14.09.31.53s3.39-2 4.74-4.44a9.54 9.54 0 0 0 .95-4.41 12 12 0 0 0-.08-1.42l-.61.08Z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1493"
        d="m577 329.85-.14.41A13 13 0 0 1 575 334a12.8 12.8 0 0 1-2.52 2.2c-.43.3-.83.55-1.11.73l-.46.28.3.54a18.2 18.2 0 0 0 4.26-3.35 14.1 14.1 0 0 0 2.13-4.4l-.58-.18Z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1495"
        d="m574.1 328.38-.17.33c-.17.32-.43.81-.74 1.28a5.6 5.6 0 0 1-.93 1.18 15 15 0 0 1-1.87 1.25c-.68.41-1.24.71-1.25.72l.29.55s.58-.32 1.27-.73a15 15 0 0 0 2-1.32 7.6 7.6 0 0 0 1.34-1.8c.38-.64.65-1.19.65-1.19l-.55-.27Z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1497"
        d="m572.68 326.54-.48.56c-.45.51-1.15 1.28-1.85 1.95a12 12 0 0 1-1 .87 3 3 0 0 1-.75.46l.17.59a4.1 4.1 0 0 0 1.29-.82 31 31 0 0 0 3.08-3.21z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1499"
        d="m572 325.32-.44.35a20 20 0 0 1-1.71 1.18 4.1 4.1 0 0 1-1.65.68v.62a3.1 3.1 0 0 0 1.28-.39 20 20 0 0 0 2.91-2l-.39-.48Z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1501"
        d="M571.43 324s-.68.4-1.46.8c-.39.2-.81.41-1.18.57a4.4 4.4 0 0 1-.84.28l.06.61a3.9 3.9 0 0 0 1-.32c1.17-.5 2.7-1.4 2.71-1.4l-.31-.54Z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1503"
        d="m570.79 321.26-.07.07a6.6 6.6 0 0 1-1.05.92 3.2 3.2 0 0 1-1.71.67v.62a4.1 4.1 0 0 0 2.28-.94 6.8 6.8 0 0 0 1-.93z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1505"
        d="M571 317a15 15 0 0 0-1.16 1 6.2 6.2 0 0 0-1.51 1.9 1.4 1.4 0 0 1-.18.25l-.13.11v.62a.87.87 0 0 0 .61-.32 1.6 1.6 0 0 0 .31-.45 5.6 5.6 0 0 1 1.36-1.67c.29-.28.57-.53.78-.71s.34-.27.34-.27z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1507"
        d="M592.05 291.81h3.12l.08-.07.06-.19-.06-.18-.11-.09h-.09v.62-.24.24-.24.24-.29l-.06.29v-.29l-.06.29.06-.31-.11.29h.05l.06-.31-.11.29.11-.29-.18.25h.07l.11-.29-.18.25-.07-.07.25-.18h-.3v.18l.25-.18h-.3l.06-.18.12-.1.12.28v-.31h-.09l.12.28v-.31.21-.21.21-.21h-2.92z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1509"
        d="M592.14 290h.2a3 3 0 0 0 1.31-.42 23 23 0 0 0 2-1.28 8 8 0 0 1 .85-.53 1.5 1.5 0 0 1 .6-.2v-.62a2.5 2.5 0 0 0-1.17.43c-.61.36-1.28.87-1.91 1.28a3.6 3.6 0 0 1-1.65.71h-.11Z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1511"
        d="M591.89 287a4.6 4.6 0 0 0 1.45-.58c.76-.43 1.6-1 2.36-1.5a4.5 4.5 0 0 1 1.84-.83v-.63a3.3 3.3 0 0 0-1.39.48c-.74.4-1.57 1-2.34 1.48a5.9 5.9 0 0 1-2 1l.08.62Z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1513"
        d="M590.78 284.27a29 29 0 0 0 3-2.15c1.16-.9 2.35-1.83 3.15-2.32l-.31-.53c-.86.52-2 1.46-3.21 2.35a28 28 0 0 1-2.92 2.09l.28.56Z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1515"
        d="M588.72 281.13c1.47-1 5.06-3.6 6.41-4.46l-.33-.52c-1.38.87-5 3.44-6.43 4.48z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1517"
        d="M586 278.12a37 37 0 0 1 3.6-2.55c1.27-.81 2.42-1.52 3-1.95l-.36-.5c-.53.4-1.7 1.11-3 1.92a36 36 0 0 0-3.67 2.61l.4.47Z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1519"
        d="M583.82 276.26s1.44-1.06 3-2.17c.79-.56 1.61-1.13 2.29-1.59a14 14 0 0 1 1.45-.91l-.25-.56a15 15 0 0 0-1.54 1c-2.07 1.39-5.33 3.77-5.33 3.77Z"
        className="Mexico_svg__cls-12"
      />
      <path
        id="Mexico_svg__path1521"
        d="m588.75 270.18.37.29a34.5 34.5 0 0 1 4.84 4.88c1.89 2.37 3.55 5.29 3.54 8.14a5.6 5.6 0 0 1 0 .82c-.42 3.72-2.28 7-4.87 10-3.87 4.53-9.36 8.48-13.9 12.49a35.4 35.4 0 0 0-5.83 6.2 12 12 0 0 0-2.39 6.83v.33a12.5 12.5 0 0 0 2.2 6.68 8.63 8.63 0 0 0 6.25 3.77c.45 0 .92.06 1.38.06 3.55 0 7.4-1.13 11.08-1.13a11 11 0 0 1 8.66 3.63c2.49 2.73 3.26 7.12 3.26 11.35a48.7 48.7 0 0 1-.77 8.15c-.2 1.09-.39 2-.53 2.61s-.24 1-.24 1l.58.17a50.7 50.7 0 0 0 1.57-11.9c0-4.3-.75-8.83-3.43-11.77a11.53 11.53 0 0 0-9.1-3.83c-3.79 0-7.66 1.13-11.08 1.13q-.68 0-1.32-.06a8 8 0 0 1-5.81-3.51 11.94 11.94 0 0 1-2.09-6.34v-.31c0-3 1.52-5.81 3.89-8.51 3.55-4.06 9-7.89 13.66-12.13s8.72-8.94 9.39-14.77a9 9 0 0 0 .05-.89c0-3.54-2.28-7-4.51-9.54a34.4 34.4 0 0 0-4.49-4.27l-.36.5Z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path1523"
        d="m589.06 269.39.67.68s-.63-.16-.89-.19.22-.49.22-.49"
        className="Mexico_svg__cls-60"
      />
      <path
        id="Mexico_svg__path1525"
        d="m589.72 270.08-1.27.18c-.34 0 .38-.38.38-.38Z"
        className="Mexico_svg__cls-39"
      />
      <path
        id="Mexico_svg__path1527"
        d="M601.48 356.19a1.83 1.83 0 0 0 1.16-.58c.35-.48-.23.77-.23.77l-.52.2z"
        className="Mexico_svg__cls-10"
      />
      <path
        id="Mexico_svg__polygon1529"
        d="m584.11 276.2-.74-.63-.63.23 1.19.97z"
        className="Mexico_svg__cls-4"
      />
      <path
        id="Mexico_svg__polygon1531"
        d="m586.08 278.07-.55-.57-.29.16.46.6z"
        className="Mexico_svg__cls-4"
      />
      <path
        id="Mexico_svg__polygon1533"
        d="m588.84 281.11-.47-.6-.29.37.48.56z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__polygon1535"
        d="m590.9 284.2-.34-.61-.55.1.72.77z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__polygon1537"
        d="m592.07 287.11-.27-.85-.08.15-.05.64z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__polygon1539"
        d="m592.22 290.04.03-.8-.37-.23.05 1.1z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__polygon1541"
        d="m592.09 291.91.08-.91-.24-.16.02 1.19z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path1543"
        d="M568.19 321a7 7 0 0 1 .27-1.4c.21-.65-.59.31-.59.31l-.1.89z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__path1545"
        d="m568 322.82-.35.16.12.87.2-.27v-.76Z"
        className="Mexico_svg__cls-1"
      />
      <path
        id="Mexico_svg__polygon1547"
        d="m568.06 326.28-.05-.85-.26-.1v1.39z"
        className="Mexico_svg__cls-6"
      />
      <path
        id="Mexico_svg__polygon1549"
        d="m568.28 328.21-.08-.77-.27.04-.02.73z"
        className="Mexico_svg__cls-1"
      />
      <path
        id="Mexico_svg__polygon1551"
        d="m568.81 331-.16-.75-.18.18.15.75z"
        className="Mexico_svg__cls-1"
      />
      <path
        id="Mexico_svg__polygon1553"
        d="m569.54 333.87-.3-1.01-.22.1.3.97z"
        className="Mexico_svg__cls-1"
      />
      <path
        id="Mexico_svg__polygon1555"
        d="m571.39 337.7-.41-.63-.39-.06.5.76z"
        className="Mexico_svg__cls-4"
      />
      <path
        id="Mexico_svg__path1557"
        d="M574.24 340.5a7.4 7.4 0 0 1-1-.68c-.55-.45-.22.43-.22.43l.8.42Z"
        className="Mexico_svg__cls-4"
      />
      <path
        id="Mexico_svg__path1559"
        d="M593.46 342a6.4 6.4 0 0 0-.76-.46s.17 0 .44.67.32-.21.32-.21"
        className="Mexico_svg__cls-4"
      />
      <path
        id="Mexico_svg__path1561"
        d="M595.12 343.28a3.5 3.5 0 0 0-.61-.63c-.24-.16-.15.48-.15.48l.49.21z"
        className="Mexico_svg__cls-1"
      />
      <path
        id="Mexico_svg__path1563"
        d="M595.44 344.05c-.2-.28-.42.4-.42.4l.59.55a1.9 1.9 0 0 0-.17-.95"
        className="Mexico_svg__cls-4"
      />
      <path
        id="Mexico_svg__path1565"
        d="M595.54 346.7a4 4 0 0 0 .1-.93c0-.35-.32.13-.32.13v.8Z"
        className="Mexico_svg__cls-4"
      />
      <path
        id="Mexico_svg__polygon1567"
        d="m594.61 349.5.22-.7-.29.01-.17.72z"
        className="Mexico_svg__cls-1"
      />
      <path
        id="Mexico_svg__path1569"
        d="M565.33 247s1.1-.22.27 1 .56-1.11.56-1.11l-.45-.13-.38.22Z"
        className="Mexico_svg__cls-1"
      />
      <path
        id="Mexico_svg__path7832"
        d="M721.29 399.36c-3.65 3.19-5.4 7.33-3.9 9.25s5.69.89 9.34-2.3 5.4-7.33 3.9-9.25-5.63-.89-9.34 2.3"
        style={{
          fill: "url(#Mexico_svg__radial-gradient-3)",
        }}
      />
    </g>
  </svg>
);
export default SvgMexico;
